var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _g, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _g2, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _g3, _g4, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _g5, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _g6, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _g7, _g8, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _g9, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _g10, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _g11, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _g12, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _g13, _g14, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTfib(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 300,
    viewBox: "0 0 333 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_182)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 333,
    height: 300,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.637 -17.5999H-42.8218V199.41H380.637V-17.5999Z",
    fill: "#BAE5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.8543 199.411H380.604L424 341.963H-77L-42.8543 199.411Z",
    fill: "#7D9732"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.021 199.443C320.021 158.983 303.948 120.179 275.338 91.569C246.728 62.959 207.925 46.887 167.464 46.887C127.004 46.887 88.2 62.959 59.591 91.569C30.981 120.179 14.9077 158.983 14.9077 199.443H167.464H320.021Z",
    fill: "#EDBC3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.067 19.7946C102.067 3.61345 94.664 -11.905 81.488 -23.3468C68.311 -34.7886 50.44 -41.2166 31.806 -41.2166C13.1715 -41.2166 -4.69958 -34.7886 -17.8761 -23.3468C-31.0526 -11.905 -38.4551 3.61345 -38.4551 19.7946H31.806H102.067Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-17.9254 58.2168C7.56301 58.2168 28.2254 40.2746 28.2254 18.1418C28.2254 -3.99104 7.56301 -21.9332 -17.9254 -21.9332C-43.4138 -21.9332 -64.0762 -3.99104 -64.0762 18.1418C-64.0762 40.2746 -43.4138 58.2168 -17.9254 58.2168Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7289 48.2735C93.2173 48.2735 113.88 30.3313 113.88 8.19854C113.88 -13.9343 93.2173 -31.8765 67.7289 -31.8765C42.2405 -31.8765 21.5781 -13.9343 21.5781 8.19854C21.5781 30.3313 42.2405 48.2735 67.7289 48.2735Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3759 57.6657C99.8643 57.6657 120.527 39.7236 120.527 17.5907C120.527 -4.54207 99.8643 -22.4843 74.3759 -22.4843C48.8875 -22.4843 28.2251 -4.54207 28.2251 17.5907C28.2251 39.7236 48.8875 57.6657 74.3759 57.6657Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2408 68.1602C60.0532 68.1602 85.8424 45.7662 85.8424 18.1418C85.8424 -9.48259 60.0532 -31.8766 28.2408 -31.8766C-3.57173 -31.8766 -29.3608 -9.48259 -29.3608 18.1418C-29.3608 45.7662 -3.57173 68.1602 28.2408 68.1602Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.425 18.2647C325.738 18.2647 343.015 2.14557 343.015 -17.7383C343.015 -37.6222 325.738 -53.7413 304.425 -53.7413C283.112 -53.7413 265.835 -37.6222 265.835 -17.7383C265.835 2.14557 283.112 18.2647 304.425 18.2647Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M343.027 27.1977C369.628 27.1977 391.192 7.07915 391.192 -17.7383C391.192 -42.5558 369.628 -62.6743 343.027 -62.6743C316.426 -62.6743 294.862 -42.5558 294.862 -17.7383C294.862 7.07915 316.426 27.1977 343.027 27.1977Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_57_182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 195,
    width: 43,
    height: 83
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.7 227.437C108.303 219.551 99.4229 208.56 103.73 205.439",
    stroke: "#ED9191",
    strokeWidth: 1.17695
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.965 205.395C108.315 203.026 109.781 201.377 107.991 201.112C106.201 200.848 103.156 199.47 102.806 201.838C102.455 204.207 104.932 209.425 106.722 209.69C108.512 209.955 107.614 207.763 107.965 205.395Z",
    fill: "#443A26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.356 205.978C108.767 204.612 106.946 204.342 105.988 205.48L104.554 207.182C103.544 208.38 104.241 210.221 105.791 210.45L108.105 210.793C109.655 211.022 110.855 209.462 110.235 208.022L109.356 205.978Z",
    fill: "#443A26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.792 210.854C108.333 208.317 110.631 210.114 112.058 209.54C113.485 208.966 113.347 207.784 113.91 208.795C114.345 211.075 113.116 211.303 111.689 211.877C110.081 212.096 110.521 211.386 108.792 210.854Z",
    fill: "#443A26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.092 210.307C106.266 208.011 103.546 209.066 102.347 208.104C101.147 207.141 101.621 206.049 100.789 206.854C99.7127 208.911 100.824 209.485 102.024 210.447C103.499 211.123 103.284 210.316 105.092 210.307Z",
    fill: "#443A26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.685 204.527L95.1641 202.971C93.6545 202.748 92.6117 201.343 92.835 199.833C93.0583 198.324 94.4631 197.281 95.9728 197.504L106.494 199.06C108.004 199.284 109.046 200.689 108.823 202.198C108.6 203.708 107.195 204.751 105.685 204.527Z",
    fill: "#443A26"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.074 204.933C105.432 205.393 105.23 207.832 103.938 208.363C103.225 209.076 105.231 207.58 106.873 207.121C108.515 206.661 106.175 206.947 106.505 206.209C107.074 204.933 107.679 205.834 107.074 204.933Z",
    fill: "#B8873E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.474 205.165C109.913 206.081 109.4 208.474 110.483 209.357C110.959 210.246 109.472 208.233 108.034 207.318C106.595 206.402 108.751 207.354 108.65 206.551C108.474 205.165 107.635 205.853 108.474 205.165Z",
    fill: "#B8873E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.305 206.159C108.313 205.876 108.069 205.671 107.789 205.632L107.695 205.618L107.588 205.603C107.315 205.565 107.029 205.686 106.956 205.953C106.909 206.124 106.899 206.314 107.013 206.445C107.273 206.745 107.79 206.837 108.124 206.602C108.257 206.509 108.299 206.332 108.305 206.159Z",
    fill: "#635843"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.292 208.663C106.312 208.527 106.202 208.39 106.035 208.366C105.868 208.341 105.722 208.439 105.702 208.576C105.682 208.712 105.793 208.848 105.96 208.873C106.127 208.898 106.272 208.8 106.292 208.663Z",
    fill: "#5C4B27",
    stroke: "#CFCFCF",
    strokeWidth: 0.0588476
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.669 209.015C108.689 208.878 108.578 208.742 108.411 208.717C108.244 208.693 108.099 208.791 108.079 208.927C108.059 209.064 108.169 209.2 108.336 209.225C108.503 209.249 108.649 209.151 108.669 209.015Z",
    fill: "#5C4B27",
    stroke: "#CFCFCF",
    strokeWidth: 0.0588476
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.601 208.868C106.487 208.659 106.412 208.942 106.178 209.034C105.944 209.125 105.642 208.99 105.755 209.199C105.868 209.408 106.15 209.503 106.383 209.412C106.617 209.32 106.714 209.077 106.601 208.868Z",
    fill: "#B8873E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.85 209.053C108.019 208.886 108.01 209.179 108.207 209.334C108.404 209.489 108.733 209.448 108.564 209.615C108.395 209.782 108.098 209.791 107.901 209.636C107.704 209.481 107.681 209.22 107.85 209.053Z",
    fill: "#B8873E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M107.142 204.984C107.933 204.86 108.438 205.176 108.438 205.176",
    stroke: "#635843",
    strokeWidth: 0.117695
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1759 201.481C95.4019 200.511 96.8609 199.147 96.4349 198.435C96.0079 197.722 95.0159 199.866 92.7889 200.836C90.5629 201.806 87.9449 201.235 88.3719 201.948C88.7979 202.66 90.9489 202.451 93.1759 201.481Z",
    fill: "#443A26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105.335 201.273C105.682 198.93 108.206 197.363 106.921 197.173C105.635 196.983 104.552 198.763 104.206 201.106C103.859 203.448 102.963 202.787 104.248 202.977C105.533 203.167 104.989 203.615 105.335 201.273Z",
    fill: "#443A26"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.388 201.576C107.734 199.234 110.258 197.667 108.973 197.476C107.688 197.286 106.605 199.067 106.258 201.409C105.912 203.752 103.052 203.015 104.337 203.205C105.622 203.395 107.041 203.919 107.388 201.576Z",
    fill: "#443A26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7496 199.695C95.0966 197.352 97.6206 195.785 96.3356 195.595C95.0496 195.405 93.9666 197.185 93.6206 199.528C93.2736 201.871 93.5726 201.788 94.8576 201.978C96.1426 202.169 94.4036 202.038 94.7496 199.695Z",
    fill: "#443A26"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.803 199.999C97.149 197.656 99.673 196.089 98.388 195.899C97.103 195.709 96.02 197.489 95.673 199.831C95.327 202.174 95.24 201.686 96.525 201.876C97.81 202.066 96.456 202.341 96.803 199.999Z",
    fill: "#443A26"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7049 196.737C95.8279 196.166 96.9759 195.9 96.3609 195.777C95.7449 195.655 95.2609 196.041 95.1379 196.612C95.0149 197.184 95.6139 196.372 95.4109 197.098C96.0729 197.41 95.6309 197.082 95.7049 196.737Z",
    fill: "#B8873E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6737 197.098C97.7967 196.527 98.9447 196.261 98.3287 196.138C97.7137 196.016 97.2297 196.402 97.1067 196.973C96.9837 197.545 97.5827 196.733 97.3797 197.459C98.0407 197.771 97.5987 197.443 97.6737 197.098Z",
    fill: "#B8873E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.35 198.34C106.474 197.769 107.622 197.503 107.006 197.38C106.391 197.258 105.907 197.644 105.784 198.215C105.661 198.786 106.26 197.974 106.057 198.701C106.718 199.013 106.276 198.684 106.35 198.34Z",
    fill: "#B8873E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M108.33 198.686C108.453 198.115 109.601 197.849 108.986 197.727C108.37 197.604 107.886 197.991 107.763 198.562C107.64 199.133 108.239 198.321 108.036 199.048C108.698 199.359 108.256 199.031 108.33 198.686Z",
    fill: "#B8873E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M103.94 206.485C104.867 206.189 106.29 203.654 108.315 204.146",
    stroke: "#ED9191",
    strokeWidth: 1.17695
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.809 202.331C122.989 201.118 123.21 200.146 124.86 200.39C126.509 200.634 130.229 199.945 130.049 201.158C129.87 202.371 127.269 203.173 125.619 202.929C123.97 202.685 122.63 203.544 122.809 202.331Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.006 202.924C123.088 202.366 123.011 200.69 123.767 200.802C124.522 200.914 131.324 200.239 129.893 201.708C119.615 199.357 126.028 203.095 125.272 202.983C124.517 202.872 122.923 203.483 123.006 202.924Z",
    fill: "#8C799B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M120.546 202.338C120.715 201.124 120.776 200.129 119.126 199.895C117.475 199.661 114.101 197.946 113.931 199.16C113.762 200.374 116.031 201.881 117.682 202.115C119.333 202.349 120.376 203.553 120.546 202.338Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M120.19 202.852C120.268 202.293 120.814 200.707 120.057 200.6C119.301 200.493 112.966 197.917 113.925 199.732C124.447 200.391 117.243 202.158 117.999 202.266C118.755 202.373 120.112 203.411 120.19 202.852Z",
    fill: "#8C799B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M113.103 228.435L126.342 230.393C127.396 217.586 126.002 211.962 125.462 202.926L121.94 202.405C117.636 212.308 129.606 216.369 113.103 228.435Z",
    fill: "#ED9191"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M125.89 229.602L112.542 229.31C113.155 216.466 115.261 211.138 116.964 202.292L120.515 202.37C123.491 212.888 111.127 214.89 125.89 229.602Z",
    fill: "#ED9191"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M118.061 248.036C118.121 245.11 122.583 244.918 123.474 247.802L128.557 264.255C129.09 265.98 126.767 266.955 125.543 265.519C125.427 265.383 125.333 265.233 125.263 265.074L118.276 249.095C118.127 248.753 118.053 248.392 118.061 248.036Z",
    fill: "#F0BEA2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M111.514 244.568C110.312 248.311 112.416 252.502 116.305 253.078C120.045 253.631 123.28 250.464 123.749 246.712C124.544 240.344 127.021 235.506 127.444 228.853C123.759 228.707 122.913 220.141 112.159 226.592C113.342 234.016 113.311 238.971 111.514 244.568Z",
    fill: "#B49DC7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M119.679 250.385C120.296 246.215 121.744 248.071 117.272 247.41C112.799 246.748 114.249 245.32 113.632 249.491C113.016 253.661 111.303 256.863 115.776 257.525C120.248 258.186 119.063 254.556 119.679 250.385Z",
    fill: "#EFB99E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.345 254.77C116.668 254.274 115.79 254.144 114.999 254.423L114.671 254.539C112.176 255.42 112.527 259.054 115.145 259.441L115.752 259.531C118.37 259.918 119.758 256.542 117.625 254.976L117.345 254.77Z",
    fill: "#E4CFB0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M109.605 263.847C107.773 258.132 117.087 254.487 113.995 248.786C114.62 254.113 104.286 258.782 106.119 264.497C107.951 270.212 112.871 273.273 117.652 272.247C122.434 271.221 111.438 269.562 109.605 263.847Z",
    fill: "#443A26"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 262.956C122.109 258.017 114.249 251.831 118.859 247.27C116.718 252.188 125.258 259.648 121.849 264.588C118.441 269.528 112.845 271.034 108.566 268.667C104.287 266.301 115.291 267.896 118.7 262.956Z",
    fill: "#443A26"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 263.199C125.185 258.259 117.325 252.073 121.935 247.512C119.794 252.43 128.334 259.89 124.926 264.83C121.517 269.77 115.921 271.276 111.642 268.909C107.363 266.543 118.368 268.138 121.776 263.199Z",
    fill: "#443A26"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.372 263.204C123.781 258.264 115.921 252.079 120.531 247.517C118.39 252.435 126.93 259.895 123.521 264.835C120.113 269.775 114.517 271.281 110.238 268.914C105.958 266.548 116.963 268.144 120.372 263.204Z",
    fill: "#443A26"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M122.059 262.775C121.155 257.337 121.337 256.244 116.033 255.46C110.73 254.675 111.416 255.737 108.148 260.718C107.516 264.986 110.119 268.907 113.96 269.476C117.802 270.044 121.428 267.044 122.059 262.775Z",
    fill: "#F0BEA2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M113.571 247.337C113.584 249.973 109.527 250.183 108.739 247.588L104.937 235.071C104.622 234.032 105.906 233.345 106.802 234.074C106.935 234.182 107.044 234.314 107.121 234.461L113.31 246.311C113.48 246.636 113.569 246.988 113.571 247.337Z",
    fill: "#F0BEA2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M107.233 234.9C106.97 236.185 105.003 235.95 104.859 234.617L104.214 228.682C104.154 228.137 104.833 227.877 105.233 228.291C105.302 228.363 105.353 228.448 105.382 228.541L107.202 234.334C107.26 234.521 107.271 234.716 107.233 234.9Z",
    fill: "#F0BEA2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M106.962 227.222C106.221 226.757 105.652 227.991 105.237 227.73C104.689 228.423 105.13 229.216 105.446 229.904C106.188 230.369 105.262 229.067 105.81 228.375C106.358 227.683 107.703 227.687 106.962 227.222Z",
    fill: "#F0BEA2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M104.983 226.072C104.309 226.332 105.101 228.122 104.723 228.268C105.077 228.927 104.7 229.575 105.39 229.685C106.064 229.425 105.453 229.857 105.512 228.854C105.159 228.195 105.657 225.812 104.983 226.072Z",
    fill: "#F0BEA2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M104.524 226.244C103.896 226.555 104.859 228.243 104.507 228.417C104.922 229.033 104.625 229.7 105.307 229.75C105.935 229.44 105.649 228.9 105.234 228.283C104.82 227.667 105.151 225.934 104.524 226.244Z",
    fill: "#F0BEA2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M104.085 226.404C103.593 226.687 104.699 227.857 103.957 228.485C104.33 228.97 104.372 229.224 104.931 229.234C105.422 228.951 105.158 228.523 104.784 228.038C104.41 227.554 104.577 226.122 104.085 226.404Z",
    fill: "#F0BEA2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M103.878 226.835C103.611 227.082 104.045 228.37 104.122 228.768C104.442 229.036 104.339 228.979 104.698 228.914C104.965 228.666 104.832 228.366 104.404 228.153C104.084 227.886 104.146 226.588 103.878 226.835Z",
    fill: "#F0BEA2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M105.225 227.597C105.173 227.21 104.799 226.921 104.408 226.967C104.159 226.996 103.957 227.158 103.881 227.389L103.862 227.447C103.819 227.58 103.815 227.724 103.851 227.865L104.18 229.155C104.194 229.209 104.235 229.254 104.289 229.275C104.321 229.288 104.357 229.291 104.39 229.283L104.64 229.223C105.091 229.116 105.374 228.703 105.312 228.243L105.225 227.597Z",
    fill: "#F0BEA2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M125.555 264.615C126.284 262.97 128.819 263.739 128.649 265.553L127.949 273.011C127.882 273.727 126.954 273.931 126.531 273.324C126.455 273.215 126.407 273.09 126.39 272.961L125.436 265.449C125.4 265.161 125.441 264.874 125.555 264.615Z",
    fill: "#F0BEA2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M124.079 274.345C124.912 275.06 125.921 273.615 126.388 274.016C127.245 273.246 126.891 272.198 126.649 271.279C125.815 270.563 126.668 272.335 125.81 273.105C124.953 273.875 123.246 273.629 124.079 274.345Z",
    fill: "#EFB99E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M125.729 277.685C126.646 277.48 126.055 275.093 126.569 274.978C126.273 274.088 126.903 273.343 126.052 273.082C125.135 273.287 125.296 274.044 125.592 274.933C125.888 275.823 124.813 277.891 125.729 277.685Z",
    fill: "#EFB99E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M126.733 277.551C127.602 277.274 126.772 274.984 127.259 274.829C126.876 273.982 127.408 273.199 126.553 273.014C125.684 273.291 125.921 274.019 126.305 274.866C126.688 275.713 125.864 277.827 126.733 277.551Z",
    fill: "#EFB99E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M127.592 277.483C128.282 277.217 127.016 275.52 128.105 274.866C127.743 274.191 127.882 273.896 127.176 273.783C126.486 274.049 126.722 274.633 127.084 275.308C127.446 275.983 126.902 277.749 127.592 277.483Z",
    fill: "#EFB99E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M128.003 276.579C128.4 276.317 128.17 274.231 128.164 273.718C127.82 273.325 127.916 273.808 127.445 273.826C127.048 274.088 127.147 274.489 127.641 274.832C127.985 275.225 127.605 276.841 128.003 276.579Z",
    fill: "#EFB99E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M109.348 249.05C111.852 248.107 112.868 247.306 113.721 245.205",
    stroke: "#B49DC7",
    strokeWidth: 2.94238
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.373 274.163C126.348 274.669 126.758 275.109 127.267 275.121C127.589 275.129 127.882 274.962 128.032 274.684L128.066 274.622C128.153 274.46 128.192 274.275 128.179 274.089L128.061 272.422C128.056 272.35 128.014 272.284 127.951 272.248C127.912 272.226 127.869 272.217 127.826 272.221L127.499 272.25C126.898 272.304 126.439 272.782 126.41 273.385L126.373 274.163Z",
    fill: "#EFB99E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M109.098 261.472C109.207 260.729 109.688 259.101 108.956 258.993C108.224 258.885 106.557 260.337 106.447 261.08C106.337 261.823 106.841 262.513 107.573 262.622C108.305 262.73 108.988 262.215 109.098 261.472Z",
    fill: "#D6C2A2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M107.88 261.23C107.079 260.652 108.531 260.578 108.065 259.979",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M122.225 265.026C123.158 264.706 121.79 264.214 122.409 263.776",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M108.399 263.653C106.566 257.937 115.881 254.293 112.789 248.592C113.414 253.919 104.59 260.754 106.422 266.469C108.255 272.184 111.665 273.079 116.446 272.053C121.227 271.026 110.232 269.368 108.399 263.653Z",
    fill: "#443A26"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M108.66 263.798C106.827 258.082 120.144 245.973 111.039 246.336C111.664 251.664 105.294 259.5 107.127 265.215C108.959 270.931 111.926 273.224 116.707 272.198C121.488 271.171 110.492 269.513 108.66 263.798Z",
    fill: "#443A26"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M122.78 264.324C124.87 258.814 112.137 245.343 121.204 246.656C120.337 251.906 126.334 260.389 124.245 265.899C122.156 271.409 119.092 273.387 114.369 271.864C109.646 270.34 120.691 269.834 122.78 264.324Z",
    fill: "#443A26"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M117.345 254.77C116.668 254.274 115.79 254.144 114.999 254.423L114.671 254.539C112.176 255.42 112.527 259.054 115.145 259.441L115.752 259.531C118.37 259.918 119.758 256.542 117.625 254.976L117.345 254.77Z",
    fill: "#F0BEA2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M109.216 259.961C103.986 263.975 117.284 265.832 112.241 270.192",
    stroke: "#443A26",
    strokeWidth: 4.55349
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M122.56 262.759C126.404 268.115 113.138 266.042 116.702 271.676",
    stroke: "#443A26",
    strokeWidth: 4.55349
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M110.164 255.515C103.837 255.087 113.542 263.783 107.092 263.67",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M111.623 251.108C105.54 252.438 113.482 262.337 107.397 264.004",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M121.029 261.055C127.209 262.477 115.402 267.991 121.609 269.75",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M121.048 255.468C126.983 257.895 116.018 265.679 121.36 269.036",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M118.027 258.141C118.008 258.27 116.631 257.934 115.781 257.809C114.931 257.683 113.306 257.677 113.325 257.547C113.344 257.418 115.008 257.168 115.858 257.293C116.707 257.419 118.046 258.011 118.027 258.141Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M117.988 258.198C117.969 258.327 116.551 258.065 115.701 257.939C114.851 257.814 113.401 257.652 113.42 257.522C113.439 257.393 115.028 256.615 115.878 256.741C116.728 256.867 118.007 258.068 117.988 258.198Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M118.136 258.231C118.155 258.101 116.928 256.657 115.89 256.503C114.851 256.35 113.155 257.462 113.136 257.591C113.116 257.72 114.805 256.662 115.843 256.816C116.882 256.969 118.116 258.36 118.136 258.231Z",
    fill: "#DE4C66"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M118.23 258.211C118.211 258.341 116.686 258.542 115.684 258.101C114.784 258.207 113.117 257.72 113.136 257.591C113.155 257.462 114.684 257.687 115.722 257.84C116.761 257.994 118.249 258.082 118.23 258.211Z",
    fill: "#DE4C66"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M114.281 262.84C114.339 262.452 113.472 262.933 112.549 262.797C111.626 262.66 111.356 262.407 110.95 262.054C110.893 262.443 111.595 262.868 112.518 263.005C113.441 263.142 114.224 263.228 114.281 262.84Z",
    fill: "#443A26"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M116.076 263.079C116.134 262.69 116.895 263.333 117.818 263.47C118.742 263.606 119.073 263.442 119.563 263.222C119.506 263.61 118.711 263.815 117.787 263.678C116.864 263.541 116.019 263.467 116.076 263.079Z",
    fill: "#443A26"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M114.576 260.049C113.747 259.261 114.73 259.007 115.138 259.277",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M116.035 260.265C117.057 259.75 116.189 259.223 115.721 259.363",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M114.851 259.198C114.95 259.213 115.026 259.248 115.022 259.277C115.018 259.305 114.934 259.317 114.835 259.302C114.736 259.287 114.66 259.252 114.664 259.224C114.668 259.195 114.752 259.183 114.851 259.198Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M115.985 259.366C116.083 259.381 116.16 259.416 116.156 259.444C116.152 259.473 116.068 259.485 115.969 259.47C115.87 259.455 115.793 259.42 115.798 259.392C115.802 259.363 115.886 259.351 115.985 259.366Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M113.936 261.679C113.606 261.505 113.454 261.103 112.855 261.081C112.257 261.058 111.77 261.322 111.769 261.597C112.167 261.873 112.252 262.114 112.851 262.137C113.449 262.159 113.498 261.888 113.936 261.679Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M112.832 261.294C113.063 261.328 113.226 261.519 113.196 261.721C113.166 261.922 112.955 262.058 112.724 262.024C112.493 261.989 112.33 261.799 112.36 261.597C112.39 261.396 112.601 261.26 112.832 261.294Z",
    fill: "#443A26"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M113.936 261.679C113.606 261.505 113.334 261.969 112.736 261.946C112.137 261.923 111.77 261.322 111.769 261.597C112.167 261.873 112.252 262.114 112.851 262.137C113.449 262.159 113.498 261.888 113.936 261.679Z",
    fill: "#BCA6CA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M116.758 262.044C117.125 261.973 117.387 261.632 117.967 261.784C118.546 261.935 118.935 262.329 118.857 262.592C118.396 262.741 118.245 262.947 117.665 262.795C117.086 262.644 117.117 262.37 116.758 262.044Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M117.922 261.941C118.153 261.976 118.316 262.166 118.286 262.368C118.256 262.569 118.045 262.705 117.814 262.671C117.583 262.637 117.42 262.446 117.45 262.244C117.48 262.043 117.691 261.907 117.922 261.941Z",
    fill: "#443A26"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M116.758 262.044C117.125 261.973 117.115 262.448 117.694 262.6C118.274 262.751 118.935 262.329 118.857 262.592C118.396 262.741 118.245 262.947 117.665 262.795C117.086 262.644 117.117 262.37 116.758 262.044Z",
    fill: "#BCA6CA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M115.115 259.263C115.381 259.189 115.516 259.218 115.742 259.356",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M111.701 261.682L111.836 261.595",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M111.804 261.848L111.924 261.691",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M111.91 261.965L112.02 261.747",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M112.022 262.034L112.132 261.816",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M112.195 262.109L112.263 261.877",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M112.306 262.179L112.373 261.947",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M112.427 262.248L112.478 262.012",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M112.618 262.272L112.63 262.031",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M112.801 262.299L112.813 262.058",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M112.801 262.299L112.813 262.058",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M112.98 262.325L112.992 262.084",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M113.345 262.161L113.312 261.974",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M113.487 262.019L113.445 261.895",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M113.621 261.927L113.573 261.837",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M113.832 261.748L113.801 261.67",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M113.756 261.841L113.709 261.751",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M113.199 262.249L113.185 262.006",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M118.876 262.743L118.772 262.621",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M118.73 262.871L118.661 262.686",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M118.595 262.953L118.553 262.713",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M118.467 262.987L118.425 262.747",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M118.28 263.009L118.283 262.767",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M118.153 263.042L118.156 262.801",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M118.019 263.075L118.038 262.834",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M117.828 263.042L117.887 262.807",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M117.645 263.015L117.704 262.78",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M117.466 262.989L117.525 262.754",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M117.164 262.725L117.25 262.556",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M117.07 262.548L117.147 262.442",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M116.968 262.422L117.04 262.349",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M116.818 262.19L116.871 262.123",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M116.864 262.3L116.936 262.227",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M117.278 262.851L117.361 262.624",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M113.166 257.591C113.037 257.598 112.954 257.634 112.889 257.683",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M112.849 257.558C112.881 257.669 112.937 257.737 113.005 257.789",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M118.063 258.156C118.184 258.2 118.253 258.258 118.302 258.324",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M118.377 258.216C118.314 258.313 118.241 258.362 118.161 258.392",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M118.617 259.542C119.079 259.61 119.403 260.003 119.342 260.421C119.28 260.838 118.856 261.121 118.394 261.052C117.932 260.984 117.608 260.591 117.67 260.173C117.732 259.756 118.156 259.473 118.617 259.542Z",
    fill: "#E99985"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M112.639 258.711C113.101 258.779 113.425 259.172 113.364 259.59C113.302 260.007 112.878 260.29 112.416 260.221C111.954 260.153 111.63 259.759 111.692 259.342C111.754 258.925 112.178 258.642 112.639 258.711Z",
    fill: "#E99985"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M103.906 228.376C104.697 228.252 105.242 228.057 106.008 227.16",
    stroke: "#ED9191",
    strokeWidth: 0.984025
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M105.884 227.32C106.389 226.782 106.309 226.058 106.239 224.916",
    stroke: "#ED9191",
    strokeWidth: 0.984025
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5728 287.248L133.21 299.619L150.399 183.405L108.277 199.8L66.7628 171.034L49.5728 287.248Z",
    fill: "black",
    fillOpacity: 0.1
  })))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 164.228C110.998 174.334 99.7969 186.159 103.897 190.751",
    stroke: "#ED9191",
    strokeWidth: 1.17695
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M108.405 191.571C108.405 194.528 109.707 196.808 107.757 196.808C105.807 196.808 102.343 197.942 102.343 194.984C102.343 192.026 105.807 186.098 107.757 186.098C109.707 186.098 108.405 188.613 108.405 191.571Z",
    fill: "#443A26"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M109.907 191.245C109.151 192.647 107.14 192.647 106.384 191.245L104.609 187.95C103.89 186.617 104.856 185 106.37 185H109.921C111.435 185 112.401 186.617 111.682 187.95L109.907 191.245Z",
    fill: "#443A26"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M110.148 185.05C109.259 188.067 111.992 186.286 113.423 187.245C114.853 188.205 114.52 189.624 115.28 188.491C116.103 185.783 114.828 185.283 113.398 184.324C111.718 183.764 112.075 184.712 110.148 185.05Z",
    fill: "#443A26"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M106.117 185.05C107.007 188.067 104.273 186.286 102.842 187.245C101.412 188.205 101.745 189.624 100.985 188.491C100.162 185.783 101.437 185.283 102.867 184.324C104.547 183.764 104.191 184.712 106.117 185.05Z",
    fill: "#443A26"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M105.58 192.218H94.6346C92.847 192.218 91.3979 193.667 91.3979 195.455V195.808C91.3979 197.595 92.847 199.044 94.6346 199.044H105.58C107.368 199.044 108.817 197.595 108.817 195.808V195.455C108.817 193.667 107.368 192.218 105.58 192.218Z",
    fill: "#443A26"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M107.383 191.974C105.705 191.116 105.874 188.099 104.58 187.216C103.932 186.216 105.835 188.406 107.513 189.265C109.191 190.123 106.742 189.35 106.977 190.312C107.383 191.974 108.17 190.982 107.383 191.974Z",
    fill: "#B8873E"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M108.912 191.943C110.59 191.085 110.42 188.068 111.715 187.185C112.362 186.185 110.46 188.375 108.782 189.234C107.103 190.092 109.553 189.319 109.318 190.281C108.912 191.943 108.125 190.951 108.912 191.943Z",
    fill: "#B8873E"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M108.878 190.779C108.835 191.071 108.561 191.252 108.267 191.25L108.152 191.249L108.026 191.248C107.737 191.246 107.47 191.068 107.427 190.783C107.392 190.544 107.397 190.272 107.556 190.116C107.881 189.796 108.446 189.777 108.765 190.125C108.908 190.28 108.912 190.545 108.878 190.779Z",
    fill: "#635843"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M106.816 187.599C106.995 187.599 107.14 187.454 107.14 187.275C107.14 187.096 106.995 186.951 106.816 186.951C106.637 186.951 106.492 187.096 106.492 187.275C106.492 187.454 106.637 187.599 106.816 187.599Z",
    fill: "#5C4B27",
    stroke: "#CFCFCF",
    strokeWidth: 0.0588476
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M109.405 187.599C109.584 187.599 109.729 187.454 109.729 187.275C109.729 187.096 109.584 186.951 109.405 186.951C109.226 186.951 109.082 187.096 109.082 187.275C109.082 187.454 109.226 187.599 109.405 187.599Z",
    fill: "#5C4B27",
    stroke: "#CFCFCF",
    strokeWidth: 0.0588476
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M107.499 187.08C107.345 187.315 107.309 186.955 107.074 186.801C106.839 186.648 106.495 186.757 106.649 186.523C106.803 186.288 107.118 186.223 107.353 186.377C107.587 186.531 107.653 186.845 107.499 187.08Z",
    fill: "#B8873E"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M108.86 187.08C109.014 187.315 109.05 186.955 109.284 186.801C109.519 186.648 109.863 186.757 109.709 186.523C109.555 186.288 109.24 186.223 109.006 186.377C108.771 186.531 108.706 186.845 108.86 187.08Z",
    fill: "#B8873E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M107.463 191.924C108.287 192.218 108.876 191.924 108.876 191.924",
    stroke: "#635843",
    strokeWidth: 0.117695
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0198 193.681C94.2408 195.268 95.5818 197.199 95.0148 197.992C94.4478 198.785 93.7278 195.987 91.5068 194.399C89.2858 192.811 86.4048 193.035 86.9718 192.242C87.5388 191.449 89.7988 192.093 92.0198 193.681Z",
    fill: "#443A26"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M104.951 196.132C104.951 199.057 107.395 201.429 105.995 201.429C104.595 201.429 103.721 199.057 103.721 196.132C103.721 193.207 102.661 193.854 104.061 193.854C105.461 193.854 104.951 193.207 104.951 196.132Z",
    fill: "#443A26"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M107.187 196.132C107.187 199.057 109.631 201.429 108.231 201.429C106.831 201.429 105.957 199.057 105.957 196.132C105.957 193.207 102.792 193.591 104.192 193.591C105.592 193.591 107.187 193.207 107.187 196.132Z",
    fill: "#443A26"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M93.417 196.147C93.417 199.072 95.861 201.443 94.461 201.443C93.061 201.443 92.187 199.072 92.187 196.147C92.187 193.222 92.493 193.377 93.893 193.377C95.293 193.377 93.417 193.222 93.417 196.147Z",
    fill: "#443A26"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M95.653 196.147C95.653 199.072 98.097 201.443 96.697 201.443C95.297 201.443 94.423 199.072 94.423 196.147C94.423 193.222 94.253 193.803 95.653 193.803C97.053 193.803 95.653 193.222 95.653 196.147Z",
    fill: "#443A26"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9691 199.934C94.0101 200.654 95.1921 201.187 94.5161 201.225C93.8411 201.264 93.3861 200.704 93.3451 199.984C93.3041 199.264 93.8141 200.364 93.7131 199.44C94.4671 199.179 93.9441 199.5 93.9691 199.934Z",
    fill: "#B8873E"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1249 199.849C96.1659 200.569 97.3479 201.101 96.6719 201.14C95.9969 201.179 95.5419 200.619 95.5009 199.899C95.4599 199.179 95.9699 200.279 95.8679 199.354C96.6229 199.093 96.0999 199.414 96.1249 199.849Z",
    fill: "#B8873E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M105.571 199.9C105.612 200.62 106.794 201.152 106.119 201.191C105.444 201.229 104.989 200.67 104.948 199.949C104.906 199.229 105.417 200.33 105.315 199.405C106.069 199.144 105.546 199.465 105.571 199.9Z",
    fill: "#B8873E"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M107.736 199.834C107.777 200.554 108.959 201.087 108.284 201.125C107.609 201.164 107.154 200.604 107.113 199.884C107.071 199.164 107.582 200.264 107.48 199.34C108.234 199.079 107.712 199.4 107.736 199.834Z",
    fill: "#B8873E"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M104.285 189.511C105.227 190.041 106.345 193.395 108.581 193.16",
    stroke: "#ED9191",
    strokeWidth: 1.17695
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M123.748 197.997C123.748 199.512 123.831 200.739 125.628 200.739C127.425 200.739 131.282 202.254 131.282 200.739C131.282 199.225 128.635 197.775 126.839 197.775C125.042 197.775 123.748 196.483 123.748 197.997Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M124.051 197.308C124.051 198.005 123.705 200.039 124.528 200.039C125.351 200.039 132.497 202.092 131.203 200.039C119.873 201.054 127.3 197.646 126.477 197.646C125.654 197.646 124.051 196.61 124.051 197.308Z",
    fill: "#8C799B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M121.336 197.579C121.325 199.094 121.233 200.321 119.436 200.308C117.639 200.295 113.772 201.782 113.782 200.268C113.793 198.753 116.45 197.322 118.247 197.335C120.044 197.347 121.346 196.065 121.336 197.579Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M121.038 196.888C121.033 197.585 121.365 199.621 120.542 199.615C119.719 199.609 112.558 201.612 113.867 199.567C125.189 200.664 117.786 197.202 118.609 197.208C119.432 197.214 121.043 196.19 121.038 196.888Z",
    fill: "#8C799B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M117.516 164.346H131.939C131.044 180.186 128.671 186.806 126.67 197.749H122.833C119.806 184.871 133.208 182.072 117.516 164.346Z",
    fill: "#ED9191"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M131.333 165.232L117.056 163.175C115.685 178.981 117.089 185.871 117.51 196.988L121.308 197.535C126.14 185.221 113.274 180.539 131.333 165.232Z",
    fill: "#ED9191"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M125.902 141.209C125.526 144.609 130.258 145.832 131.577 142.676L139.648 123.354C140.439 121.461 138.048 119.859 136.598 121.31C136.472 121.436 136.365 121.579 136.28 121.736L126.246 140.116C126.061 140.454 125.945 140.826 125.902 141.209Z",
    fill: "#F0BEA2"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M118.178 143.147C117.464 138.916 120.493 134.814 124.784 134.814C128.926 134.814 131.966 138.681 131.784 142.819C131.411 151.273 133.497 157.839 132.872 166.428C128.919 165.94 126.667 176.253 116.219 166.428C118.786 157.08 119.477 150.847 118.178 143.147Z",
    fill: "#B49DC7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M127.989 138.714C127.989 143.921 129.825 141.914 124.953 141.914C120.08 141.914 121.401 143.921 121.401 138.714C121.401 133.506 120.08 129.284 124.953 129.284C129.825 129.284 127.989 133.506 127.989 138.714Z",
    fill: "#EFB99E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.228 132.911C125.42 133.401 124.407 133.401 123.599 132.911L121.329 131.535C119.133 130.205 120.076 126.829 122.643 126.829H127.183C129.751 126.829 130.694 130.205 128.498 131.535L126.228 132.911Z",
    fill: "#E4CFB0"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M119.371 120.443C116.516 127.096 125.872 133.233 121.676 139.64C123.183 133.243 112.901 125.672 115.756 119.019C118.612 112.367 124.34 109.516 129.276 111.634C134.211 113.752 122.226 113.791 119.371 120.443Z",
    fill: "#443A26"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M128.928 123.175C131.783 129.828 122.428 135.965 126.623 142.372C125.117 135.975 135.398 128.404 132.543 121.751C129.688 115.099 123.959 112.248 119.024 114.366C114.088 116.484 126.073 116.523 128.928 123.175Z",
    fill: "#443A26"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M132.245 123.436C135.101 130.088 125.745 136.225 129.941 142.632C128.434 136.236 138.715 128.664 135.86 122.012C133.005 115.359 127.277 112.508 122.341 114.626C117.406 116.744 129.39 116.783 132.245 123.436Z",
    fill: "#443A26"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M130.749 123.175C133.604 129.828 124.249 135.965 128.445 142.372C126.938 135.975 137.219 128.404 134.364 121.751C131.509 115.099 125.781 112.248 120.845 114.366C115.91 116.484 127.894 116.523 130.749 123.175Z",
    fill: "#443A26"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M132.481 124.004C130.659 130.485 130.681 131.854 124.903 131.854C119.124 131.854 120.024 130.681 117.324 124.004C117.324 118.674 120.717 114.353 124.903 114.353C129.088 114.353 132.481 118.674 132.481 124.004Z",
    fill: "#F0BEA2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M120.986 141.408C121.395 138.342 117.106 137.191 115.926 140.051L109.848 154.782C109.373 155.934 110.684 156.999 111.714 156.299C111.856 156.203 111.976 156.078 112.068 155.933L120.599 142.472C120.803 142.15 120.935 141.786 120.986 141.408Z",
    fill: "#F0BEA2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M112.28 155.444C112.207 153.937 110.055 153.748 109.72 155.219L108.073 162.459C107.934 163.066 108.655 163.494 109.122 163.082C109.194 163.018 109.251 162.939 109.289 162.851L112.179 156.012C112.255 155.833 112.29 155.638 112.28 155.444Z",
    fill: "#F0BEA2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M110.778 164.719C109.914 165.153 109.503 163.542 109.018 163.786C108.543 162.841 109.139 161.951 109.584 161.168C110.448 160.733 109.256 162.156 109.731 163.101C110.206 164.046 111.641 164.284 110.778 164.719Z",
    fill: "#F0BEA2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M108.486 165.766C107.808 165.327 108.936 163.282 108.556 163.036C109.037 162.295 108.737 161.434 109.49 161.425C110.167 161.864 109.585 161.227 109.49 162.462C109.009 163.204 109.164 166.206 108.486 165.766Z",
    fill: "#F0BEA2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M108.024 165.473C107.404 164.98 108.696 163.091 108.349 162.815C108.888 162.137 108.676 161.268 109.412 161.33C110.032 161.823 109.642 162.431 109.103 163.109C108.564 163.788 108.644 165.965 108.024 165.473Z",
    fill: "#F0BEA2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M107.581 165.198C107.102 164.764 108.465 163.533 107.773 162.632C108.247 162.107 108.332 161.805 108.929 161.893C109.409 162.327 109.059 162.802 108.584 163.327C108.11 163.852 108.061 165.632 107.581 165.198Z",
    fill: "#F0BEA2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M107.429 164.634C107.183 164.284 107.848 162.788 107.994 162.316C108.377 162.046 108.258 162.098 108.63 162.242C108.877 162.593 108.687 162.936 108.198 163.118C107.814 163.388 107.675 164.985 107.429 164.634Z",
    fill: "#F0BEA2"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M108.959 164.052C108.856 164.46 108.433 164.698 108.032 164.574C107.762 164.49 107.564 164.26 107.523 163.981L107.505 163.857C107.482 163.704 107.498 163.547 107.551 163.401L108.122 161.841C108.142 161.785 108.188 161.743 108.246 161.728C108.286 161.717 108.329 161.721 108.367 161.738L108.642 161.864C109.093 162.07 109.332 162.569 109.211 163.049L108.959 164.052Z",
    fill: "#F0BEA2"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M136.474 122.289C136.951 124.264 139.843 123.988 139.937 121.958L140.376 112.53C140.414 111.721 139.398 111.33 138.884 111.956C138.804 112.054 138.746 112.168 138.716 112.291L136.475 121.459C136.408 121.731 136.408 122.016 136.474 122.289Z",
    fill: "#F0BEA2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M136.458 110.232C137.459 109.508 138.307 111.457 138.868 111.051C139.66 112.147 139.117 113.363 138.714 114.443C137.713 115.167 138.901 113.156 138.108 112.06C137.316 110.964 135.456 110.956 136.458 110.232Z",
    fill: "#EFB99E"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M138.744 106.448C139.689 106.865 138.683 109.675 139.212 109.908C138.757 110.942 139.311 111.967 138.362 112.132C137.417 111.716 137.708 110.82 138.164 109.786C138.62 108.752 137.799 106.032 138.744 106.448Z",
    fill: "#EFB99E"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M139.794 106.795C140.676 107.29 139.43 109.938 139.925 110.215C139.383 111.181 139.827 112.234 138.886 112.305C138.003 111.81 138.371 110.963 138.913 109.997C139.455 109.031 138.911 106.299 139.794 106.795Z",
    fill: "#EFB99E"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M140.698 107.033C141.392 107.482 139.774 109.327 140.833 110.323C140.34 111.083 140.442 111.468 139.671 111.478C138.977 111.028 139.321 110.357 139.814 109.598C140.306 108.838 140.004 106.583 140.698 107.033Z",
    fill: "#EFB99E"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M140.994 108.211C141.376 108.603 140.802 111.11 140.715 111.736C140.286 112.154 140.465 111.581 139.966 111.475C139.583 111.082 139.752 110.611 140.333 110.281C140.762 109.863 140.612 107.819 140.994 108.211Z",
    fill: "#EFB99E"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M116.764 138.478C119.284 140.083 120.241 141.245 120.82 143.966",
    stroke: "#B49DC7",
    strokeWidth: 2.94238
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M138.889 110.703C138.935 110.168 139.421 109.781 139.953 109.855C140.31 109.906 140.607 110.156 140.716 110.5L140.764 110.652C140.824 110.841 140.836 111.042 140.798 111.237L140.397 113.323C140.382 113.397 140.332 113.46 140.263 113.491C140.214 113.512 140.159 113.516 140.108 113.502L139.735 113.399C139.125 113.231 138.721 112.651 138.776 112.019L138.889 110.703Z",
    fill: "#EFB99E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M118.456 123.254C118.456 124.182 118.712 126.257 117.914 126.257C117.117 126.257 115.568 124.182 115.568 123.254C115.568 122.326 116.214 121.574 117.012 121.574C117.809 121.574 118.456 122.326 118.456 123.254Z",
    fill: "#D6C2A2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M117.119 123.33C116.174 123.89 117.711 124.244 117.119 124.891",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M133.011 121.283C133.956 121.844 132.42 122.197 133.011 122.844",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M118.055 120.463C115.2 127.115 124.555 133.252 120.36 139.66C121.866 133.263 113.537 123.317 116.392 116.665C119.247 110.012 123.024 109.535 127.959 111.653C132.895 113.772 120.91 113.811 118.055 120.463Z",
    fill: "#443A26"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M118.356 120.333C115.5 126.985 127.789 144.188 118.138 142.099C119.645 135.702 114.09 124.976 116.945 118.323C119.8 111.671 123.324 109.405 128.26 111.523C133.195 113.642 121.211 113.681 118.356 120.333Z",
    fill: "#443A26"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M133.493 122.242C134.852 129.352 119.152 143.511 129.026 143.546C128.93 136.975 136.661 127.693 135.303 120.582C133.945 113.472 130.99 110.501 125.714 111.509C120.439 112.517 132.135 115.131 133.493 122.242Z",
    fill: "#443A26"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M126.228 132.911C125.42 133.401 124.407 133.401 123.599 132.911L121.329 131.535C119.133 130.205 120.076 126.829 122.643 126.829H127.183C129.751 126.829 130.694 130.205 128.498 131.535L126.228 132.911Z",
    fill: "#F0BEA2"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M118.343 125.121C113.4 119.271 127.871 119.406 123.183 113.167",
    stroke: "#443A26",
    strokeWidth: 4.55349
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M133.011 124.115C137.954 118.264 123.484 118.399 128.172 112.16",
    stroke: "#443A26",
    strokeWidth: 4.55349
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M118.653 130.725C111.84 130.105 123.558 121.233 116.664 120.205",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M119.514 136.375C113.239 133.65 123.266 122.989 117.042 119.852",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M131.111 125.92C137.924 125.3 126.206 116.427 133.1 115.4",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M130.25 132.75C136.96 130.857 126.498 119.365 132.722 116.228",
    stroke: "#443A26",
    strokeWidth: 1.9515
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M127.45 128.938C127.45 128.776 125.93 128.938 125.004 128.938C124.078 128.938 122.344 128.652 122.344 128.813C122.344 128.975 124.078 129.582 125.004 129.582C125.93 129.582 127.45 129.1 127.45 128.938Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M127.418 128.861C127.418 128.7 125.865 128.764 124.939 128.764C124.013 128.764 122.441 128.7 122.441 128.861C122.441 129.023 124.013 130.26 124.939 130.26C125.865 130.26 127.418 129.023 127.418 128.861Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M127.581 128.848C127.581 129.01 126.045 130.553 124.914 130.553C123.782 130.553 122.149 128.888 122.149 128.726C122.149 128.564 123.782 130.163 124.914 130.163C126.045 130.163 127.581 128.686 127.581 128.848Z",
    fill: "#DE4C66"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M127.678 128.888C127.678 128.727 126.084 128.205 124.946 128.563C124.003 128.27 122.149 128.564 122.149 128.726C122.149 128.888 123.814 128.888 124.946 128.888C126.078 128.888 127.678 129.05 127.678 128.888Z",
    fill: "#DE4C66"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M124.198 122.519C124.198 123.004 123.35 122.259 122.344 122.259C121.338 122.259 121.01 122.519 120.522 122.877C120.522 122.392 121.338 121.999 122.344 121.999C123.35 121.999 124.198 122.034 124.198 122.519Z",
    fill: "#443A26"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M126.149 122.552C126.149 123.037 127.062 122.389 128.068 122.389C129.074 122.389 129.402 122.649 129.89 123.007C129.89 122.522 129.074 122.129 128.068 122.129C127.062 122.129 126.149 122.067 126.149 122.552Z",
    fill: "#443A26"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M124.072 125.983C123.064 126.796 124.072 127.284 124.55 127.028",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M125.662 125.983C126.67 126.796 125.662 127.284 125.184 127.028",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M124.23 127.073C124.338 127.073 124.425 127.044 124.425 127.008C124.425 126.972 124.338 126.943 124.23 126.943C124.122 126.943 124.035 126.972 124.035 127.008C124.035 127.044 124.122 127.073 124.23 127.073Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M125.466 127.073C125.574 127.073 125.661 127.044 125.661 127.008C125.661 126.972 125.574 126.943 125.466 126.943C125.358 126.943 125.271 126.972 125.271 127.008C125.271 127.044 125.358 127.073 125.466 127.073Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M123.647 123.875C123.267 124.028 123.042 124.491 122.4 124.411C121.758 124.331 121.281 123.92 121.324 123.584C121.792 123.318 121.92 123.04 122.562 123.12C123.203 123.201 123.213 123.541 123.647 123.875Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M122.409 124.145C122.66 124.145 122.864 123.941 122.864 123.69C122.864 123.438 122.66 123.235 122.409 123.235C122.157 123.235 121.954 123.438 121.954 123.69C121.954 123.941 122.157 124.145 122.409 124.145Z",
    fill: "#443A26"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M123.647 123.875C123.267 124.028 123.051 123.413 122.409 123.332C121.767 123.252 121.281 123.92 121.324 123.584C121.792 123.318 121.92 123.04 122.562 123.12C123.203 123.201 123.213 123.541 123.647 123.875Z",
    fill: "#BCA6CA"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M126.714 123.94C127.093 124.093 127.319 124.556 127.961 124.476C128.603 124.396 129.079 123.985 129.037 123.649C128.569 123.383 128.441 123.105 127.799 123.185C127.157 123.266 127.148 123.606 126.714 123.94Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M127.938 124.275C128.189 124.275 128.393 124.071 128.393 123.82C128.393 123.568 128.189 123.365 127.938 123.365C127.686 123.365 127.482 123.568 127.482 123.82C127.482 124.071 127.686 124.275 127.938 124.275Z",
    fill: "#443A26"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M126.714 123.94C127.093 124.093 127.157 123.51 127.799 123.43C128.441 123.349 129.079 123.985 129.037 123.649C128.569 123.383 128.441 123.105 127.799 123.185C127.157 123.266 127.148 123.606 126.714 123.94Z",
    fill: "#BCA6CA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M124.523 127.04C124.795 127.179 124.943 127.168 125.206 127.04",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M121.261 123.472L121.391 123.602",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M121.397 123.286L121.501 123.499",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M121.529 123.161L121.612 123.447",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M121.66 123.096L121.742 123.382",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M121.856 123.036L121.891 123.332",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M121.986 122.971L122.021 123.267",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M122.125 122.907L122.142 123.204",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M122.333 122.913L122.307 123.21",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M122.532 122.912L122.506 123.209",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M122.532 122.912L122.506 123.209",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M122.727 122.912L122.702 123.209",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M123.091 123.179L123.026 123.401",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M123.219 123.378L123.154 123.522",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M123.347 123.512L123.282 123.614",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M123.544 123.77L123.498 123.86",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M123.477 123.642L123.412 123.744",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M122.949 123.045L122.896 123.339",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M129.086 123.473L128.956 123.603",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M128.95 123.287L128.846 123.501",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M128.818 123.161L128.735 123.447",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M128.688 123.096L128.605 123.382",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M128.491 123.036L128.456 123.332",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M128.362 122.971L128.327 123.267",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M128.222 122.907L128.204 123.205",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M128.015 122.914L128.04 123.211",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M127.814 122.913L127.84 123.21",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M127.62 122.913L127.645 123.21",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M127.257 123.179L127.322 123.401",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M127.128 123.379L127.193 123.523",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M127 123.514L127.065 123.615",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M126.804 123.771L126.849 123.861",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M126.87 123.644L126.935 123.746",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M127.398 123.046L127.451 123.339",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M122.181 128.731C122.045 128.699 121.962 128.641 121.9 128.569",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M121.838 128.714C121.89 128.584 121.96 128.511 122.04 128.46",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M127.492 128.927C127.628 128.894 127.711 128.836 127.773 128.764",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M127.835 128.909C127.783 128.779 127.713 128.706 127.633 128.655",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.302 127.333C128.805 127.333 129.213 126.911 129.213 126.39C129.213 125.869 128.805 125.447 128.302 125.447C127.799 125.447 127.391 125.869 127.391 126.39C127.391 126.911 127.799 127.333 128.302 127.333Z",
    fill: "#E99985"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.796 127.268C122.299 127.268 122.707 126.846 122.707 126.325C122.707 125.804 122.299 125.382 121.796 125.382C121.293 125.382 120.885 125.804 120.885 126.325C120.885 126.846 121.293 127.268 121.796 127.268Z",
    fill: "#E99985"
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M107.702 162.757C108.526 163.051 109.076 163.388 109.751 164.621",
    stroke: "#ED9191",
    strokeWidth: 0.984025
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M109.644 164.404C110.097 165.152 109.898 166.023 109.644 167.406",
    stroke: "#ED9191",
    strokeWidth: 0.984025
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_57_182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_57_182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 198,
    width: 41,
    height: 89
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M166.578 202.425C166.614 200.822 166.739 199.525 168.829 199.571C170.919 199.618 175.441 198.115 175.405 199.718C175.37 201.321 172.257 202.788 170.167 202.741C168.077 202.695 166.542 204.029 166.578 202.425Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M166.914 203.163C166.931 202.425 166.576 200.263 167.533 200.285C168.49 200.306 176.85 198.317 175.297 200.458C162.144 199.089 170.701 202.89 169.744 202.868C168.787 202.847 166.898 203.902 166.914 203.163Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M163.763 202.805C163.786 201.202 163.708 199.901 161.618 199.868C159.528 199.835 155.064 198.16 155.041 199.764C155.018 201.367 158.074 202.952 160.165 202.984C162.255 203.017 163.74 204.409 163.763 202.805Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M163.399 203.53C163.41 202.791 163.844 200.645 162.887 200.63C161.929 200.615 153.648 198.309 155.122 200.507C168.316 199.64 159.625 203.113 160.582 203.128C161.54 203.143 163.389 204.268 163.399 203.53Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M159.973 236.433L174.401 236.754C173.867 220.515 171.644 213.683 169.893 202.433L166.053 202.347C162.732 215.466 176.074 218.631 159.973 236.433Z",
    fill: "#F0AA95"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M173.813 235.905L159.499 237.459C158.188 221.131 159.624 214.092 160.09 202.662L163.899 202.249C168.691 215.119 155.779 219.431 173.813 235.905Z",
    fill: "#F0AA95"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M161.552 257.427C158.754 255.911 160.495 251.625 163.612 252.355L183.793 257.083C185.64 257.515 185.436 260.183 183.538 260.422C183.392 260.44 183.245 260.44 183.1 260.421L162.495 257.732C162.163 257.689 161.844 257.586 161.552 257.427Z",
    fill: "#F3CEB9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M159.656 254.838C159.548 259.091 162.418 263.344 166.671 263.438C170.767 263.53 173.823 259.727 173.684 255.633C173.436 248.287 175.205 242.52 175.376 234.851C171.415 235.207 168.061 226.132 157.416 234.84C157.659 243.181 159.818 248.464 159.656 254.838Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M169.933 259.96C170.039 255.222 171.833 257.089 166.962 256.981C162.091 256.872 163.452 255.075 163.346 259.814C163.241 264.552 161.835 268.364 166.706 268.473C171.577 268.581 169.827 264.699 169.933 259.96Z",
    fill: "#F3CEB9"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M167.966 265.15C167.213 264.712 166.288 264.692 165.517 265.095L163.999 265.889C161.676 267.103 162.497 270.615 165.118 270.673L168.116 270.74C170.737 270.798 171.714 267.327 169.447 266.01L167.966 265.15Z",
    fill: "#E4CFB0"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M160.946 276.393C158.227 270.276 167.704 264.901 163.639 258.977C165.016 264.831 156.987 270.249 159.706 276.366C162.426 282.482 165.158 284.254 170.135 282.437C175.113 280.619 163.666 282.51 160.946 276.393Z",
    fill: "#F7E2BE"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M170.556 274.12C173.546 268.131 164.317 262.338 168.641 256.601C167.005 262.388 177.131 269.507 174.141 275.496C171.152 281.486 165.367 283.953 160.476 281.916C155.585 279.878 167.567 280.11 170.556 274.12Z",
    fill: "#F7E2BE"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M172.378 274.161C175.367 268.171 166.138 262.378 170.463 256.642C168.827 262.429 176.863 269.185 173.874 275.174C170.885 281.164 167.189 283.994 162.297 281.956C157.406 279.919 169.388 280.15 172.378 274.161Z",
    fill: "#F7E2BE"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M174.125 273.445C172.436 267.507 172.485 266.262 166.708 266.134C160.931 266.005 161.807 267.093 158.972 273.108C158.864 277.958 162.169 281.965 166.353 282.058C170.538 282.151 174.017 278.295 174.125 273.445Z",
    fill: "#F3CEB9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M159.277 256.775C161.421 255.258 164.01 257.782 162.278 259.699L151.939 271.138C151.131 272.033 149.598 271.466 149.73 270.322C149.751 270.132 149.822 269.95 149.936 269.788L158.736 257.314C158.882 257.108 159.065 256.925 159.277 256.775Z",
    fill: "#F3CEB9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M152.089 271.074C151.614 269.675 149.526 270.077 149.57 271.559L149.772 278.229C149.79 278.836 150.564 279.071 150.93 278.581C150.993 278.497 151.035 278.4 151.052 278.297L152.139 271.694C152.173 271.486 152.156 271.273 152.089 271.074Z",
    fill: "#F3CEB9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M152.954 279.639C152.226 280.215 151.427 278.885 151.018 279.207C150.323 278.479 150.679 277.561 150.916 276.771C151.645 276.195 150.843 277.716 151.538 278.444C152.234 279.173 153.683 279.064 152.954 279.639Z",
    fill: "#F3CEB9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M150.995 281.074C150.229 280.837 150.813 278.781 150.384 278.649C150.666 277.887 150.161 277.194 150.888 277.019C151.654 277.256 150.931 276.823 151.146 277.934C150.864 278.696 151.761 281.311 150.995 281.074Z",
    fill: "#F3CEB9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M150.474 280.918C149.751 280.621 150.533 278.666 150.128 278.499C150.482 277.781 150.061 277.062 150.789 276.953C151.512 277.25 151.285 277.873 150.932 278.591C150.578 279.31 151.197 281.214 150.474 280.918Z",
    fill: "#F3CEB9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M149.935 280.511C149.363 280.234 150.42 279.108 149.524 278.466C149.854 277.897 149.861 277.611 150.461 277.557C151.033 277.833 150.813 278.33 150.484 278.899C150.154 279.468 150.508 280.787 149.935 280.511Z",
    fill: "#F3CEB9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M149.689 280.31C149.364 280.055 149.636 278.587 149.66 278.138C149.964 277.815 149.862 277.887 150.258 277.931C150.584 278.186 150.486 278.531 150.057 278.801C149.753 279.124 150.015 280.564 149.689 280.31Z",
    fill: "#F3CEB9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M151.026 279.372C151.029 279.799 150.67 280.142 150.244 280.121C149.969 280.108 149.726 279.944 149.611 279.696L149.579 279.626C149.513 279.483 149.487 279.326 149.505 279.169L149.665 277.701C149.672 277.641 149.709 277.588 149.763 277.561C149.797 277.544 149.835 277.538 149.872 277.544L150.154 277.591C150.654 277.675 151.02 278.105 151.022 278.612L151.026 279.372Z",
    fill: "#F3CEB9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M181.84 258.037C182.388 256.146 185.224 256.586 185.281 258.571L185.526 267.045C185.548 267.831 184.565 268.181 184.041 267.574C183.951 267.47 183.887 267.346 183.855 267.214L181.824 258.921C181.752 258.627 181.758 258.323 181.84 258.037Z",
    fill: "#F3CEB9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M181.562 269.068C182.549 269.749 183.436 267.995 183.988 268.377C184.803 267.397 184.284 266.278 183.903 265.287C182.917 264.606 184.064 266.462 183.249 267.441C182.435 268.421 180.576 268.387 181.562 269.068Z",
    fill: "#F3CEB9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M183.771 272.562C184.724 272.204 183.775 269.625 184.31 269.424C183.875 268.473 184.45 267.553 183.505 267.382C182.552 267.74 182.824 268.561 183.259 269.512C183.694 270.463 182.818 272.92 183.771 272.562Z",
    fill: "#F3CEB9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M184.828 272.27C185.72 271.839 184.528 269.402 185.028 269.161C184.506 268.27 184.971 267.322 184.032 267.236C183.139 267.667 183.49 268.445 184.012 269.336C184.535 270.227 183.935 272.701 184.828 272.27Z",
    fill: "#F3CEB9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M185.737 272.074C186.439 271.68 184.86 269.965 185.938 269.082C185.461 268.381 185.571 268.032 184.8 268.006C184.097 268.4 184.428 269.018 184.904 269.72C185.381 270.422 185.034 272.468 185.737 272.074Z",
    fill: "#F3CEB9"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M186.056 271.008C186.447 270.66 185.923 268.366 185.849 267.795C185.428 267.404 185.596 267.93 185.094 268.016C184.704 268.364 184.863 268.797 185.437 269.11C185.858 269.5 185.666 271.356 186.056 271.008Z",
    fill: "#F3CEB9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M159.972 260.011C162.524 258.606 162.238 257.484 162.872 255.021",
    stroke: "black",
    strokeWidth: 2.94238
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M183.995 268.592C184.035 269.134 184.525 269.544 185.067 269.487C185.416 269.45 185.711 269.223 185.833 268.898L185.867 268.805C185.937 268.619 185.954 268.417 185.917 268.22L185.565 266.357C185.551 266.281 185.499 266.216 185.427 266.185C185.382 266.166 185.332 266.161 185.285 266.172L184.93 266.253C184.301 266.396 183.878 266.968 183.924 267.612L183.995 268.592Z",
    fill: "#F3CEB9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M158.754 273.716C157.82 273.185 159.364 272.898 158.785 272.296",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M174.601 275.933C175.557 275.444 174.028 275.088 174.632 274.512",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M159.631 276.346C156.912 270.229 166.389 264.853 162.325 258.93C163.701 264.784 156.019 270.99 158.738 277.106C161.458 283.223 163.713 284.312 168.691 282.494C173.668 280.676 162.351 282.463 159.631 276.346Z",
    fill: "#F7E2BE"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M161.173 276.832C158.453 270.715 169.844 254.974 160.153 256.66C161.53 262.515 155.758 272.151 158.478 278.268C161.197 284.385 164.42 283.551 169.397 281.733C174.374 279.916 162.879 279.767 161.173 276.832Z",
    fill: "#F7E2BE"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M167.664 264.974C167.099 264.646 166.405 264.631 165.827 264.933L161.816 267.03C160.073 267.941 160.689 270.574 162.655 270.618L170.579 270.795C172.545 270.839 173.277 268.235 171.577 267.248L167.664 264.974Z",
    fill: "#F3CEB9"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M161.419 269.984C160.636 261.291 162.783 260.717 163.513 260.971C162.269 260.538 160.308 259.599 158.975 271.647C159.424 279.237 159.832 278.046 161.076 278.478C162.319 278.91 161.291 275.726 161.419 269.984Z",
    fill: "#F7E2BE"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M172.124 276.144C175.114 270.155 164.515 254.5 174.121 256.616C172.485 262.403 177.693 270.212 174.704 276.202C171.715 282.191 168.274 286.25 163.382 284.213C158.491 282.175 169.135 282.134 172.124 276.144Z",
    fill: "#F7E2BE"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M160.49 278.491C159.323 275.152 166.472 256.326 157.796 256.666C161.98 260.58 154.69 275.815 161.332 278.509C162.499 281.848 157.314 278.064 158.752 277.652C160.189 277.241 161.657 281.829 160.49 278.491Z",
    fill: "#F7E2BE"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M161.412 261.9C155.084 264.24 164.893 274.164 158.606 276.879",
    stroke: "#F7E2BE",
    strokeWidth: 1.9515
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M169.196 268.844C169.193 268.991 167.676 268.81 166.75 268.789C165.825 268.769 164.085 268.99 164.088 268.843C164.092 268.696 165.838 268.183 166.763 268.203C167.689 268.224 169.199 268.697 169.196 268.844Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M169.162 268.913C169.159 269.06 167.607 268.967 166.682 268.946C165.756 268.926 164.184 268.949 164.187 268.802C164.19 268.655 165.786 267.564 166.712 267.585C167.638 267.605 169.165 268.765 169.162 268.913Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M169.324 268.928C169.327 268.781 167.824 267.343 166.692 267.318C165.561 267.293 163.895 268.771 163.891 268.919C163.888 269.066 165.553 267.648 166.684 267.673C167.816 267.698 169.321 269.075 169.324 268.928Z",
    fill: "#DE4C66"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M169.423 268.894C169.42 269.041 167.816 269.48 166.685 269.129C165.736 269.374 163.888 269.066 163.892 268.919C163.895 268.772 165.56 268.808 166.691 268.833C167.823 268.858 169.426 268.747 169.423 268.894Z",
    fill: "#DE4C66"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M165.814 274.612C165.824 274.171 164.961 274.83 163.956 274.807C162.95 274.785 162.628 274.541 162.147 274.205C162.137 274.646 162.945 275.022 163.95 275.044C164.956 275.067 165.805 275.053 165.814 274.612Z",
    fill: "#C4B397"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M167.766 274.626C167.776 274.184 168.675 274.794 169.681 274.817C170.687 274.839 171.019 274.609 171.514 274.295C171.505 274.736 170.681 275.076 169.676 275.053C168.67 275.031 167.756 275.067 167.766 274.626Z",
    fill: "#C4B397"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M165.787 271.241C164.795 270.479 165.567 270.217 166.039 270.461",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M167.228 271.271C168.253 270.554 167.571 270.261 167.088 270.484",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M165.841 270.427C165.949 270.429 166.036 270.458 166.035 270.49C166.034 270.523 165.946 270.548 165.839 270.545C165.731 270.543 165.644 270.514 165.645 270.482C165.646 270.449 165.734 270.424 165.841 270.427Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M167.284 270.46C167.392 270.462 167.479 270.491 167.478 270.523C167.477 270.556 167.389 270.581 167.282 270.578C167.174 270.576 167.087 270.547 167.088 270.515C167.088 270.482 167.176 270.457 167.284 270.46Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M168.358 273.375C168.741 273.244 168.913 273.169 169.553 273.256C170.193 273.344 170.724 273.387 170.675 273.692C170.202 273.923 170.068 274.174 169.428 274.086C168.788 273.999 168.785 273.689 168.358 273.375Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M169.581 273.264C169.833 273.269 170.032 273.459 170.027 273.688C170.022 273.917 169.814 274.098 169.563 274.092C169.311 274.087 169.112 273.897 169.117 273.668C169.122 273.439 169.33 273.258 169.581 273.264Z",
    fill: "url(#paint0_radial_57_182)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M168.358 273.375C168.741 273.244 168.793 273.776 169.433 273.863C170.073 273.951 170.724 273.387 170.675 273.692C170.202 273.923 170.068 274.174 169.428 274.086C168.788 273.999 168.785 273.689 168.358 273.375Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M170.719 273.854L170.592 273.733",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M170.58 274.019L170.481 273.823",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M170.446 274.131L170.369 273.868",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M170.314 274.187L170.237 273.924",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M170.117 274.237L170.088 273.967",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M169.985 274.293L169.956 274.022",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M169.846 274.348L169.834 274.077",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M169.638 274.339L169.669 274.069",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M169.438 274.334L169.47 274.064",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M169.244 274.33L169.275 274.06",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M168.886 274.079L168.955 273.878",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M168.761 273.895L168.829 273.766",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M168.635 273.769L168.702 273.678",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M168.444 273.531L168.491 273.449",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M168.508 273.648L168.575 273.557",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M169.024 274.204L169.083 273.938",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M164.891 273.409C164.515 273.261 164.346 273.178 163.703 273.237C163.06 273.296 162.527 273.315 162.562 273.622C163.025 273.874 163.148 274.13 163.791 274.071C164.434 274.012 164.45 273.703 164.891 273.409Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M163.674 273.243C163.423 273.237 163.215 273.418 163.21 273.647C163.205 273.876 163.404 274.066 163.656 274.071C163.907 274.077 164.115 273.896 164.12 273.667C164.125 273.438 163.925 273.248 163.674 273.243Z",
    fill: "url(#paint1_radial_57_182)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M164.891 273.409C164.515 273.261 164.439 273.79 163.796 273.849C163.153 273.908 162.527 273.315 162.562 273.622C163.025 273.874 163.148 274.13 163.791 274.071C164.434 274.012 164.45 273.703 164.891 273.409Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M162.512 273.782L162.644 273.667",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M162.644 273.954L162.751 273.762",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M162.772 274.07L162.861 273.811",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M162.901 274.132L162.99 273.873",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M163.095 274.191L163.136 273.922",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M163.224 274.253L163.265 273.984",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M163.362 274.314L163.386 274.044",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M163.57 274.314L163.551 274.043",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M163.77 274.318L163.75 274.047",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M163.964 274.323L163.945 274.052",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M164.333 274.088L164.273 273.885",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M164.466 273.909L164.404 273.777",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M164.598 273.79L164.535 273.696",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M164.799 273.561L164.755 273.478",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M164.729 273.674L164.667 273.58",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M164.189 274.206L164.142 273.938",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M163.924 268.914C163.787 268.941 163.703 268.992 163.64 269.056",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M163.58 268.923C163.63 269.042 163.698 269.11 163.778 269.158",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M169.237 268.855C169.372 268.887 169.454 268.942 169.515 269.009",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M169.58 268.879C169.525 268.996 169.454 269.061 169.373 269.105",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M170.015 270.323C170.518 270.334 170.917 270.727 170.906 271.201C170.896 271.675 170.48 272.051 169.977 272.039C169.474 272.028 169.075 271.635 169.086 271.161C169.096 270.687 169.512 270.312 170.015 270.323Z",
    fill: "#E99985"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M163.51 270.238C164.013 270.249 164.412 270.642 164.402 271.116C164.391 271.59 163.975 271.965 163.472 271.954C162.969 271.943 162.57 271.55 162.581 271.076C162.591 270.602 163.007 270.227 163.51 270.238Z",
    fill: "#E99985"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M166.039 270.461C166.433 270.06 166.662 270.088 167.088 270.484",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M152.225 281.269L149.159 279.556C148.842 279.379 148.75 278.992 148.952 278.691L149.177 278.356C149.379 278.055 149.799 277.955 150.115 278.132L153.182 279.845C153.498 280.022 153.591 280.409 153.389 280.71L153.164 281.045C152.962 281.346 152.541 281.446 152.225 281.269Z",
    fill: "#EE8B17"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M148.186 279.664L147.115 279.066C146.798 278.889 146.706 278.502 146.908 278.201L147.777 276.907C147.979 276.606 148.399 276.506 148.715 276.682L149.786 277.281C150.103 277.458 150.195 277.845 149.993 278.146L149.124 279.44C148.922 279.741 148.502 279.841 148.186 279.664Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M151.798 284.153L151.025 283.715C150.678 283.519 150.579 283.093 150.803 282.763L152.61 280.105C152.834 279.776 153.297 279.667 153.644 279.864L154.417 280.301C154.764 280.497 154.864 280.924 154.639 281.253L152.832 283.911C152.608 284.241 152.145 284.349 151.798 284.153Z",
    fill: "#EE8B17"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M150.532 285.617L150.135 285.392C149.788 285.196 149.688 284.77 149.913 284.44L150.38 283.752C150.604 283.423 151.067 283.314 151.414 283.511L151.811 283.735C152.158 283.932 152.258 284.358 152.034 284.687L151.566 285.376C151.342 285.705 150.879 285.813 150.532 285.617Z",
    fill: "#ACACAC"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M149.724 286.661C149.681 286.724 149.592 286.745 149.525 286.707C149.459 286.67 149.44 286.588 149.483 286.524L150.606 284.872C150.649 284.809 150.738 284.788 150.805 284.826C150.871 284.863 150.891 284.945 150.847 285.009L149.724 286.661Z",
    fill: "#ACACAC"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M151.375 281.043C151.699 281.075 152.067 281.343 152.093 281.113C152.119 280.884 151.877 280.672 151.553 280.64C151.229 280.608 150.938 280.661 150.911 280.891C150.885 281.12 151.051 281.011 151.375 281.043Z",
    fill: "#F3CEB9"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M150.859 280.673C151.183 280.705 151.55 280.973 151.576 280.744C151.602 280.514 151.361 280.302 151.036 280.27C150.712 280.238 150.428 280.399 150.402 280.628C150.376 280.858 150.534 280.641 150.859 280.673Z",
    fill: "#F3CEB9"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M150.469 280.485C150.793 280.517 151.16 280.785 151.187 280.556C151.213 280.326 150.971 280.114 150.647 280.082C150.322 280.051 150.038 280.211 150.012 280.44C149.986 280.67 150.145 280.453 150.469 280.485Z",
    fill: "#F3CEB9"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M150.081 280.238C150.405 280.27 150.772 280.538 150.798 280.308C150.825 280.079 150.583 279.867 150.259 279.835C149.934 279.803 149.65 279.963 149.624 280.193C149.598 280.422 149.756 280.206 150.081 280.238Z",
    fill: "#F3CEB9"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M152.303 279.968C152.548 279.773 153.013 279.713 152.847 279.538C152.68 279.363 152.346 279.379 152.1 279.573C151.854 279.767 151.79 280.066 151.957 280.241C152.123 280.416 152.057 280.162 152.303 279.968Z",
    fill: "#F3CEB9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.149 309.645L129.888 307.835L132.608 185.763L213.868 187.574L211.149 309.645Z",
    fill: "black",
    fillOpacity: 0.1
  })))), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M166.669 197.093C166.669 198.855 166.765 200.283 168.856 200.283C170.946 200.283 175.434 202.045 175.434 200.283C175.434 198.521 172.354 196.834 170.264 196.834C168.173 196.834 166.669 195.331 166.669 197.093Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M167.021 196.291C167.021 197.102 166.618 199.468 167.576 199.468C168.533 199.468 176.847 201.857 175.341 199.468C162.161 200.649 170.801 196.684 169.844 196.684C168.886 196.684 167.021 195.479 167.021 196.291Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M163.862 196.607C163.85 198.369 163.743 199.796 161.653 199.781C159.562 199.766 155.063 201.496 155.075 199.734C155.088 197.972 158.179 196.307 160.269 196.322C162.36 196.337 163.875 194.845 163.862 196.607Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M163.516 195.802C163.51 196.614 163.896 198.982 162.938 198.975C161.981 198.968 153.651 201.298 155.173 198.919C168.345 200.195 159.733 196.168 160.69 196.175C161.648 196.182 163.521 194.99 163.516 195.802Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M160.823 159.576H175.255C174.359 177.401 171.985 184.851 169.983 197.166H166.143C163.115 182.674 176.524 179.524 160.823 159.576Z",
    fill: "#F0AA95"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M174.648 160.494L160.371 158.438C158.697 176.341 159.976 184.108 160.188 196.674L163.986 197.221C169.063 183.201 156.251 178.149 174.648 160.494Z",
    fill: "#F0AA95"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M162.79 136.598C159.766 138.305 161.564 142.929 164.947 142.145L185.078 137.481C187.077 137.018 186.982 134.14 184.957 133.809C184.785 133.781 184.609 133.777 184.435 133.798L163.914 136.231C163.519 136.278 163.137 136.402 162.79 136.598Z",
    fill: "#F3CEB9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M160.902 138.51C160.776 134.221 163.809 130.076 168.099 130.076C172.241 130.076 175.277 133.937 175.003 138.07C174.444 146.493 176.187 153.002 176.187 161.69C172.235 161.203 168.679 171.089 158.231 161.263C158.677 151.743 161.12 145.905 160.902 138.51Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M171.305 133.976C171.305 139.184 173.141 137.177 168.268 137.177C163.396 137.177 164.716 139.184 164.716 133.976C164.716 128.769 163.396 124.547 168.268 124.547C173.141 124.547 171.305 128.769 171.305 133.976Z",
    fill: "#F3CEB9"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.543 128.174C168.735 128.663 167.722 128.663 166.914 128.174L164.644 126.798C162.448 125.467 163.391 122.091 165.958 122.091H170.498C173.066 122.091 174.009 125.467 171.813 126.798L169.543 128.174Z",
    fill: "#E4CFB0"
  }))), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M162.686 115.706C159.831 122.358 169.186 128.495 164.991 134.903C166.497 128.506 158.591 122.358 161.446 115.706C164.301 109.054 167.072 107.174 172.007 109.293C176.943 111.411 165.541 109.054 162.686 115.706Z",
    fill: "#F7E2BE"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M172.243 118.438C175.098 125.09 165.743 131.228 169.938 137.635C168.432 131.238 178.713 123.666 175.858 117.014C173.003 110.362 167.274 107.51 162.339 109.629C157.403 111.747 169.388 111.786 172.243 118.438Z",
    fill: "#F7E2BE"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M174.065 118.438C176.92 125.09 167.564 131.227 171.76 137.635C170.253 131.238 178.438 124.014 175.583 117.362C172.728 110.709 169.096 107.51 164.16 109.629C159.225 111.747 171.209 111.786 174.065 118.438Z",
    fill: "#F7E2BE"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M175.796 119.267C173.974 125.748 173.996 127.116 168.217 127.116C162.439 127.116 163.339 125.943 160.639 119.267C160.639 113.937 164.032 109.616 168.217 109.616C172.403 109.616 175.796 113.937 175.796 119.267Z",
    fill: "#F3CEB9"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M160.556 137.195C162.597 138.858 165.309 136.192 163.682 134.123L153.557 121.25C152.794 120.279 151.235 120.893 151.339 122.124C151.355 122.317 151.416 122.504 151.517 122.669L160.069 136.637C160.199 136.849 160.363 137.038 160.556 137.195Z",
    fill: "#F3CEB9"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M153.728 121.283C153.254 122.715 151.129 122.32 151.201 120.813L151.556 113.397C151.586 112.775 152.395 112.556 152.734 113.078C152.787 113.159 152.82 113.25 152.832 113.345L153.784 120.709C153.809 120.902 153.79 121.098 153.728 121.283Z",
    fill: "#F3CEB9"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M154.768 111.945C154.053 111.295 153.224 112.736 152.823 112.372C152.112 113.155 152.447 114.172 152.667 115.046C153.382 115.696 152.615 114.006 153.326 113.223C154.037 112.44 155.484 112.595 154.768 111.945Z",
    fill: "#F3CEB9"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M152.841 110.321C152.07 110.563 152.608 112.835 152.176 112.97C152.441 113.814 151.921 114.562 152.644 114.773C153.414 114.531 152.682 114.989 152.922 113.773C152.657 112.93 153.611 110.079 152.841 110.321Z",
    fill: "#F3CEB9"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M152.317 110.48C151.587 110.789 152.326 112.955 151.917 113.128C152.255 113.926 151.818 114.705 152.543 114.843C153.273 114.535 153.06 113.845 152.723 113.046C152.385 112.248 153.046 110.172 152.317 110.48Z",
    fill: "#F3CEB9"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 110.914C151.191 111.203 152.223 112.467 151.313 113.149C151.63 113.782 151.631 114.097 152.229 114.171C152.808 113.882 152.599 113.33 152.282 112.697C151.965 112.064 152.348 110.624 151.77 110.914Z",
    fill: "#F3CEB9"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M151.519 111.128C151.188 111.4 151.428 113.02 151.441 113.513C151.739 113.876 151.638 113.794 152.035 113.755C152.366 113.483 152.276 113.102 151.853 112.795C151.556 112.433 151.85 110.857 151.519 111.128Z",
    fill: "#F3CEB9"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M152.837 112.099C152.848 111.68 152.504 111.337 152.084 111.348C151.802 111.356 151.549 111.526 151.435 111.783L151.384 111.898C151.321 112.039 151.294 112.195 151.307 112.349L151.438 114.005C151.442 114.064 151.476 114.118 151.527 114.147C151.563 114.168 151.605 114.176 151.647 114.17L151.945 114.122C152.434 114.044 152.799 113.628 152.811 113.133L152.837 112.099Z",
    fill: "#F3CEB9"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M183.15 136.314C183.627 138.289 186.518 138.013 186.613 135.983L187.052 126.555C187.089 125.745 186.074 125.355 185.56 125.981C185.479 126.079 185.422 126.193 185.392 126.316L183.151 135.484C183.084 135.756 183.084 136.041 183.15 136.314Z",
    fill: "#F3CEB9"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M183.134 124.257C184.135 123.533 184.983 125.482 185.544 125.076C186.336 126.172 185.793 127.388 185.39 128.467C184.389 129.192 185.576 127.181 184.784 126.085C183.992 124.989 182.132 124.981 183.134 124.257Z",
    fill: "#F3CEB9"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M185.42 120.473C186.365 120.89 185.359 123.7 185.888 123.933C185.432 124.967 185.987 125.992 185.038 126.157C184.093 125.74 184.384 124.845 184.84 123.811C185.296 122.777 184.475 120.056 185.42 120.473Z",
    fill: "#F3CEB9"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M186.469 120.819C187.352 121.315 186.106 123.962 186.601 124.24C186.058 125.206 186.503 126.258 185.562 126.33C184.679 125.835 185.047 124.988 185.589 124.022C186.131 123.056 185.587 120.324 186.469 120.819Z",
    fill: "#F3CEB9"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M187.374 121.057C188.068 121.507 186.45 123.352 187.508 124.348C187.016 125.107 187.118 125.493 186.347 125.502C185.653 125.053 185.997 124.382 186.489 123.622C186.982 122.863 186.68 120.607 187.374 121.057Z",
    fill: "#F3CEB9"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M187.67 122.236C188.052 122.628 187.478 125.135 187.391 125.76C186.962 126.179 187.141 125.606 186.641 125.499C186.259 125.107 186.428 124.635 187.009 124.306C187.438 123.887 187.287 121.843 187.67 122.236Z",
    fill: "#F3CEB9"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M161.347 133.678C163.867 135.283 163.556 136.508 164.134 139.229",
    stroke: "black",
    strokeWidth: 2.94238
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M185.565 124.727C185.611 124.192 186.097 123.805 186.629 123.88C186.986 123.93 187.283 124.181 187.392 124.525L187.44 124.677C187.5 124.866 187.512 125.067 187.474 125.262L187.072 127.347C187.058 127.422 187.008 127.485 186.939 127.515C186.89 127.537 186.835 127.541 186.784 127.527L186.411 127.424C185.8 127.256 185.397 126.675 185.451 126.044L185.565 124.727Z",
    fill: "#F3CEB9"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M160.434 118.593C159.489 119.153 161.026 119.507 160.434 120.154",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M176.327 116.546C177.272 117.106 175.735 117.46 176.327 118.107",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M161.37 115.726C158.515 122.378 167.871 128.515 163.675 134.923C165.182 128.526 157.64 121.521 160.495 114.869C163.35 108.216 165.629 107.076 170.564 109.194C175.5 111.313 164.226 109.073 161.37 115.726Z",
    fill: "#F7E2BE"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 115.23C160.067 121.882 171.104 139.451 161.453 137.362C162.96 130.965 157.405 120.238 160.26 113.586C163.115 106.934 166.318 107.929 171.253 110.047C176.189 112.165 164.693 112.048 162.922 115.23Z",
    fill: "#F7E2BE"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M169.214 128.373C168.608 128.74 167.848 128.74 167.242 128.373L162.701 125.621C161.055 124.623 161.762 122.091 163.687 122.091H172.77C174.695 122.091 175.402 124.623 173.756 125.621L169.214 128.373Z",
    fill: "#F3CEB9"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M163.016 122.758C162.04 132.288 164.173 132.97 164.908 132.709C163.656 133.154 161.674 134.138 160.609 120.871C161.227 112.545 161.609 113.864 162.862 113.419C164.114 112.975 163.016 116.448 163.016 122.758Z",
    fill: "#F7E2BE"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M173.855 116.253C176.711 122.905 165.766 139.841 175.417 137.752C173.91 131.355 179.291 122.905 176.436 116.253C173.581 109.601 170.231 105.058 165.295 107.176C160.36 109.295 171 109.601 173.855 116.253Z",
    fill: "#F7E2BE"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M162.276 113.391C161.035 117.029 167.764 137.884 159.097 137.298C163.367 133.101 156.419 116.188 163.119 113.391C164.36 109.753 159.092 113.782 160.52 114.269C161.948 114.756 163.518 109.753 162.276 113.391Z",
    fill: "#F7E2BE"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M162.829 131.637C156.554 128.913 166.581 118.252 160.357 115.115",
    stroke: "#F7E2BE",
    strokeWidth: 1.9515
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M170.766 124.201C170.766 124.039 169.245 124.201 168.319 124.201C167.393 124.201 165.659 123.914 165.659 124.076C165.659 124.238 167.393 124.844 168.319 124.844C169.245 124.844 170.766 124.362 170.766 124.201Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M170.733 124.124C170.733 123.962 169.18 124.027 168.254 124.027C167.328 124.027 165.757 123.962 165.757 124.124C165.757 124.286 167.328 125.523 168.254 125.523C169.18 125.523 170.733 124.286 170.733 124.124Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M170.896 124.111C170.896 124.272 169.36 125.816 168.228 125.816C167.097 125.816 165.464 124.15 165.464 123.989C165.464 123.827 167.097 125.425 168.228 125.425C169.36 125.425 170.896 123.949 170.896 124.111Z",
    fill: "#DE4C66"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M170.993 124.151C170.993 123.99 169.399 123.468 168.261 123.826C167.318 123.533 165.464 123.827 165.464 123.989C165.464 124.15 167.129 124.151 168.261 124.151C169.393 124.151 170.993 124.313 170.993 124.151Z",
    fill: "#DE4C66"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M167.513 117.782C167.513 118.267 166.665 117.522 165.659 117.522C164.653 117.522 164.326 117.782 163.838 118.14C163.838 117.655 164.653 117.261 165.659 117.261C166.665 117.261 167.513 117.297 167.513 117.782Z",
    fill: "#C4B397"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M169.464 117.814C169.464 118.299 170.377 117.652 171.383 117.652C172.389 117.652 172.717 117.912 173.205 118.27C173.205 117.785 172.389 117.392 171.383 117.392C170.377 117.392 169.464 117.329 169.464 117.814Z",
    fill: "#C4B397"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M167.41 121.484C166.402 122.297 167.168 122.603 167.645 122.347",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M168.852 121.486C169.861 122.299 169.172 122.604 168.695 122.347",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M167.447 122.379C167.555 122.379 167.642 122.35 167.642 122.314C167.642 122.278 167.555 122.249 167.447 122.249C167.339 122.249 167.252 122.278 167.252 122.314C167.252 122.35 167.339 122.379 167.447 122.379Z",
    fill: "black"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M168.89 122.379C168.998 122.379 169.085 122.35 169.085 122.314C169.085 122.278 168.998 122.249 168.89 122.249C168.782 122.249 168.695 122.278 168.695 122.314C168.695 122.35 168.782 122.379 168.89 122.379Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M170.029 119.203C170.408 119.356 170.579 119.443 171.22 119.362C171.862 119.282 172.394 119.248 172.352 118.911C171.884 118.646 171.756 118.367 171.114 118.448C170.472 118.528 170.463 118.868 170.029 119.203Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M171.249 119.354C171.5 119.354 171.704 119.15 171.704 118.899C171.704 118.647 171.5 118.444 171.249 118.444C170.997 118.444 170.793 118.647 170.793 118.899C170.793 119.15 170.997 119.354 171.249 119.354Z",
    fill: "url(#paint2_radial_57_182)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M170.029 119.203C170.408 119.356 170.472 118.773 171.114 118.693C171.756 118.612 172.394 119.248 172.352 118.911C171.884 118.646 171.756 118.367 171.114 118.448C170.472 118.528 170.463 118.868 170.029 119.203Z",
    fill: "black"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M172.401 118.735L172.271 118.865",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M172.265 118.549L172.161 118.763",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M172.133 118.424L172.05 118.71",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M172.003 118.359L171.92 118.645",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M171.807 118.299L171.771 118.595",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M171.676 118.234L171.641 118.53",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M171.538 118.17L171.52 118.468",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M171.33 118.176L171.355 118.473",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M171.13 118.176L171.156 118.473",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M170.935 118.176L170.96 118.473",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M170.572 118.442L170.637 118.664",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M170.443 118.641L170.508 118.785",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M170.315 118.776L170.38 118.877",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M170.118 119.034L170.164 119.124",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M170.185 118.906L170.25 119.007",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M170.713 118.309L170.766 118.602",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M166.564 119.081C166.184 119.234 166.014 119.321 165.372 119.241C164.73 119.16 164.198 119.126 164.24 118.79C164.708 118.524 164.837 118.246 165.478 118.326C166.12 118.407 166.129 118.747 166.564 119.081Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M165.343 119.233C165.092 119.233 164.888 119.029 164.888 118.778C164.888 118.526 165.092 118.323 165.343 118.323C165.594 118.323 165.798 118.526 165.798 118.778C165.798 119.029 165.594 119.233 165.343 119.233Z",
    fill: "url(#paint3_radial_57_182)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M166.564 119.081C166.184 119.234 166.12 118.651 165.478 118.571C164.837 118.49 164.198 119.126 164.24 118.79C164.708 118.524 164.837 118.246 165.478 118.326C166.12 118.407 166.129 118.747 166.564 119.081Z",
    fill: "black"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M164.191 118.614L164.321 118.744",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M164.328 118.427L164.431 118.641",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M164.459 118.302L164.542 118.589",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M164.59 118.237L164.673 118.524",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M164.786 118.178L164.821 118.474",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M164.916 118.112L164.951 118.409",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M165.055 118.049L165.072 118.346",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M165.263 118.054L165.237 118.351",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M165.462 118.054L165.436 118.351",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M165.657 118.054L165.632 118.351",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M166.02 118.321L165.955 118.543",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M166.149 118.52L166.084 118.664",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M166.277 118.654L166.212 118.756",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M166.474 118.911L166.428 119.002",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M166.407 118.784L166.342 118.886",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M165.879 118.187L165.826 118.481",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M165.497 123.994C165.36 123.962 165.278 123.904 165.216 123.831",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M165.153 123.977C165.205 123.847 165.275 123.774 165.356 123.723",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M170.807 124.189C170.943 124.157 171.025 124.099 171.088 124.027",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M171.15 124.172C171.098 124.042 171.028 123.969 170.948 123.918",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.617 122.595C172.12 122.595 172.527 122.173 172.527 121.652C172.527 121.131 172.12 120.709 171.617 120.709C171.114 120.709 170.706 121.131 170.706 121.652C170.706 122.173 171.114 122.595 171.617 122.595Z",
    fill: "#E99985"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.111 122.53C165.614 122.53 166.022 122.108 166.022 121.587C166.022 121.066 165.614 120.644 165.111 120.644C164.608 120.644 164.2 121.066 164.2 121.587C164.2 122.108 164.608 122.53 165.111 122.53Z",
    fill: "#E99985"
  }))), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M167.645 122.347C168.03 122.797 168.259 122.772 168.695 122.347",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M154.088 110.129L150.959 111.951C150.646 112.133 150.54 112.535 150.722 112.848L150.987 113.302C151.169 113.615 151.57 113.721 151.883 113.539L155.013 111.717C155.326 111.535 155.432 111.133 155.25 110.82L154.985 110.366C154.803 110.053 154.402 109.947 154.088 110.129Z",
    fill: "#EE8B17"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M150.014 111.793L148.904 112.439C148.591 112.621 148.485 113.023 148.667 113.336L149.554 114.859C149.736 115.173 150.138 115.279 150.451 115.096L151.561 114.45C151.874 114.268 151.98 113.866 151.797 113.553L150.911 112.03C150.728 111.717 150.327 111.611 150.014 111.793Z",
    fill: "black"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M153.727 106.95L152.916 107.429C152.572 107.631 152.458 108.073 152.66 108.417L154.46 111.468C154.662 111.812 155.104 111.926 155.448 111.723L156.259 111.245C156.602 111.043 156.717 110.6 156.514 110.257L154.715 107.205C154.513 106.862 154.07 106.748 153.727 106.95Z",
    fill: "#EE8B17"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M152.493 105.311L152.063 105.565C151.719 105.767 151.605 106.209 151.807 106.553L152.311 107.408C152.514 107.751 152.956 107.865 153.3 107.663L153.73 107.409C154.074 107.206 154.188 106.764 153.985 106.421L153.481 105.566C153.279 105.222 152.836 105.108 152.493 105.311Z",
    fill: "#ACACAC"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M151.692 104.148C151.653 104.081 151.566 104.058 151.498 104.098C151.431 104.138 151.408 104.225 151.448 104.292L152.541 106.146C152.581 106.213 152.668 106.236 152.735 106.196C152.803 106.156 152.825 106.069 152.785 106.002L151.692 104.148Z",
    fill: "#ACACAC"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M153.221 110.364C153.546 110.337 153.919 110.052 153.94 110.304C153.961 110.557 153.715 110.784 153.39 110.811C153.065 110.838 152.775 110.773 152.754 110.52C152.733 110.267 152.896 110.391 153.221 110.364Z",
    fill: "#F3CEB9"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M152.696 110.758C153.021 110.731 153.394 110.445 153.415 110.698C153.436 110.951 153.19 111.178 152.865 111.205C152.54 111.232 152.259 111.049 152.238 110.796C152.217 110.543 152.371 110.785 152.696 110.758Z",
    fill: "#F3CEB9"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M152.302 110.955C152.627 110.928 153 110.642 153.021 110.895C153.042 111.148 152.796 111.374 152.471 111.402C152.146 111.429 151.866 111.246 151.845 110.993C151.824 110.74 151.977 110.982 152.302 110.955Z",
    fill: "#F3CEB9"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M151.909 111.217C152.234 111.19 152.607 110.905 152.628 111.157C152.649 111.41 152.403 111.637 152.078 111.664C151.753 111.691 151.472 111.508 151.451 111.255C151.43 111.003 151.584 111.244 151.909 111.217Z",
    fill: "#F3CEB9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M154.124 111.568C154.365 111.788 154.829 111.866 154.658 112.053C154.488 112.241 154.154 112.216 153.912 111.996C153.671 111.777 153.613 111.447 153.784 111.26C153.954 111.072 153.882 111.349 154.124 111.568Z",
    fill: "#F3CEB9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_57_182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_57_182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 251,
    y: 197,
    width: 61,
    height: 114
  }, _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M284.822 285.35C283.541 280.598 285.39 282.064 281.794 283.034C278.197 284.003 278.678 281.909 279.959 286.66C281.24 291.412 281.303 295.527 284.899 294.558C288.496 293.589 286.103 290.102 284.822 285.35Z",
    fill: "#E4BDA7"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M296.593 283.882C296.04 285.355 294.543 285.879 293.25 285.053L283.992 279.141C283.195 278.632 282.581 277.758 282.307 276.74C281.435 273.507 284.224 271.085 286.642 272.975L295.474 279.877C296.624 280.776 297.109 282.509 296.593 283.882Z",
    fill: "#D37D64"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M293.827 285.276C291.042 281.92 294.308 278.748 296.516 281.877",
    stroke: "#EDE7D9",
    strokeWidth: 0.656017
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M292.805 283.134C292.672 280.095 296.202 279.658 297.103 282.602L302.177 299.184C302.65 300.729 301.061 301.701 300.158 300.419C300.092 300.325 300.034 300.223 299.987 300.115L293.08 284.313C292.917 283.941 292.823 283.538 292.805 283.134Z",
    fill: "#E4BDA7"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M260.051 203.718C259.512 201.716 258.986 200.117 257.074 200.632C255.161 201.148 250.516 200.253 251.056 202.254C251.595 204.256 254.721 205.502 256.634 204.986C258.546 204.471 260.591 205.719 260.051 203.718Z",
    fill: "#A8A5A5"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M259.523 203.86C258.984 201.858 258.635 200.212 260.548 199.696C262.46 199.181 266.026 196.073 266.565 198.074C267.105 200.076 264.804 202.752 262.892 203.268C260.979 203.783 260.063 205.861 259.523 203.86Z",
    fill: "#A8A5A5"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M260.081 204.67C259.834 203.753 258.747 201.178 259.618 200.943C260.488 200.709 267.317 195.972 266.676 199.041C254.336 200.934 264.45 203.294 263.58 203.528C262.71 203.763 260.328 205.587 260.081 204.67Z",
    fill: "#737373"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M260.002 204.692C259.755 203.774 259.4 201.002 258.53 201.236C257.66 201.471 249.375 200.807 251.472 203.139C263.092 198.575 255.779 205.185 256.65 204.95C257.52 204.716 260.249 205.609 260.002 204.692Z",
    fill: "#737373"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M266.062 254.876L280.419 251.007L263.524 203.034L256.562 204.91L266.062 254.876Z",
    fill: "#70A0AF"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M274.407 253.126C274.167 252.236 276.788 250.33 278.484 249.873C280.18 249.416 280.308 250.581 280.548 251.471C280.788 252.361 279.055 251.402 277.359 251.859C275.663 252.316 274.646 254.016 274.407 253.126Z",
    fill: "#D37D64"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M260.172 203.94L273.706 252.819",
    stroke: "black",
    strokeOpacity: 0.03,
    strokeWidth: 0.656017
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M272.527 277.366C273.489 281.75 277.257 284.648 280.764 283.703L282.559 283.219C285.927 282.311 287.748 278.201 286.626 274.038L280.419 251.007L266.062 254.876L269.536 264.19C269.694 264.613 269.823 265.049 269.92 265.491L272.527 277.366Z",
    fill: "#D37D64"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M267.9 264.952C266.597 265.356 266.12 267.202 266.949 268.637L273.549 280.058C273.616 280.175 273.714 280.263 273.824 280.306C274.186 280.447 274.493 280.068 274.365 279.636L270.564 266.768C270.169 265.432 268.977 264.62 267.9 264.952Z",
    fill: "#D37D64"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M265.932 257.895C266.596 254.466 269.455 252.608 272.318 253.745C275.181 254.883 276.964 258.585 276.3 262.014C275.636 265.444 272.776 267.302 269.913 266.165C267.05 265.027 265.268 261.325 265.932 257.895Z",
    fill: "#BAD8BA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M271.203 247.698C268.823 247.716 270.986 252.388 270.581 254.479C270.176 256.57 268.791 255.997 270.427 256.647C272.063 257.297 276.985 258.749 277.39 256.658C277.795 254.566 272.504 247.688 271.203 247.698Z",
    fill: "#BAD8BA"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M274.528 250.846C271.184 245.461 265.818 243.794 265.346 255.155C264.508 261.54 268.463 267.198 269.154 263.634C271.583 262.896 275.749 261.835 276.414 258.406C277.078 254.977 274.778 252.71 274.528 250.846Z",
    fill: "#BAD8BA"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M280.041 265.761C280.179 265.046 280.766 264.656 281.353 264.889C281.939 265.121 282.302 265.889 282.164 266.604C282.025 267.318 281.438 267.709 280.852 267.476C280.265 267.243 279.902 266.475 280.041 265.761Z",
    fill: "#BAD8BA"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M277.333 261.661C275.947 262.433 273.141 266.518 275.952 265.87C278.454 265.718 279.3 266.704 279.431 266.85C281.273 268.884 279.141 262.261 281.323 263.533C280.505 261.727 278.718 260.89 277.333 261.661Z",
    fill: "#BAD8BA"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M278.774 260.768C275.911 259.631 273.052 261.489 272.388 264.918C271.19 268.22 275.359 264.953 278.222 266.091C281.149 263.879 277.688 265.414 277.495 263.944C277.394 260.344 281.637 261.906 278.774 260.768Z",
    fill: "#BAD8BA"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M278.813 254.251C278.836 257.294 267.851 256.358 267.187 259.787C266.523 263.217 267.504 268.582 276.603 265.664C279.848 261.535 282.316 264.444 282.98 261.015C284.767 260.3 282.229 261.46 278.813 254.251Z",
    fill: "#BAD8BA"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M278.412 254.68C276.012 253.727 272.266 250.721 273.059 258.157C272.651 263.01 268.327 265.844 272.509 263.883C278.13 263.546 282.806 268.778 283.363 265.904C283.236 254.615 280.91 260.037 278.412 254.68Z",
    fill: "#BAD8BA"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M280.584 253.344C276.571 252.926 277.767 253.753 277.435 255.468C277.103 257.183 277.994 259.034 279.425 259.603C280.857 260.171 282.05 259.365 282.382 257.65C285.906 256.202 282.539 253.548 280.584 253.344Z",
    fill: "#BAD8BA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M282.592 254.235C279.851 253.146 279.621 257.493 279.289 259.208C278.957 260.923 278.217 260.764 282.276 260.395C282.939 257.933 283.628 257.804 283.884 256.482C284.035 255.706 283.475 254.586 282.592 254.235Z",
    fill: "#BAD8BA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M270.544 247.529C268.759 245.489 266.608 247.536 265.944 250.965C265.28 254.395 267.063 258.097 269.926 259.235C272.789 260.372 275.648 258.514 276.312 255.084C276.094 250.446 273.705 252.624 270.544 247.529Z",
    fill: "#BAD8BA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M283.114 263.483C282.793 263.356 282.454 263.393 282.172 263.589C280.401 262.25 285.156 269.96 285.824 269.668C283.495 271.808 278.894 266.326 279.223 266.55C279.395 266.926 282.203 266.403 282.523 266.53L282.819 265.006L283.114 263.483Z",
    fill: "#BAD8BA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M308.292 270.606C308.461 269.733 309.229 269.276 310.006 269.584C310.783 269.893 311.276 270.851 311.106 271.724C310.937 272.598 310.17 273.055 309.393 272.747C308.616 272.438 308.123 271.48 308.292 270.606Z",
    fill: "#D9D0B2"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M304.475 267.666C304.42 267.953 304.168 269.526 302.632 268.946C303.004 269.496 303.714 270.707 304.491 271.016C305.268 271.324 307.902 272.073 308.071 271.2C308.096 270.25 306.552 268.336 304.475 267.666Z",
    fill: "#D9D0B2"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M283.045 258.347C282.529 259.226 272.618 255.629 280.282 255.454C277.609 254.98 280.613 263.418 281.663 263.835C282.713 264.253 285.938 261.664 285.222 261.379C283.42 260.663 282.19 259.803 283.045 258.347Z",
    fill: "#BAD8BA"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M283.31 263.819L283.3 263.865C283.273 263.991 283.164 264.056 283.055 264.01L281.29 263.258C281.182 263.212 281.116 263.072 281.143 262.946L281.153 262.9C281.18 262.774 281.29 262.709 281.398 262.756L283.163 263.507C283.271 263.553 283.337 263.693 283.31 263.819Z",
    fill: "#C4C4C4"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M284.217 263.55C282.745 262.965 281.293 265.608 281.617 267.501C281.251 269.391 283.831 270.208 284.351 270.135C288.03 270.08 284.246 267.246 283.955 265.179C283.957 263.384 285.844 265.032 284.217 263.55Z",
    fill: "#BAD8BA"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M302.147 271.043L302.557 268.924L281.967 259.931L281.388 262.921L302.147 271.043Z",
    fill: "url(#paint4_linear_57_182)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M310.458 271.595L310.47 271.998C310.483 272.467 310.177 272.819 309.785 272.784L303.107 272.198C302.716 272.163 302.389 271.756 302.375 271.287L302.364 270.884C302.351 270.415 302.657 270.063 303.048 270.098L309.726 270.685C310.117 270.719 310.445 271.127 310.458 271.595Z",
    fill: "#D9D0B2"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M276.835 253.211C275.35 252.782 273.983 249.267 273.327 249.501C272.67 249.736 275.553 254.746 276.344 255.06C277.135 255.374 279.543 254.193 279.647 253.653C280.782 252.871 277.638 253.444 276.835 253.211Z",
    fill: "#BAD8BA"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M302.818 269.082C302.473 268.666 302.501 269.484 302.357 270.23C302.212 270.976 302.338 271.678 302.638 271.797C302.938 271.916 303.687 270.912 303.831 270.166C303.976 269.419 302.865 269.255 302.818 269.082Z",
    fill: "#D9D0B2"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M303.052 269.113L302.64 271.24L302.146 271.044L302.558 268.917L303.052 269.113Z",
    fill: "#D9D0B2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M307.664 271.877C307.773 272.046 307.977 272.058 308.07 271.901L309.034 270.267C309.183 270.015 308.918 269.658 308.688 269.802L308.118 270.156C308.033 270.209 307.923 270.193 307.84 270.113L307.34 269.636C307.246 269.547 307.119 269.537 307.032 269.615L306.697 269.913C306.591 270.007 306.578 270.195 306.668 270.333L307.664 271.877Z",
    fill: "#D9D0B2"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M303.68 272.459C303.476 272.377 303.214 272.533 303.177 272.723C303.14 272.914 303.348 273.038 303.552 273.12C303.757 273.201 303.999 273.007 304.036 272.817C304.073 272.626 303.885 272.54 303.68 272.459Z",
    fill: "url(#paint5_linear_57_182)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M304.877 272.593C304.672 272.512 304.411 272.667 304.374 272.858C304.337 273.049 304.545 273.174 304.749 273.255C304.954 273.336 305.196 273.142 305.233 272.952C305.27 272.761 305.082 272.675 304.877 272.593Z",
    fill: "url(#paint6_linear_57_182)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M305.981 272.661C305.776 272.579 305.514 272.734 305.477 272.925C305.441 273.116 305.648 273.24 305.852 273.322C306.057 273.403 306.3 273.209 306.337 273.019C306.373 272.828 306.185 272.742 305.981 272.661Z",
    fill: "url(#paint7_linear_57_182)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M307.073 272.785C306.868 272.703 306.606 272.859 306.57 273.049C306.533 273.24 306.74 273.365 306.945 273.446C307.149 273.527 307.392 273.333 307.429 273.143C307.466 272.952 307.277 272.866 307.073 272.785Z",
    fill: "url(#paint8_linear_57_182)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M308.176 272.852C307.972 272.771 307.71 272.926 307.673 273.116C307.636 273.307 307.844 273.432 308.048 273.513C308.253 273.594 308.495 273.4 308.532 273.21C308.569 273.019 308.381 272.933 308.176 272.852Z",
    fill: "url(#paint9_linear_57_182)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M309.28 272.919C309.075 272.837 308.814 272.993 308.777 273.183C308.74 273.374 308.947 273.499 309.152 273.58C309.356 273.661 309.599 273.467 309.636 273.277C309.673 273.086 309.484 273 309.28 272.919Z",
    fill: "url(#paint10_linear_57_182)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M281.028 260.048C280.378 256.12 278.654 256.875 276.585 254.045C271.287 265.295 274.646 259.469 279.694 265.541C279.406 265.265 283.883 270.252 284.286 267.619C283.124 265.402 280.371 264.337 281.028 260.048Z",
    fill: "#EDE7D9"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M282.805 263.49C281.525 263.012 278.993 261.933 280.422 263.339C280.634 265.381 284.03 268.248 284.202 267.948C284.687 266.816 283.041 266.788 282.829 264.745C282.69 263.413 285.112 264.351 282.805 263.49Z",
    fill: "#EDE7D9"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M281.932 263.316L281.9 261.691L282.401 260.249L281.091 259.801L280.621 262.868L281.932 263.316Z",
    fill: "#EDE7D9"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M283.127 255.906C282.658 255.745 281.95 256.528 281.806 257.464C281.663 258.4 278.772 258.439 282.774 260.146C283.314 260.377 281.943 259.923 282.086 258.987C282.259 257.857 283.494 257.012 283.127 255.906Z",
    fill: "#EDE7D9"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M278.787 254.5C274.737 257.954 278.504 255.019 278.302 256.336C278.1 257.654 278.795 259.015 279.854 259.378C280.912 259.74 281.32 257.638 283.134 256.464C283.621 254.449 279.463 253.924 278.787 254.5Z",
    fill: "#EDE7D9"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M281.997 258.556L281.597 261.169L280.335 260.738L280.735 258.125L281.997 258.556Z",
    fill: "#EDE7D9"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M282.401 260.249L282.465 259.951L281.752 259.489L281.673 260L282.401 260.249Z",
    fill: "#EDE7D9"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M282.872 260.325L282.897 260.206L282.097 259.761L282.062 259.976L282.872 260.325Z",
    fill: "#EDE7D9"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M275.483 253.4C274.103 252.927 273.112 253.044 273.031 253.577C272.949 254.11 274.002 254.925 275.382 255.397C276.762 255.869 280.033 255.039 280.115 254.505C280.122 253.79 277.588 255.165 275.483 253.4Z",
    fill: "#EDE7D9"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M275.645 253.515C274.3 252.457 271.962 248.716 271.691 250.489C271.419 252.261 273.251 255.304 274.609 255.611C276.929 256.136 277.42 259.096 277.692 257.323C277.963 255.55 279.2 256.644 275.645 253.515Z",
    fill: "#EDE7D9"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M275.459 253.392C274.963 253.222 274.458 253.758 274.331 254.59C274.204 255.421 273.882 254.018 273.334 254.428C270.759 250.738 274.492 257.373 274.619 256.542C274.747 255.71 275.955 253.561 275.459 253.392Z",
    fill: "#EDE7D9"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M276.311 254.998L275.372 261.132L273.916 260.634L274.855 254.5L276.311 254.998Z",
    fill: "#EDE7D9"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M271.152 254.442C269.849 253.97 268.603 254.718 268.369 256.112C268.135 257.506 269.002 259.019 270.304 259.49C271.607 259.962 271.587 258.756 271.821 257.363C272.055 255.968 272.455 254.914 271.152 254.442Z",
    fill: "url(#paint11_linear_57_182)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M303.448 271.438C303.469 271.343 303.551 271.295 303.633 271.33C303.714 271.364 303.763 271.469 303.743 271.564C303.723 271.658 303.64 271.707 303.559 271.672C303.477 271.637 303.428 271.532 303.448 271.438Z",
    fill: "#9E9D9D"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M304.652 271.578C304.672 271.483 304.754 271.435 304.836 271.47C304.917 271.504 304.966 271.609 304.946 271.704C304.926 271.798 304.843 271.846 304.762 271.812C304.681 271.777 304.631 271.672 304.652 271.578Z",
    fill: "#9E9D9D"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M305.756 271.676C305.776 271.582 305.859 271.533 305.94 271.568C306.022 271.603 306.071 271.707 306.051 271.802C306.03 271.896 305.948 271.945 305.866 271.91C305.785 271.875 305.736 271.771 305.756 271.676Z",
    fill: "#9E9D9D"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M306.837 271.889C306.857 271.794 306.939 271.746 307.021 271.78C307.102 271.815 307.152 271.92 307.131 272.014C307.111 272.109 307.028 272.157 306.947 272.123C306.866 272.088 306.816 271.983 306.837 271.889Z",
    fill: "#9E9D9D"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M308.052 271.972C308.072 271.878 308.155 271.829 308.236 271.864C308.317 271.899 308.367 272.004 308.346 272.098C308.326 272.193 308.244 272.241 308.162 272.206C308.081 272.172 308.032 272.067 308.052 271.972Z",
    fill: "#9E9D9D"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M309.156 272.071C309.177 271.976 309.259 271.928 309.341 271.962C309.422 271.997 309.471 272.102 309.451 272.196C309.431 272.291 309.348 272.339 309.267 272.305C309.185 272.27 309.136 272.165 309.156 272.071Z",
    fill: "#9E9D9D"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M303.454 271.409L270.672 258.587",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M304.62 271.471L270.795 258.016",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M306.02 271.696L270.918 257.446",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M306.978 271.731L271.066 256.762",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M308.021 271.865L271.201 256.135",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M309.175 271.985L271.312 255.622",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M300.667 270.44L301.085 268.308",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M299.345 269.881L299.762 267.749",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M298.021 269.32L298.439 267.189",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M296.598 268.811L297.064 266.564",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M295.531 268.399L295.997 266.151",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M294.359 267.855L294.827 265.668",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M292.988 267.411L293.503 265.048",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M291.664 266.791L292.131 264.604",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M290.189 266.215L290.655 263.967",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M288.918 265.721L289.384 263.473",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M287.594 265.1L288.012 262.969",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M286.271 264.541L286.689 262.409",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M284.948 263.981L285.366 261.849",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M283.525 263.471L283.991 261.224",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M282.457 263.059L282.923 260.812",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M279.933 262.331L279.342 262.087C279.206 262.031 279.122 261.858 279.155 261.7L279.603 259.506C279.636 259.348 279.772 259.265 279.908 259.321L280.499 259.564C280.635 259.62 280.719 259.794 280.687 259.952L280.238 262.146C280.206 262.304 280.069 262.387 279.933 262.331Z",
    fill: "#756F62"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M276.214 260.777L275.624 260.534C275.488 260.478 275.404 260.304 275.436 260.146L275.894 257.909C275.926 257.75 276.062 257.668 276.198 257.724L276.789 257.967C276.925 258.023 277.009 258.197 276.977 258.355L276.519 260.592C276.487 260.75 276.35 260.833 276.214 260.777Z",
    fill: "#756F62"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M272.809 251.299C273.074 251.327 273.294 251.606 273.3 251.924C273.305 252.241 273.094 252.477 272.829 252.449C272.563 252.422 272.344 252.142 272.338 251.824C272.333 251.507 272.543 251.272 272.809 251.299Z",
    fill: "#070707"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M269.189 247.844C269.3 247.855 269.393 247.973 269.395 248.107C269.398 248.24 269.309 248.34 269.197 248.328C269.085 248.316 268.993 248.199 268.99 248.065C268.988 247.931 269.077 247.832 269.189 247.844Z",
    fill: "#6C6C6C"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M274.359 253.272C274.624 253.3 274.844 253.579 274.849 253.897C274.855 254.215 274.644 254.45 274.379 254.422C274.113 254.395 273.893 254.115 273.888 253.798C273.883 253.48 274.093 253.245 274.359 253.272Z",
    fill: "#070707"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M298.875 268.464C298.928 268.45 298.985 268.492 299.002 268.557C299.02 268.622 298.991 268.687 298.938 268.701C298.886 268.715 298.829 268.674 298.811 268.608C298.793 268.543 298.822 268.479 298.875 268.464Z",
    fill: "#EDE7D9"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M296.218 267.398C296.271 267.383 296.328 267.425 296.346 267.49C296.364 267.555 296.335 267.62 296.282 267.634C296.229 267.648 296.172 267.607 296.155 267.542C296.137 267.476 296.166 267.412 296.218 267.398Z",
    fill: "#EDE7D9"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M293.85 266.444C293.903 266.43 293.96 266.471 293.977 266.537C293.995 266.602 293.966 266.667 293.914 266.681C293.861 266.695 293.804 266.654 293.786 266.588C293.768 266.523 293.797 266.459 293.85 266.444Z",
    fill: "#EDE7D9"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M291.113 265.272C291.166 265.258 291.223 265.299 291.24 265.364C291.258 265.43 291.23 265.494 291.177 265.508C291.124 265.523 291.067 265.481 291.049 265.416C291.032 265.351 291.06 265.286 291.113 265.272Z",
    fill: "#EDE7D9"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M288.456 264.205C288.509 264.191 288.566 264.232 288.584 264.297C288.601 264.363 288.573 264.427 288.52 264.442C288.467 264.456 288.41 264.414 288.392 264.349C288.375 264.284 288.403 264.219 288.456 264.205Z",
    fill: "#EDE7D9"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M285.72 263.033C285.773 263.018 285.83 263.06 285.847 263.125C285.865 263.19 285.836 263.255 285.784 263.269C285.731 263.283 285.674 263.242 285.656 263.177C285.639 263.111 285.667 263.047 285.72 263.033Z",
    fill: "#EDE7D9"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M283.191 262.059C283.244 262.044 283.301 262.086 283.319 262.151C283.336 262.216 283.308 262.281 283.255 262.295C283.202 262.309 283.145 262.268 283.127 262.203C283.11 262.137 283.138 262.073 283.191 262.059Z",
    fill: "#EDE7D9"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M290.202 293.424C287.264 287.872 285.384 284.941 282.295 285.773C279.205 286.606 279.365 289.81 279.014 296.439C280.325 301.303 283.892 304.571 286.982 303.738C290.071 302.905 291.513 298.288 290.202 293.424Z",
    fill: "#E4BDA7"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M289.248 301.964C291.913 298.818 288.261 290.625 291.028 293.992C289.392 295.098 294.767 303.768 291.43 304.667C288.765 307.813 291.145 307.432 287.341 310.04C287.43 298.416 286.583 305.11 289.248 301.964Z",
    fill: "url(#paint12_linear_57_182)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M284.251 303.281C280.366 301.9 278.757 292.33 278.706 297.283C280.337 303.332 280.787 307.506 283.723 306.715C287.608 308.095 285.359 308.962 289.958 309.305C292.2 298.257 288.136 304.662 284.251 303.281Z",
    fill: "url(#paint13_linear_57_182)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M280.034 296.899C279.806 296.052 279.484 294.107 278.896 294.266C278.307 294.425 277.674 296.626 277.902 297.473C278.13 298.32 278.793 298.878 279.381 298.719C279.97 298.56 280.262 297.745 280.034 296.899Z",
    fill: "#E4BDA7"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M289.952 294.672C289.723 293.825 289.024 291.982 289.613 291.823C290.201 291.665 291.855 293.25 292.083 294.097C292.312 294.944 292.019 295.759 291.431 295.918C290.842 296.076 290.18 295.518 289.952 294.672Z",
    fill: "#E4BDA7"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M280.638 288.276C280.4 288.901 280.261 289.642 280.143 290.494C280.315 290.009 280.506 289.515 280.716 289.06C280.943 288.569 281.203 288.097 281.502 287.719C281.797 287.345 282.164 287.018 282.613 286.897C283.056 286.778 283.532 286.864 283.974 287.026C284.421 287.19 284.884 287.45 285.329 287.743C285.712 287.996 286.099 288.285 286.469 288.579C285.921 287.894 285.444 287.36 284.956 286.981C284.261 286.44 283.537 286.213 282.504 286.492C281.498 286.763 280.973 287.393 280.638 288.276Z",
    stroke: "url(#paint14_linear_57_182)",
    strokeWidth: 1.64004
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M286.52 291.703C286.386 291.205 286.007 290.802 285.473 290.567C284.939 290.333 284.266 290.275 283.584 290.459C282.901 290.643 282.348 291.031 282.005 291.502C281.66 291.974 281.536 292.512 281.67 293.01C281.705 293.139 281.742 293.21 281.773 293.247C281.799 293.279 281.827 293.294 281.866 293.296C281.91 293.298 281.97 293.283 282.05 293.244C282.129 293.205 282.219 293.147 282.321 293.074C282.39 293.025 282.465 292.97 282.544 292.91C282.926 292.625 283.422 292.253 284.023 292.091C284.624 291.929 285.241 292.001 285.714 292.056C285.813 292.067 285.905 292.078 285.989 292.086C286.114 292.097 286.221 292.102 286.308 292.096C286.397 292.09 286.457 292.073 286.494 292.048C286.527 292.027 286.543 292 286.55 291.959C286.558 291.911 286.555 291.832 286.52 291.703Z",
    fill: "white",
    stroke: "#D99584",
    strokeWidth: 0.328008
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M286.807 291.72C286.772 291.589 286.17 291.669 284.136 292.217C282.102 292.765 281.378 292.979 281.414 293.11C281.449 293.241 282.582 294.546 284.616 293.998C286.65 293.45 286.843 291.851 286.807 291.72Z",
    fill: "url(#paint15_linear_57_182)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M283.667 286.341C283.609 286.126 283.188 286.951 282.492 286.07C282.315 287.25 281.47 286.599 281.528 286.813C281.586 287.027 282.533 289.402 283.332 289.187C284.131 288.971 283.725 286.555 283.667 286.341Z",
    fill: "url(#paint16_linear_57_182)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M284.291 294.641C284.524 294.627 283.965 294.26 283.672 294.339C283.289 294.442 283.093 294.651 283.25 294.882C283.31 295.104 283.595 295.219 283.888 295.14C284.181 295.061 284.478 294.63 284.291 294.641Z",
    fill: "#F8D1BC"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 294.442C284.822 294.547 285.12 293.949 285.413 293.87C285.796 293.767 286.071 293.849 286.052 294.128C286.111 294.349 285.922 294.592 285.629 294.671C285.336 294.75 284.863 294.526 285.03 294.442Z",
    fill: "#F8D1BC"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M281.525 299.112L285.156 298.134L284.789 296.771C284.46 295.55 283.392 294.776 282.405 295.042L282.35 295.057C281.363 295.323 280.829 296.529 281.158 297.75L281.525 299.112Z",
    fill: "url(#paint17_linear_57_182)",
    stroke: "white",
    strokeWidth: 0.361241
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M286.072 297.887L289.703 296.908L289.336 295.545C289.007 294.324 287.94 293.55 286.952 293.816L286.898 293.831C285.91 294.097 285.376 295.303 285.705 296.524L286.072 297.887Z",
    fill: "url(#paint18_linear_57_182)",
    stroke: "white",
    strokeWidth: 0.361241
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M285.791 296.355C285.807 296.418 285.809 296.483 285.796 296.549C285.782 296.614 285.754 296.678 285.712 296.737C285.671 296.795 285.617 296.847 285.553 296.89C285.49 296.933 285.418 296.965 285.342 296.985C285.267 297.006 285.188 297.014 285.112 297.009C285.036 297.004 284.963 296.986 284.897 296.956C284.832 296.926 284.775 296.886 284.731 296.836C284.686 296.786 284.655 296.728 284.638 296.666L284.671 296.116C284.677 296.137 285.036 296.604 285.051 296.62C285.066 296.637 285.085 296.651 285.107 296.661C285.129 296.671 285.154 296.677 285.18 296.679C285.206 296.68 285.232 296.678 285.258 296.671C285.283 296.664 285.307 296.653 285.329 296.639C285.35 296.624 285.368 296.607 285.382 296.587C285.396 296.567 285.406 296.546 285.411 296.523C285.415 296.501 285.491 295.917 285.486 295.896L285.791 296.355Z",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M285.998 298.082L285.326 298.263L284.958 296.898L285.63 296.717L285.998 298.082Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M263.057 249.834C263.665 249.756 264.283 250.197 264.553 250.9L270.296 265.856C270.597 266.642 269.909 267.317 269.306 266.827C269.09 266.65 268.824 266.615 268.607 266.734L266.953 267.635C266.793 267.722 266.591 267.602 266.533 267.387L262.069 251.819C261.797 250.869 262.261 249.936 263.057 249.834Z",
    fill: "#E4BDA7"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M284.192 282.015C283.75 280.377 282.156 279.126 280.711 279.515C279.266 279.905 278.581 282.025 279.022 283.663C279.463 285.301 280.272 284.404 281.717 284.015C283.162 283.625 284.633 283.653 284.192 282.015Z",
    fill: "#E4BDA7"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M298.503 305.402C300.227 306.278 300.513 302.617 301.48 303.108C302.08 300.934 300.499 299.292 299.445 297.586C297.721 296.71 300.561 299.479 299.961 301.654C299.361 303.828 296.779 304.527 298.503 305.402Z",
    fill: "#E4BDA7"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M301.134 309.682C302.142 308.852 301.173 304.032 302.117 303.713C301.398 301.42 302.906 299.45 301.259 298.808C299.573 299.376 300.014 301.33 300.733 303.623C301.452 305.916 299.449 310.25 301.134 309.682Z",
    fill: "#E4BDA7"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M304.106 302.674C303.827 302.19 302.211 299.407 302.115 298.991C301.589 299.102 301.726 303.847 301.61 304.475C301.782 305.218 301.681 304.207 302.207 304.096C302.733 303.985 304.278 303.417 304.106 302.674Z",
    fill: "#E4BDA7"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M264.818 247.337C264.804 246.349 264.099 245.488 263.275 245.452C262.721 245.428 262.239 245.788 262.035 246.378L261.945 246.639C261.833 246.964 261.793 247.326 261.83 247.692L262.226 251.615C262.24 251.755 262.31 251.885 262.413 251.964C262.486 252.019 262.57 252.044 262.65 252.035L263.233 251.968C264.189 251.859 264.87 250.934 264.853 249.769L264.818 247.337Z",
    fill: "#E4BDA7"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M267.33 247.022C266.002 245.642 264.789 248.595 264.044 247.821C262.936 249.414 263.935 251.38 264.441 253.202C265.769 254.582 263.927 251.2 265.036 249.607C266.145 248.015 268.658 248.401 267.33 247.022Z",
    fill: "#E4BDA7"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M264.372 240.445C263.081 240.912 264.343 245.647 263.619 245.909C264.199 247.67 263.414 249.199 264.69 249.669C265.982 249.202 265.62 247.699 265.04 245.938C264.46 244.178 265.663 239.978 264.372 240.445Z",
    fill: "#E4BDA7"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M262.942 240.777C261.732 241.384 263.324 245.91 262.646 246.25C263.345 247.92 262.707 249.517 263.977 249.835C265.187 249.227 264.719 247.787 264.02 246.117C263.321 244.447 264.152 240.169 262.942 240.777Z",
    fill: "#E4BDA7"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M261.711 240.965C260.758 241.54 262.681 244.8 261.216 246.176C261.855 247.502 261.903 248.155 262.944 248.335C263.898 247.76 263.456 246.608 262.817 245.281C262.178 243.954 262.665 240.391 261.711 240.965Z",
    fill: "#E4BDA7"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M261.271 242.797C260.74 243.346 261.393 246.715 261.489 247.74C262.054 248.505 261.868 248.331 262.547 248.267C263.077 247.718 262.865 246.923 262.092 246.269C261.527 245.504 261.801 242.248 261.271 242.797Z",
    fill: "#E4BDA7"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M264.028 247.256C263.984 246.386 263.341 245.659 262.62 245.665C262.135 245.669 261.725 246.009 261.566 246.539L261.496 246.773C261.408 247.064 261.385 247.385 261.429 247.706L261.899 251.146C261.916 251.27 261.981 251.381 262.074 251.446C262.139 251.491 262.213 251.509 262.283 251.497L262.79 251.412C263.621 251.272 264.187 250.426 264.135 249.398L264.028 247.256Z",
    fill: "#E4BDA7"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M279.132 299.359L281.293 298.777L281.117 298.124C280.368 298.72 279.888 298.826 278.956 298.707L279.132 299.359Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M291.024 296.473L289.823 296.796L289.647 296.143C290.217 296.384 290.474 296.291 290.848 295.82L291.024 296.473Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M279.029 297.095C278.193 296.772 279.241 296.143 278.645 295.671",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M290.776 294.375C291.335 293.676 290.114 293.659 290.392 292.951",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M266.508 267.807C268.709 267.279 268.557 266.524 270.397 266.759",
    stroke: "#EDE7D9",
    strokeWidth: 0.656017
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M284.468 293.656C285.07 293.493 285.655 293.72 285.774 294.163C285.894 294.606 285.502 295.096 284.9 295.258C284.298 295.42 283.713 295.193 283.594 294.751C283.475 294.308 283.866 293.818 284.468 293.656Z",
    fill: "#EEB8A7"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M286.52 291.384C286.352 290.761 284.815 289.296 283.383 289.682C281.951 290.068 281.39 292.321 281.558 292.944C281.726 293.566 282.221 291.071 283.653 290.685C285.085 290.299 286.688 292.006 286.52 291.384Z",
    fill: "#D99584"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M286.52 291.384C286.352 290.761 284.815 289.296 283.383 289.682C281.951 290.068 281.39 292.321 281.558 292.944C281.726 293.566 282.221 291.071 283.653 290.685C285.085 290.299 286.688 292.006 286.52 291.384Z",
    fill: "#D99584"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M286.52 291.384C286.352 290.761 284.815 289.296 283.383 289.682C281.951 290.068 281.39 292.321 281.558 292.944C281.726 293.566 282.221 291.071 283.653 290.685C285.085 290.299 286.688 292.006 286.52 291.384Z",
    fill: "#D99584"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M289.382 292.331C288.723 290.481 286.105 285.256 283.704 286.19C287.32 291.773 287.955 290.747 288.614 292.597C289.274 294.447 290.413 295.954 290.777 295.807C289.299 292.24 290.042 294.18 289.382 292.331Z",
    fill: "#79643D"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M279.531 295.098C279.172 293.167 278.81 287.335 281.355 286.935C281.034 293.58 279.97 293.011 280.329 294.942C280.689 296.873 280.385 298.561 279.996 298.617C279.481 294.79 279.891 297.029 279.531 295.098Z",
    fill: "#79643D"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M284.28 282.405L286.425 280.617C286.758 274.259 287.058 271.657 286.467 268.446L285.026 268.834C285.74 274.263 285.562 277.099 284.28 282.405Z",
    fill: "#A8A5A5"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M285.17 270.132L286.729 269.808L286.641 269.067L286.555 268.39L285.061 268.793L285.11 269.353L285.17 270.132Z",
    fill: "#80693D"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M285.668 269.252C285.61 269.307 285.631 269.424 285.705 269.461L285.956 269.589C286.03 269.627 286.102 269.558 286.085 269.465L286.029 269.151C286.012 269.058 285.92 269.011 285.862 269.066L285.668 269.252Z",
    fill: "#C4C4C4"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M285.206 299.417C285.156 298.981 284.435 299.681 283.488 299.717C282.541 299.752 282.206 299.53 281.71 299.225C281.76 299.661 282.568 299.986 283.515 299.95C284.462 299.915 285.256 299.853 285.206 299.417Z",
    fill: "#A78E64"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M286.593 299.188C286.413 298.79 287.425 298.891 288.274 298.416C289.124 297.941 289.303 297.573 289.582 297.05C289.763 297.448 289.22 298.155 288.371 298.63C287.522 299.104 286.774 299.586 286.593 299.188Z",
    fill: "#A78E64"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.768 300.395L273.276 316.428L230.708 158.479L290.2 142.445L332.768 300.395Z",
    fill: "black",
    fillOpacity: 0.1
  })))), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M355.492 80.8049C355.492 73.1319 352.353 65.7719 346.767 60.3469C341.181 54.9209 333.604 51.8719 325.704 51.8719C317.804 51.8719 310.228 54.9209 304.641 60.3469C299.055 65.7719 295.917 73.1319 295.917 80.8049H325.704H355.492Z",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M304.621 99.0254C315.427 99.0254 324.187 90.5168 324.187 80.021C324.187 69.5252 315.427 61.0166 304.621 61.0166C293.815 61.0166 285.055 69.5252 285.055 80.021C285.055 90.5168 293.815 99.0254 304.621 99.0254Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M340.934 94.3104C351.74 94.3104 360.5 85.8019 360.5 75.306C360.5 64.8102 351.74 56.3016 340.934 56.3016C330.128 56.3016 321.368 64.8102 321.368 75.306C321.368 85.8019 330.128 94.3104 340.934 94.3104Z",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M343.752 98.7644C354.558 98.7644 363.318 90.2558 363.318 79.76C363.318 69.2642 354.558 60.7556 343.752 60.7556C332.946 60.7556 324.187 69.2642 324.187 79.76C324.187 90.2558 332.946 98.7644 343.752 98.7644Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M324.193 103.741C337.68 103.741 348.613 93.121 348.613 80.021C348.613 66.9209 337.68 56.3011 324.193 56.3011C310.706 56.3011 299.772 66.9209 299.772 80.021C299.772 93.121 310.706 103.741 324.193 103.741Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M262.212 105.748C262.212 111 264.064 108.976 259.15 108.976C254.236 108.976 255.568 111 255.568 105.748C255.568 100.497 254.236 96.239 259.15 96.239C264.064 96.239 262.212 100.497 262.212 105.748Z",
    fill: "#E4BDA7"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M277.708 103.992C276.498 102.628 274.412 102.504 273.048 103.714L263.286 112.376C262.445 113.122 261.964 114.193 261.964 115.318C261.964 118.892 266.346 120.613 268.778 117.993L277.658 108.429C278.815 107.184 278.836 105.263 277.708 103.992Z",
    fill: "#D37D64"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M273.707 103.324C271.312 107.555 276.56 109.917 278.298 106.079",
    stroke: "#EDE7D9",
    strokeWidth: 0.656017
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M273.141 105.814C274.014 108.983 278.66 108.453 278.797 105.169L279.568 86.675C279.64 84.952 277.283 84.392 276.572 85.963C276.52 86.078 276.482 86.199 276.459 86.323L273.086 104.524C273.006 104.953 273.025 105.394 273.141 105.814Z",
    fill: "#E4BDA7"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M258.684 196.738C258.684 198.95 258.563 200.743 255.95 200.743C253.337 200.743 247.728 202.956 247.728 200.743C247.728 198.531 251.282 196.38 253.895 196.38C256.508 196.38 258.684 194.526 258.684 196.738Z",
    fill: "#A8A5A5"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M257.962 196.738C257.962 198.95 258.083 200.743 260.696 200.743C263.309 200.743 268.917 202.955 268.917 200.743C268.917 198.531 265.069 196.413 262.456 196.413C259.843 196.413 257.962 194.526 257.962 196.738Z",
    fill: "#A8A5A5"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M258.394 195.748C258.394 196.762 257.894 199.717 259.083 199.717C260.272 199.717 270.596 202.702 268.726 199.717C252.359 201.193 264.432 195.954 263.243 195.954C262.053 195.954 258.394 194.734 258.394 195.748Z",
    fill: "#737373"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M258.286 195.748C258.286 196.762 258.786 199.717 257.597 199.717C256.408 199.717 246.084 202.702 247.954 199.717C264.321 201.193 252.738 196.413 253.927 196.413C255.117 196.413 258.286 194.734 258.286 195.748Z",
    fill: "#737373"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M248.777 142.357H268.392L263.341 196.478H253.829L248.777 142.357Z",
    fill: "#70A0AF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M260.007 141.843C260.007 142.826 264 144.063 266.317 144.063C268.634 144.063 268.397 142.826 268.397 141.843C268.397 140.86 266.519 142.329 264.202 142.329C261.885 142.329 260.007 140.86 260.007 141.843Z",
    fill: "#D37D64"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M258.76 196.476L259.22 142.354",
    stroke: "black",
    strokeOpacity: 0.03,
    strokeWidth: 0.656017
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M249.291 117.389C249.012 112.605 252.817 108.572 257.609 108.572H260.061C264.662 108.572 268.392 112.302 268.392 116.904V142.357H248.777L250.005 131.795C250.061 131.315 250.075 130.831 250.047 130.348L249.291 117.389Z",
    fill: "#D37D64"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M266.293 95.935C264.456 102.471 263.068 106.014 258.847 106.014C254.626 106.014 253.73 102.668 251.008 95.935C251.008 90.56 254.43 86.202 258.65 86.202C262.871 86.202 266.293 90.56 266.293 95.935Z",
    fill: "#E4BDA7"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M262.146 87.401C266.621 89.902 264.78 99.358 267.149 95.121C264.686 94.435 268.556 84.01 263.997 84.01C259.522 81.508 262.685 81.24 256.945 79.609C261.048 91.561 257.671 84.899 262.146 87.401Z",
    fill: "url(#paint19_linear_57_182)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M255.329 87.431C250.854 89.933 252.09 100.241 250.325 95.151C250.325 88.465 249.466 84.04 253.478 84.04C257.952 81.538 254.79 81.27 260.53 79.64C267.179 90.401 259.804 84.93 255.329 87.431Z",
    fill: "url(#paint20_linear_57_182)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M252.149 95.178C252.149 96.114 252.408 98.207 251.603 98.207C250.799 98.207 249.237 96.114 249.237 95.178C249.237 94.243 249.889 93.484 250.693 93.484C251.497 93.484 252.149 94.243 252.149 95.178Z",
    fill: "#E4BDA7"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M265.545 94.719C265.545 95.655 265.287 97.748 266.092 97.748C266.896 97.748 268.458 95.655 268.458 94.719C268.458 93.783 267.806 93.025 267.002 93.025C266.197 93.025 265.545 93.783 265.545 94.719Z",
    fill: "#E4BDA7"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M255.878 103.895C255.361 103.317 254.929 102.592 254.486 101.747C254.872 102.2 255.285 102.655 255.709 103.065C256.166 103.509 256.66 103.922 257.17 104.229C257.674 104.533 258.254 104.767 258.868 104.767C259.472 104.767 260.048 104.546 260.556 104.256C261.07 103.963 261.57 103.567 262.036 103.142C262.438 102.774 262.831 102.37 263.201 101.964C262.738 102.822 262.314 103.504 261.823 104.03C261.123 104.781 260.279 105.215 258.868 105.215C257.493 105.215 256.608 104.712 255.878 103.895Z",
    stroke: "url(#paint21_linear_57_182)",
    strokeWidth: 1.64004
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M262.193 98.731C262.193 99.281 261.85 99.802 261.249 100.192C260.65 100.582 259.813 100.828 258.88 100.828C257.947 100.828 257.11 100.582 256.511 100.192C255.911 99.802 255.567 99.281 255.567 98.731C255.567 98.588 255.59 98.505 255.617 98.458C255.639 98.418 255.67 98.395 255.718 98.382C255.774 98.368 255.856 98.366 255.971 98.385C256.085 98.403 256.219 98.437 256.375 98.484C256.48 98.515 256.593 98.552 256.714 98.591C257.299 98.779 258.059 99.024 258.88 99.024C259.701 99.024 260.462 98.779 261.046 98.591C261.167 98.552 261.281 98.515 261.386 98.484C261.541 98.437 261.675 98.403 261.789 98.385C261.905 98.366 261.986 98.368 262.042 98.382C262.091 98.395 262.121 98.418 262.144 98.458C262.17 98.505 262.193 98.588 262.193 98.731Z",
    fill: "white",
    stroke: "#D99584",
    strokeWidth: 0.328008
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M262.554 98.634C262.554 98.778 261.759 98.863 258.98 98.863C256.201 98.863 255.207 98.844 255.207 98.699C255.207 98.554 256.201 96.895 258.98 96.895C261.759 96.895 262.554 98.489 262.554 98.634Z",
    fill: "url(#paint22_linear_57_182)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M260.401 105.048C260.401 105.285 259.581 104.552 258.997 105.653C258.367 104.486 257.514 105.392 257.514 105.155C257.514 104.919 257.905 102.209 258.997 102.209C260.088 102.209 260.401 104.812 260.401 105.048Z",
    fill: "url(#paint23_linear_57_182)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M258.346 96.323C258.648 96.272 258.062 96.806 257.662 96.806C257.139 96.806 256.817 96.6451 256.937 96.3631C256.937 96.1181 257.262 95.92 257.662 95.92C258.062 95.92 258.588 96.282 258.346 96.323Z",
    fill: "#F8D1BC"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M259.355 96.323C259.054 96.272 259.639 96.806 260.04 96.806C260.563 96.806 260.885 96.6451 260.764 96.3631C260.764 96.1181 260.44 95.92 260.04 95.92C259.639 95.92 259.114 96.282 259.355 96.323Z",
    fill: "#F8D1BC"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M253.288 92.484H258.249V93.99C258.249 95.339 257.155 96.433 255.806 96.433H255.731C254.382 96.433 253.288 95.339 253.288 93.99V92.484Z",
    fill: "url(#paint24_linear_57_182)",
    stroke: "white",
    strokeWidth: 0.361241
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M259.501 92.484H264.462V93.99C264.462 95.339 263.368 96.433 262.019 96.433H261.945C260.595 96.433 259.501 95.339 259.501 93.99V92.484Z",
    fill: "url(#paint25_linear_57_182)",
    stroke: "white",
    strokeWidth: 0.361241
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M259.667 94.14C259.667 94.071 259.647 94.003 259.607 93.939C259.568 93.875 259.51 93.817 259.437 93.769C259.364 93.72 259.277 93.681 259.181 93.655C259.086 93.629 258.983 93.615 258.88 93.615C258.777 93.615 258.674 93.629 258.579 93.655C258.483 93.681 258.396 93.72 258.323 93.769C258.25 93.817 258.192 93.875 258.153 93.939C258.113 94.003 258.093 94.071 258.093 94.14L258.323 94.697C258.323 94.674 258.621 94.094 258.634 94.072C258.648 94.051 258.667 94.031 258.692 94.015C258.717 93.998 258.746 93.985 258.778 93.976C258.811 93.967 258.845 93.963 258.88 93.963C258.915 93.963 258.949 93.967 258.982 93.976C259.014 93.985 259.043 93.998 259.068 94.015C259.093 94.031 259.112 94.051 259.126 94.072C259.139 94.094 259.437 94.674 259.437 94.697L259.667 94.14Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M259.339 92.303H258.421V93.8118H259.339V92.303Z",
    fill: "white"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M262.554 109.359C262.554 111.169 260.953 112.902 258.979 112.902C257.004 112.902 255.403 110.907 255.403 109.097C255.403 107.287 256.741 107.986 258.715 107.986C260.69 107.986 262.554 107.55 262.554 109.359Z",
    fill: "#E4BDA7"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M272.754 81.2879C274.65 79.9069 276.271 83.5989 277.333 82.8249C278.844 84.8989 277.394 87.0289 276.637 89.0799C274.742 90.4609 277.409 86.8189 275.898 84.7449C274.388 82.6709 270.859 82.6679 272.754 81.2879Z",
    fill: "#E4BDA7"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M274.636 76.148C276.205 76.723 276.625 81.959 277.937 82.025C277.809 84.587 280.406 86.198 278.528 87.317C276.186 87.2 276.076 85.065 276.205 82.502C276.334 79.94 272.294 76.03 274.636 76.148Z",
    fill: "#E4BDA7"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M279.061 74.743C279.655 76.263 278.392 80.709 279.332 81.232C278.31 83.069 279.16 85.063 277.375 85.205C275.697 84.271 276.389 82.662 277.411 80.826C278.434 78.99 277.382 73.809 279.061 74.743Z",
    fill: "#E4BDA7"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M282.138 76.728C283.086 77.978 279.282 80.298 280.529 82.758C279.161 83.796 278.822 84.4789 277.44 83.9989C276.492 82.7489 277.538 81.7729 278.906 80.7359C280.274 79.6979 281.19 75.478 282.138 76.728Z",
    fill: "#E4BDA7"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M283.276 81.077C282.948 81.853 279.799 82.585 280.094 83.471C278.971 83.645 279.182 84.008 278.528 83.293C278.369 82.266 279.286 82.027 280.409 81.853C281.533 81.679 283.117 80.05 283.276 81.077Z",
    fill: "#E4BDA7"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M280.828 82.5431C280.639 83.1191 279.536 86.4351 279.556 86.8911C278.849 86.9231 277.394 81.9961 277.031 81.3801C276.994 80.5671 277.213 81.6371 277.921 81.6051C278.629 81.5731 280.791 81.7301 280.828 82.5431Z",
    fill: "#E4BDA7"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M250.155 92.8931H253.107V93.6151C251.949 93.2091 251.302 93.2331 250.155 93.6151V92.8931Z",
    fill: "white"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M266.293 92.5649H264.653V93.2869C265.296 92.8809 265.656 92.9049 266.293 93.2869V92.5649Z",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M250.801 95.255C249.848 95.82 251.398 96.177 250.801 96.83",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M266.697 94.796C267.65 95.361 266.1 95.718 266.697 96.37",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M258.91 97.2886C259.732 97.2886 260.399 96.8921 260.399 96.403C260.399 95.9138 259.732 95.5173 258.91 95.5173C258.087 95.5173 257.42 95.9138 257.42 96.403C257.42 96.8921 258.087 97.2886 258.91 97.2886Z",
    fill: "#EEB8A7"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M262.303 99.06C262.303 99.748 260.848 101.684 258.892 101.684C256.935 101.684 255.448 99.519 255.448 98.83C255.448 98.142 256.935 100.576 258.892 100.576C260.848 100.576 262.303 98.372 262.303 99.06Z",
    fill: "#D99584"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M262.303 99.06C262.303 99.748 260.848 101.684 258.892 101.684C256.935 101.684 255.448 99.519 255.448 98.83C255.448 98.142 256.935 100.576 258.892 100.576C260.848 100.576 262.303 98.372 262.303 99.06Z",
    fill: "#D99584"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M262.303 99.06C262.303 99.748 260.848 101.684 258.892 101.684C256.935 101.684 255.448 99.519 255.448 98.83C255.448 98.142 256.935 100.576 258.892 100.576C260.848 100.576 262.303 98.372 262.303 99.06Z",
    fill: "#D99584"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M265.624 97.289C265.419 99.379 263.877 105.489 260.499 105.194C263.189 98.437 264.349 99.318 264.554 97.228C264.759 95.139 265.693 93.269 266.206 93.32C265.549 97.406 265.829 95.2 265.624 97.289Z",
    fill: "#79643D"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M252.127 97.173C252.332 99.263 253.873 105.373 257.252 105.078C254.562 98.321 253.402 99.201 253.197 97.112C252.992 95.023 252.025 93.368 251.511 93.418C252.169 97.505 251.922 95.084 252.127 97.173Z",
    fill: "#79643D"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M257.873 91.1471C257.959 91.6101 256.8 91.0901 255.582 91.3161C254.364 91.5421 254.013 91.8641 253.486 92.3151C253.4 91.8521 254.318 91.2941 255.536 91.0671C256.754 90.8411 257.787 90.6841 257.873 91.1471Z",
    fill: "#A78E64"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M259.718 90.998C259.624 91.458 260.879 91.074 262.124 91.327C263.368 91.58 263.724 91.909 264.258 92.372C264.352 91.911 263.419 91.333 262.174 91.08C260.929 90.827 259.811 90.538 259.718 90.998Z",
    fill: "#A78E64"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M247.576 139.283C249.599 142.632 253.879 143.752 257.135 141.785C260.392 139.818 261.391 135.509 259.368 132.159C257.345 128.81 253.065 127.69 249.809 129.657C246.552 131.624 245.553 135.933 247.576 139.283Z",
    fill: "#BAD8BA"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M257.79 148.325C254.752 148.968 255.904 143.553 254.67 141.511C253.437 139.469 251.869 140.444 253.73 139.32C255.591 138.196 261.362 135.333 262.595 137.375C263.829 139.418 259.45 147.974 257.79 148.325Z",
    fill: "#BAD8BA"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M260.945 144.159C258.534 150.635 252.271 153.843 247.77 142.269C244.511 135.922 247.607 128.993 249.71 132.475C253.057 132.56 258.728 132.496 260.751 135.845C262.774 139.194 260.624 142.168 260.945 144.159Z",
    fill: "#BAD8BA"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M262.846 127.26C263.267 127.958 264.149 128.197 264.816 127.794C265.483 127.392 265.682 126.5 265.26 125.802C264.839 125.104 263.957 124.865 263.29 125.268C262.623 125.67 262.424 126.563 262.846 127.26Z",
    fill: "#BAD8BA"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M260.805 132.236C258.775 131.825 253.799 128.395 257.601 128.283C260.84 127.744 261.578 126.493 261.696 126.307C263.344 123.7 262.902 131.116 265.244 129.199C264.822 131.287 262.834 132.647 260.805 132.236Z",
    fill: "#BAD8BA"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M262.947 132.756C259.691 134.723 255.411 133.602 253.388 130.253C250.729 127.184 257.161 129.392 260.417 127.425C264.905 128.891 259.969 128.27 260.227 129.839C261.335 133.576 266.204 130.789 262.947 132.756Z",
    fill: "#BAD8BA"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M265.234 139.46C264.218 136.318 250.548 140.333 248.525 136.984C246.502 133.635 245.91 127.834 258.501 128.314C264.052 131.667 266.196 127.984 268.219 131.334C270.74 131.574 267.111 131.084 265.234 139.46Z",
    fill: "#BAD8BA"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M264.575 139.13C261.846 140.779 258.106 144.915 256.564 137.033C254.378 132.146 247.898 130.427 253.897 131.287C261.173 130.072 265.333 123.384 267.028 126.19C270.742 137.857 265.918 132.916 264.575 139.13Z",
    fill: "#BAD8BA"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M267.801 139.902C262.833 141.447 264.072 140.264 263.06 138.589C262.049 136.914 262.549 134.759 264.177 133.776C265.805 132.792 267.601 133.292 268.613 134.967C273.599 135.48 270.22 139.15 267.801 139.902Z",
    fill: "#BAD8BA"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M270.052 138.427C266.936 140.31 265.15 135.895 264.138 134.22C263.127 132.546 262.239 132.915 267.536 132.168C269.225 134.52 270.147 134.461 270.927 135.753C271.385 136.511 271.057 137.821 270.052 138.427Z",
    fill: "#BAD8BA"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M257.009 148.682C255.437 151.28 251.994 149.768 249.971 146.419C247.948 143.07 248.947 138.76 252.204 136.793C255.46 134.826 259.74 135.947 261.763 139.296C263.077 144.135 259.286 142.555 257.009 148.682Z",
    fill: "#BAD8BA"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M267.542 128.754C267.177 128.974 266.733 129.029 266.306 128.905C264.511 130.777 267.92 121.513 268.871 121.628C265.171 120.07 261.192 126.995 261.534 126.673C261.623 126.239 265.38 125.998 265.744 125.778L266.643 127.266L267.542 128.754Z",
    fill: "#BAD8BA"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M297.168 114.422C297.683 115.275 298.817 115.533 299.701 114.999C300.585 114.465 300.884 113.341 300.368 112.488C299.853 111.635 298.719 111.377 297.835 111.911C296.951 112.445 296.653 113.569 297.168 114.422Z",
    fill: "#D9D0B2"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M293.315 118.512C293.146 118.231 292.286 116.681 290.528 117.704C290.813 117.034 291.302 115.589 292.186 115.056C293.069 114.522 296.167 113.019 296.682 113.872C297.04 114.844 295.73 117.244 293.315 118.512Z",
    fill: "#D9D0B2"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M269.218 134.065C268.259 133.302 256.87 139.761 266.692 137.813C263.45 139.043 264.38 129.515 265.574 128.793C266.768 128.072 271.765 129.844 270.951 130.336C268.901 131.574 267.629 132.802 269.218 134.065Z",
    fill: "#BAD8BA"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M267.677 128.353L267.649 128.309C267.571 128.186 267.409 128.15 267.286 128.228L265.296 129.492C265.174 129.57 265.138 129.732 265.216 129.855L265.244 129.899C265.322 130.022 265.484 130.058 265.606 129.98L267.596 128.716C267.719 128.638 267.755 128.476 267.677 128.353Z",
    fill: "#C4C4C4"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M268.925 128.378C267.25 129.39 264.494 127.07 264.257 125.028C263.143 123.183 266.148 121.625 266.835 121.555C271.54 120.591 267.693 124.562 268.031 126.772C268.65 128.621 270.489 126.399 268.925 128.378Z",
    fill: "#BAD8BA"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M289.19 115.679L290.44 117.748L267.301 132.732L265.537 129.812L289.19 115.679Z",
    fill: "url(#paint26_linear_57_182)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M299.588 112.801L299.464 112.383C299.32 111.896 298.809 111.619 298.322 111.763L290.018 114.222C289.532 114.366 289.254 114.877 289.398 115.363L289.522 115.782C289.666 116.268 290.177 116.546 290.663 116.402L298.968 113.943C299.454 113.799 299.732 113.288 299.588 112.801Z",
    fill: "#D9D0B2"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M263.071 141.081C261.327 141.936 260.793 145.937 259.876 145.878C258.959 145.818 260.912 139.856 261.811 139.312C262.711 138.769 266.183 139.317 266.501 139.844C268.215 140.335 264.014 140.618 263.071 141.081Z",
    fill: "#BAD8BA"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M290.719 117.513C290.422 118.037 290.177 117.187 289.737 116.458C289.297 115.729 289.216 114.971 289.557 114.765C289.899 114.559 291.197 115.386 291.637 116.115C292.077 116.844 290.718 117.321 290.719 117.513Z",
    fill: "#D9D0B2"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M291.005 117.416L289.75 115.338L289.188 115.677L290.444 117.755L291.005 117.416Z",
    fill: "#D9D0B2"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M295.932 113.287C296.013 113.082 296.268 113.014 296.44 113.15L298.229 114.566C298.505 114.784 298.29 115.225 297.947 115.141L297.101 114.934C296.973 114.903 296.839 114.951 296.76 115.056L296.288 115.686C296.199 115.805 296.041 115.849 295.903 115.793L295.374 115.58C295.207 115.512 295.126 115.322 295.192 115.155L295.932 113.287Z",
    fill: "#D9D0B2"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M290.657 113.794C290.425 113.935 290.038 113.848 289.925 113.662C289.813 113.475 290.035 113.289 290.267 113.149C290.5 113.008 290.875 113.14 290.988 113.326C291.1 113.513 290.89 113.654 290.657 113.794Z",
    fill: "url(#paint27_linear_57_182)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M292.135 113.323C291.903 113.464 291.516 113.376 291.404 113.19C291.291 113.004 291.513 112.818 291.745 112.677C291.978 112.537 292.353 112.669 292.466 112.855C292.578 113.041 292.368 113.183 292.135 113.323Z",
    fill: "url(#paint28_linear_57_182)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M293.518 112.948C293.285 113.088 292.899 113.001 292.786 112.815C292.674 112.629 292.895 112.442 293.128 112.302C293.361 112.161 293.736 112.294 293.849 112.48C293.961 112.666 293.751 112.807 293.518 112.948Z",
    fill: "url(#paint29_linear_57_182)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M294.867 112.516C294.634 112.657 294.247 112.569 294.135 112.383C294.023 112.197 294.244 112.011 294.477 111.87C294.709 111.73 295.085 111.862 295.197 112.048C295.31 112.234 295.099 112.376 294.867 112.516Z",
    fill: "url(#paint30_linear_57_182)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M296.249 112.141C296.017 112.281 295.63 112.194 295.518 112.008C295.405 111.822 295.627 111.635 295.859 111.495C296.092 111.354 296.468 111.487 296.58 111.673C296.692 111.859 296.482 112 296.249 112.141Z",
    fill: "url(#paint31_linear_57_182)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M297.632 111.765C297.4 111.906 297.013 111.819 296.901 111.632C296.788 111.446 297.01 111.26 297.242 111.12C297.475 110.979 297.85 111.111 297.963 111.297C298.075 111.483 297.865 111.625 297.632 111.765Z",
    fill: "url(#paint32_linear_57_182)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M266.065 132.872C266.586 137.1 264.13 136.801 262.466 140.291C251.857 130.171 258.135 135.241 262.481 127.583C262.208 127.946 266.198 121.565 267.616 124.167C266.897 126.773 263.756 128.635 266.065 132.872Z",
    fill: "#EDE7D9"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M267.147 128.832C265.68 129.68 262.826 131.495 264.164 129.65C263.733 127.487 267.074 123.59 267.396 123.851C268.403 124.882 266.315 125.369 266.746 127.532C267.027 128.943 269.79 127.304 267.147 128.832Z",
    fill: "#EDE7D9"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M266.094 129.253L266.611 130.937L267.745 132.283L266.23 133.109L264.579 130.079L266.094 129.253Z",
    fill: "#EDE7D9"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M270.161 136.557C269.619 136.852 268.447 136.243 267.944 135.318C267.44 134.394 263.744 135.157 268.255 132.286C268.863 131.899 267.273 132.747 267.777 133.671C268.385 134.787 270.248 135.315 270.161 136.557Z",
    fill: "#EDE7D9"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M265.116 139.211C258.771 136.777 264.577 138.755 263.867 137.453C263.158 136.152 263.576 134.556 264.8 133.889C266.024 133.222 267.265 135.274 269.978 135.979C271.29 137.921 266.174 139.617 265.116 139.211Z",
    fill: "#EDE7D9"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M267.81 134.14L266.404 131.559L264.945 132.354L266.351 134.935L267.81 134.14Z",
    fill: "#EDE7D9"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M267.745 132.284L267.929 132.573L267.179 133.247L266.903 132.742L267.745 132.284Z",
    fill: "#EDE7D9"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M268.318 132.074L268.392 132.191L267.525 132.871L267.407 132.659L268.318 132.074Z",
    fill: "#EDE7D9"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M261.285 141.262C259.689 142.132 258.387 142.287 258.1 141.76C257.813 141.234 258.874 140.101 260.47 139.232C262.066 138.362 266.517 138.31 266.804 138.837C267.059 139.571 263.359 138.858 261.285 141.262Z",
    fill: "#EDE7D9"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M261.451 141.099C260.101 142.562 258.408 147.066 257.453 145.315C256.499 143.564 257.788 139.919 259.412 139.226C262.187 138.042 261.797 134.855 262.751 136.606C263.705 138.357 264.905 136.888 261.451 141.099Z",
    fill: "#EDE7D9"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M261.257 141.277C260.683 141.59 259.856 141.177 259.408 140.356C258.961 139.535 259.033 141.07 258.194 140.799C256.181 145.317 258.658 137.443 259.106 138.265C259.553 139.086 261.83 140.965 261.257 141.277Z",
    fill: "#EDE7D9"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M261.79 139.385L258.488 133.325L256.804 134.242L260.107 140.302L261.79 139.385Z",
    fill: "#EDE7D9"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M255.41 141.39C253.913 142.238 252.069 141.814 251.292 140.443C250.516 139.071 251.1 137.272 252.597 136.424C254.095 135.576 254.483 136.825 255.26 138.196C256.036 139.567 256.908 140.542 255.41 141.39Z",
    fill: "url(#paint33_linear_57_182)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M290.713 114.911C290.772 115.002 290.893 115.029 290.985 114.971C291.077 114.913 291.104 114.791 291.045 114.699C290.987 114.608 290.865 114.581 290.773 114.639C290.682 114.697 290.655 114.819 290.713 114.911Z",
    fill: "#9E9D9D"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M292.197 114.432C292.255 114.523 292.377 114.55 292.469 114.492C292.56 114.434 292.587 114.312 292.529 114.22C292.471 114.129 292.349 114.102 292.257 114.16C292.166 114.218 292.139 114.34 292.197 114.432Z",
    fill: "#9E9D9D"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M293.57 114.024C293.629 114.115 293.75 114.142 293.842 114.084C293.934 114.026 293.961 113.904 293.902 113.812C293.844 113.721 293.722 113.694 293.63 113.752C293.539 113.81 293.512 113.932 293.57 114.024Z",
    fill: "#9E9D9D"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M294.873 113.505C294.931 113.596 295.053 113.623 295.145 113.565C295.236 113.507 295.263 113.385 295.205 113.293C295.146 113.202 295.025 113.175 294.933 113.233C294.841 113.291 294.814 113.413 294.873 113.505Z",
    fill: "#9E9D9D"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M296.392 113.082C296.45 113.173 296.572 113.2 296.664 113.142C296.755 113.084 296.782 112.962 296.724 112.87C296.666 112.779 296.544 112.752 296.452 112.81C296.36 112.868 296.334 112.99 296.392 113.082Z",
    fill: "#9E9D9D"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M297.766 112.674C297.824 112.765 297.946 112.792 298.038 112.734C298.129 112.676 298.156 112.554 298.098 112.462C298.04 112.371 297.918 112.344 297.826 112.402C297.735 112.46 297.708 112.582 297.766 112.674Z",
    fill: "#9E9D9D"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M290.73 114.939L253.376 137.254",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M292.194 114.551L253.728 137.807",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M293.899 113.931L254.081 138.36",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M295.107 113.628L254.504 139.024",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M296.39 113.2L254.892 139.632",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M297.819 112.757L255.209 140.13",
    stroke: "#C6C6C6",
    strokeWidth: 0.0656017
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M287.513 116.711L288.777 118.791",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M286.02 117.655L287.284 119.735",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M284.527 118.599L285.791 120.679",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M282.889 119.519L284.255 121.705",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M281.67 120.24L283.036 122.427",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M280.366 121.126L281.712 123.25",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M278.771 121.964L280.238 124.256",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M277.298 122.971L278.644 125.095",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M275.617 123.974L276.982 126.16",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M274.167 124.836L275.532 127.022",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M272.694 125.843L273.958 127.923",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M271.201 126.787L272.465 128.867",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M269.708 127.731L270.972 129.812",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M268.07 128.651L269.436 130.837",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M266.852 129.373L268.217 131.559",
    stroke: "#9E9D9D",
    strokeWidth: 0.0656017
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M263.887 130.824L263.218 131.239C263.064 131.335 263.016 131.537 263.112 131.691L264.436 133.827C264.532 133.98 264.734 134.028 264.888 133.932L265.557 133.517C265.711 133.422 265.758 133.22 265.663 133.066L264.338 130.93C264.243 130.776 264.041 130.729 263.887 130.824Z",
    fill: "#756F62"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M259.684 133.457L259.015 133.872C258.861 133.968 258.813 134.17 258.909 134.324L260.26 136.502C260.355 136.656 260.557 136.703 260.711 136.608L261.38 136.193C261.534 136.098 261.582 135.895 261.486 135.741L260.135 133.563C260.04 133.409 259.838 133.362 259.684 133.457Z",
    fill: "#756F62"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M258.6 144.168C258.929 144.066 259.112 143.717 259.01 143.388C258.908 143.06 258.559 142.876 258.23 142.978C257.902 143.08 257.718 143.429 257.82 143.758C257.922 144.086 258.271 144.27 258.6 144.168Z",
    fill: "#070707"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M255.175 148.735C255.313 148.692 255.391 148.545 255.348 148.406C255.305 148.268 255.158 148.19 255.019 148.233C254.881 148.276 254.803 148.423 254.846 148.562C254.889 148.7 255.036 148.778 255.175 148.735Z",
    fill: "#6C6C6C"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M259.897 141.705C260.226 141.603 260.409 141.254 260.307 140.925C260.205 140.597 259.856 140.413 259.527 140.515C259.199 140.617 259.015 140.966 259.117 141.295C259.219 141.623 259.568 141.807 259.897 141.705Z",
    fill: "#070707"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M285.909 119.245C285.981 119.245 286.04 119.186 286.04 119.114C286.04 119.042 285.981 118.983 285.909 118.983C285.837 118.983 285.778 119.042 285.778 119.114C285.778 119.186 285.837 119.245 285.909 119.245Z",
    fill: "#EDE7D9"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M282.891 121.082C282.963 121.082 283.022 121.023 283.022 120.951C283.022 120.879 282.963 120.82 282.891 120.82C282.818 120.82 282.76 120.879 282.76 120.951C282.76 121.023 282.818 121.082 282.891 121.082Z",
    fill: "#EDE7D9"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M280.201 122.722C280.273 122.722 280.332 122.664 280.332 122.591C280.332 122.519 280.273 122.46 280.201 122.46C280.129 122.46 280.07 122.519 280.07 122.591C280.07 122.664 280.129 122.722 280.201 122.722Z",
    fill: "#EDE7D9"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M277.118 124.69C277.191 124.69 277.249 124.631 277.249 124.559C277.249 124.486 277.191 124.428 277.118 124.428C277.046 124.428 276.987 124.486 276.987 124.559C276.987 124.631 277.046 124.69 277.118 124.69Z",
    fill: "#EDE7D9"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1 126.527C274.172 126.527 274.231 126.468 274.231 126.396C274.231 126.324 274.172 126.265 274.1 126.265C274.027 126.265 273.969 126.324 273.969 126.396C273.969 126.468 274.027 126.527 274.1 126.527Z",
    fill: "#EDE7D9"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M271.017 128.495C271.089 128.495 271.148 128.436 271.148 128.364C271.148 128.292 271.089 128.233 271.017 128.233C270.944 128.233 270.886 128.292 270.886 128.364C270.886 128.436 270.944 128.495 271.017 128.495Z",
    fill: "#EDE7D9"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M268.13 130.201C268.203 130.201 268.261 130.143 268.261 130.07C268.261 129.998 268.203 129.939 268.13 129.939C268.058 129.939 267.999 129.998 267.999 130.07C267.999 130.143 268.058 130.201 268.13 130.201Z",
    fill: "#EDE7D9"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M247.66 131.464C245.861 131.411 244.621 129.641 245.184 127.932L249.67 114.331C249.716 114.192 249.81 114.074 249.936 113.999C250.348 113.754 250.869 114.06 250.854 114.539L250.429 128.854C250.385 130.34 249.145 131.508 247.66 131.464Z",
    fill: "#D37D64"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M246.681 148.386C247.483 148.297 248.119 147.672 248.222 146.872L250.402 129.868C250.516 128.974 249.408 128.469 248.808 129.142C248.593 129.384 248.267 129.494 247.949 129.432L245.534 128.963C245.3 128.918 245.083 129.097 245.083 129.335L244.742 146.615C244.721 147.67 245.633 148.503 246.681 148.386Z",
    fill: "#E4BDA7"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M249.782 150.47C250.103 151.493 249.5 152.575 248.463 152.841C247.766 153.02 247.028 152.782 246.566 152.231L246.361 151.987C246.107 151.684 245.933 151.322 245.854 150.934L245.012 146.782C244.981 146.634 245.026 146.48 245.131 146.371C245.204 146.294 245.302 146.245 245.408 146.232L246.173 146.139C247.428 145.986 248.613 146.749 248.991 147.955L249.782 150.47Z",
    fill: "#E4BDA7"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M253.089 150.098C251.871 151.888 249.312 149.183 248.63 150.186C246.671 148.853 247.268 146.55 247.288 144.531C248.506 142.741 247.32 146.738 249.279 148.07C251.238 149.403 254.307 148.307 253.089 150.098Z",
    fill: "#E4BDA7"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M251.579 157.696C249.774 157.573 249.756 152.343 248.744 152.274C248.878 150.299 247.354 148.941 248.818 148.103C250.623 148.226 250.678 149.875 250.544 151.85C250.41 153.825 253.384 157.818 251.579 157.696Z",
    fill: "#E4BDA7"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M249.643 157.751C247.893 157.461 248.368 152.356 247.387 152.194C247.704 150.279 246.344 148.81 247.852 148.13C249.602 148.42 249.501 150.034 249.184 151.949C248.866 153.864 251.393 158.041 249.643 157.751Z",
    fill: "#E4BDA7"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M248.011 157.898C246.6 157.571 248.032 153.581 245.695 152.571C246.053 151.026 245.788 150.438 247.052 149.962C248.464 150.29 248.297 151.6 247.939 153.145C247.58 154.689 249.423 158.226 248.011 157.898Z",
    fill: "#E4BDA7"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M246.821 156.133C245.958 155.715 245.632 152.062 245.403 150.98C245.86 150.035 245.683 150.265 246.569 150.143C247.433 150.561 247.436 151.439 246.676 152.328C246.219 153.273 247.685 156.551 246.821 156.133Z",
    fill: "#E4BDA7"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M248.803 150.773C249.046 151.682 248.476 152.609 247.555 152.803C246.937 152.934 246.299 152.697 245.914 152.196L245.744 151.974C245.532 151.698 245.393 151.374 245.339 151.031L244.756 147.355C244.736 147.224 244.78 147.091 244.876 146.999C244.944 146.934 245.032 146.895 245.125 146.888L245.8 146.835C246.907 146.748 247.918 147.463 248.205 148.535L248.803 150.773Z",
    fill: "#E4BDA7"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M244.907 128.909C247.892 128.843 247.957 129.663 250.221 128.909",
    stroke: "#EDE7D9",
    strokeWidth: 0.656017
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M262.533 108.933L265.878 110.179C268.485 116.639 269.76 119.236 270.11 122.709H268.142C267.187 116.916 265.987 114.043 262.533 108.933Z",
    fill: "#A8A5A5"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M267.879 121.332L269.976 121.233L270.119 122.02L270.241 122.742H268.199L268.07 122.152L267.879 121.332Z",
    fill: "#80693D"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M268.815 122.1C268.723 122.059 268.71 121.933 268.791 121.874L269.067 121.673C269.148 121.613 269.264 121.665 269.274 121.765L269.311 122.104C269.321 122.204 269.219 122.279 269.127 122.238L268.815 122.1Z",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_57_182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_57_182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 197,
    width: 37,
    height: 97
  }, _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M214.001 203.692C213.669 201.761 213.297 200.214 211.063 200.598C208.829 200.982 203.702 199.876 204.034 201.806C204.365 203.736 207.974 205.02 210.208 204.636C212.442 204.252 214.333 205.622 214.001 203.692Z",
    fill: "#C4C4C4"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M213.78 204.619C213.628 203.734 213.612 201.082 212.596 201.257C211.579 201.431 202.304 200.343 204.35 202.674C218.123 198.981 208.587 205.327 209.603 205.152C210.62 204.978 213.932 205.504 213.78 204.619Z",
    fill: "black"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M215.781 203.632C215.449 201.702 215.283 200.119 217.517 199.735C219.752 199.351 224.215 196.597 224.547 198.527C224.879 200.458 222.163 202.857 219.929 203.241C217.695 203.625 216.113 205.563 215.781 203.632Z",
    fill: "#C4C4C4"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M216.269 204.438C216.117 203.553 215.246 201.048 216.263 200.873C217.28 200.698 225.659 196.577 224.508 199.456C210.292 200.573 220.913 203.043 219.896 203.217C218.88 203.392 216.421 205.323 216.269 204.438Z",
    fill: "black"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M231.433 233.894L209.614 237.643L207.72 204.608L222.275 202.107L231.433 233.894Z",
    fill: "#617483"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M236.938 258.199C237.772 263.055 234.512 267.669 229.656 268.503L223.572 269.549C218.716 270.383 214.102 267.123 213.268 262.267L208.798 236.251C217.459 231.75 222.58 230.547 232.467 232.184L236.938 258.199Z",
    fill: "#C4C4C4"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M214.993 203.834L219.319 231.028",
    stroke: "black",
    strokeOpacity: 0.03,
    strokeWidth: 0.656017
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M223.376 272.609C222.612 268.162 220.142 267.014 226 266.007C231.859 265.001 230.533 266.8 231.298 271.248C232.062 275.695 234.269 279.027 228.411 280.034C222.552 281.041 224.14 277.056 223.376 272.609Z",
    fill: "#B38B74"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M222.426 281.662C222.802 274.838 223.622 273.725 227.23 273.105C230.839 272.484 232.577 273.866 235.055 279.492C238.05 285.215 233.732 289.316 230.123 289.936C226.514 290.557 221.744 287.663 222.426 281.662Z",
    fill: "#B38B74"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M234.264 280.747C234.124 279.93 233.589 278.142 234.277 278.024C234.964 277.906 236.614 279.502 236.754 280.319C236.895 281.136 236.451 281.894 235.763 282.012C235.075 282.13 234.404 281.564 234.264 280.747Z",
    fill: "#B38B74"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M223.596 282.58C223.455 281.764 223.362 279.899 222.674 280.017C221.987 280.136 220.965 282.192 221.105 283.008C221.246 283.825 221.917 284.391 222.605 284.273C223.292 284.155 223.736 283.397 223.596 282.58Z",
    fill: "#B38B74"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M223.596 282.58C223.455 281.764 223.362 279.899 222.674 280.017C221.987 280.136 220.965 282.192 221.105 283.008C221.246 283.825 221.917 284.391 222.605 284.273C223.292 284.155 223.736 283.397 223.596 282.58Z",
    fill: "#B38B74"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M225.391 278.078C225.309 277.605 225.521 277.106 225.972 276.68C226.422 276.256 227.097 275.92 227.89 275.783C228.684 275.647 229.432 275.739 229.998 275.989C230.565 276.239 230.931 276.638 231.013 277.112C231.034 277.235 231.027 277.308 231.012 277.349C231 277.382 230.982 277.402 230.948 277.418C230.907 277.437 230.841 277.45 230.741 277.451C230.643 277.452 230.524 277.441 230.385 277.424C230.291 277.412 230.189 277.397 230.08 277.38C229.552 277.302 228.861 277.199 228.155 277.321C227.448 277.442 226.831 277.77 226.359 278.02C226.262 278.072 226.171 278.12 226.086 278.162C225.961 278.226 225.853 278.275 225.76 278.307C225.665 278.34 225.599 278.349 225.554 278.345C225.516 278.341 225.492 278.329 225.47 278.301C225.443 278.267 225.412 278.201 225.391 278.078Z",
    fill: "white",
    stroke: "#D99584",
    strokeWidth: 0.328008
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M229.045 280.272C228.778 280.366 229.227 279.777 229.593 279.714C230.071 279.632 230.391 279.731 230.326 280.013C230.365 280.241 230.1 280.477 229.735 280.54C229.369 280.602 228.831 280.347 229.045 280.272Z",
    fill: "#C39C86"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M228.123 280.43C228.406 280.43 227.786 280.024 227.42 280.087C226.942 280.169 226.674 280.37 226.829 280.614C226.868 280.842 227.197 280.976 227.562 280.913C227.928 280.85 228.35 280.43 228.123 280.43Z",
    fill: "#C39C86"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M233.879 282.801L229.685 283.522L229.46 282.213C229.261 281.055 230.038 279.954 231.197 279.755C232.355 279.556 233.455 280.334 233.654 281.492L233.879 282.801Z",
    stroke: "black",
    strokeWidth: 0.361241
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M228.567 283.714L224.372 284.435L224.147 283.126C223.948 281.968 224.726 280.867 225.884 280.668C227.043 280.469 228.143 281.247 228.342 282.405L228.567 283.714Z",
    stroke: "black",
    strokeWidth: 0.361241
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M228.204 282.309C228.214 282.369 228.242 282.426 228.285 282.476C228.328 282.525 228.387 282.567 228.456 282.599C228.526 282.631 228.606 282.652 228.692 282.661C228.777 282.67 228.867 282.667 228.955 282.651C229.044 282.636 229.129 282.609 229.207 282.572C229.285 282.535 229.353 282.489 229.408 282.436C229.463 282.382 229.504 282.323 229.529 282.262C229.553 282.201 229.56 282.138 229.55 282.078L229.269 281.625C229.272 281.645 229.105 282.196 229.097 282.217C229.089 282.237 229.075 282.257 229.056 282.275C229.037 282.293 229.014 282.309 228.988 282.321C228.962 282.334 228.933 282.343 228.903 282.348C228.873 282.353 228.843 282.354 228.814 282.351C228.785 282.348 228.758 282.341 228.735 282.33C228.711 282.32 228.692 282.306 228.677 282.289C228.662 282.272 228.321 281.809 228.317 281.789L228.204 282.309Z",
    fill: "black"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M228.759 283.864L229.544 283.729L229.318 282.412L228.532 282.547L228.759 283.864Z",
    fill: "black"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M235.679 280.73C236.409 280.097 235.03 280.013 235.443 279.356",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M222.144 283.056C221.244 282.702 222.516 282.164 221.908 281.682",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M228.375 279.459C227.623 279.588 227.078 280.063 227.156 280.519C227.234 280.975 227.907 281.24 228.659 281.111C229.41 280.982 229.956 280.507 229.878 280.051C229.799 279.595 229.126 279.33 228.375 279.459Z",
    fill: "#CFA68F"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M225.226 277.811C225.123 277.21 226.076 275.307 227.749 275.019C229.422 274.732 231.019 276.403 231.122 277.004C231.225 277.605 229.588 275.699 227.915 275.987C226.243 276.274 225.329 278.411 225.226 277.811Z",
    fill: "#D99584"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M230.591 282.758C230.537 282.447 231.309 282.763 231.999 282.645C232.689 282.526 233.166 281.951 233.22 282.263C233.273 282.574 232.731 282.769 232.04 282.888C231.35 283.006 230.644 283.07 230.591 282.758Z",
    fill: "black"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M224.965 283.625C224.908 283.294 225.698 283.712 226.328 283.604C226.958 283.495 227.391 282.96 227.448 283.291C227.505 283.621 227.002 283.753 226.372 283.862C225.743 283.97 225.022 283.955 224.965 283.625Z",
    fill: "black"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M233.638 278.988C233.377 277.47 232.796 276.687 233.23 276.612C233.664 276.538 234.915 278.09 235.176 279.608C235.437 281.126 236.684 283.607 235.983 284.303C234.76 285.515 233.899 280.506 233.638 278.988Z",
    fill: "black"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M223.55 280.575C223.289 279.058 223.575 278.125 223.141 278.2C222.708 278.274 222.046 280.155 222.307 281.673C222.568 283.191 222.2 285.831 223.094 286.252C224.651 286.987 223.81 282.093 223.55 280.575Z",
    fill: "black"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M236.314 286.494C236.805 289.351 234.887 292.065 232.031 292.556L229.699 292.956C226.843 293.447 224.129 291.529 223.638 288.673L223.15 285.83L235.826 283.652L236.314 286.494Z",
    fill: "#D6C2A2"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M236.218 283.584C236.436 284.849 235.587 286.05 234.322 286.268L225.44 287.794C224.176 288.011 222.974 287.162 222.757 285.897L236.218 283.584Z",
    fill: "#836B3D"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M221.924 276.682C221.385 273.545 223.559 270.553 226.781 269.999C230.002 269.445 233.051 271.54 233.59 274.677C235.605 286.399 230.685 273.417 227.463 273.97C224.242 274.524 223.959 288.524 221.924 276.682Z",
    fill: "url(#paint34_linear_57_182)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M224.342 278.994C224.236 278.378 226.062 278.846 228.153 278.487C230.244 278.127 231.808 277.076 231.914 277.693C232.02 278.31 230.411 279.101 228.32 279.46C226.229 279.819 224.448 279.611 224.342 278.994Z",
    fill: "black"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M228.745 291.436L232.422 290.804C232.69 290.758 232.869 290.504 232.823 290.236L232.499 288.351C232.453 288.083 232.199 287.903 231.931 287.949L228.254 288.581C227.986 288.627 227.807 288.881 227.853 289.149L228.177 291.035C228.223 291.302 228.477 291.482 228.745 291.436Z",
    fill: "#E5E5E5",
    stroke: "#79643D",
    strokeWidth: 0.0656017
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M231.533 280.853C230.883 280.965 230.415 281.401 230.488 281.828C230.561 282.255 231.148 282.511 231.799 282.399C232.449 282.287 232.917 281.85 232.844 281.424C232.77 280.997 232.184 280.741 231.533 280.853Z",
    fill: "white"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M231.533 280.853C230.883 280.965 230.415 281.401 230.488 281.828C230.561 282.255 231.148 282.511 231.799 282.399C232.449 282.287 232.917 281.85 232.844 281.424C232.77 280.997 232.184 280.741 231.533 280.853Z",
    fill: "white"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M225.934 281.874C225.283 281.986 224.816 282.422 224.889 282.849C224.962 283.276 225.549 283.532 226.2 283.42C226.85 283.308 227.318 282.871 227.245 282.445C227.171 282.018 226.584 281.762 225.934 281.874Z",
    fill: "white"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M231.544 281.086C231.25 281.137 231.053 281.421 231.105 281.722C231.157 282.022 231.437 282.224 231.731 282.174C232.026 282.123 232.222 281.839 232.171 281.538C232.119 281.238 231.839 281.036 231.544 281.086Z",
    fill: "#C4C4C4"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M231.544 281.086C231.25 281.137 231.053 281.421 231.105 281.722C231.157 282.022 231.437 282.224 231.731 282.174C232.026 282.123 232.222 281.839 232.171 281.538C232.119 281.238 231.839 281.036 231.544 281.086Z",
    fill: "#413026"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M210.29 263.988C210.823 267.337 213.821 269.729 217.205 269.503L221.308 269.23L214.975 253.049L208.722 254.123L210.29 263.988Z",
    fill: "#C4C4C4"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M226.047 282.031C225.753 282.082 225.556 282.366 225.608 282.667C225.66 282.967 225.94 283.169 226.234 283.119C226.529 283.068 226.725 282.784 226.674 282.483C226.622 282.183 226.342 281.981 226.047 282.031Z",
    fill: "#413026"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M221.089 260.924L216.386 261.732L215.62 257.275C215.5 256.579 215.968 255.917 216.664 255.798L218.845 255.423C219.542 255.303 220.203 255.771 220.323 256.467L221.089 260.924Z",
    stroke: "#939191",
    strokeWidth: 0.0656017
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M230.742 254.73C230.898 255.459 230.416 256.172 229.681 256.298L218.812 258.166C218.073 258.293 217.378 257.776 217.287 257.032L215.396 241.571C215.311 240.876 215.786 240.237 216.476 240.118L225.978 238.486C226.672 238.366 227.336 238.816 227.483 239.504L230.742 254.73Z",
    fill: "#B9A689"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M240.232 258.694C240.829 261.895 238.989 265.049 235.908 266.104L230.91 267.816L232.116 249.632L238.357 248.648L240.232 258.694Z",
    fill: "#C4C4C4"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M229.881 246.629C228.931 246.675 228.131 245.915 228.13 244.963C228.129 244.33 228.489 243.754 229.057 243.479L229.289 243.367C229.605 243.215 229.954 243.145 230.304 243.165L233.96 243.374C234.095 243.382 234.217 243.455 234.287 243.57C234.335 243.65 234.355 243.743 234.344 243.834L234.259 244.503C234.119 245.617 233.202 246.466 232.08 246.521L229.881 246.629Z",
    fill: "#B38B74"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M229.446 249.546C228.201 248.102 231.025 246.518 230.327 245.708C231.868 244.33 233.677 245.358 235.371 245.828C236.616 247.272 233.508 245.361 231.967 246.739C230.427 248.117 230.691 250.99 229.446 249.546Z",
    fill: "#B38B74"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M223.378 246.549C223.868 245.031 228.271 246.189 228.546 245.338C230.179 245.896 231.648 244.896 232.039 246.337C231.549 247.855 230.15 247.532 228.517 246.974C226.884 246.416 222.888 248.067 223.378 246.549Z",
    fill: "#B38B74"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M223.746 244.879C224.365 243.446 228.558 244.998 228.905 244.194C230.448 244.895 231.975 244.061 232.223 245.504C231.604 246.937 230.268 246.488 228.726 245.787C227.183 245.086 223.128 246.313 223.746 244.879Z",
    fill: "#B38B74"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M223.972 243.449C224.549 242.314 227.736 244.53 229.086 242.755C230.309 243.408 230.724 243.219 230.853 244.408C230.275 245.543 229.208 245.106 227.986 244.453C226.764 243.8 223.394 244.584 223.972 243.449Z",
    fill: "#B38B74"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M225.712 242.826C226.249 242.181 229.391 242.721 230.351 242.768C231.048 243.371 230.892 243.168 230.805 243.954C230.268 244.6 229.529 244.406 228.944 243.555C228.247 242.952 225.175 243.472 225.712 242.826Z",
    fill: "#B38B74"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M229.83 245.725C228.995 245.729 228.322 245.031 228.356 244.196C228.378 243.64 228.716 243.149 229.225 242.93L229.434 242.84C229.716 242.719 230.025 242.671 230.331 242.702L233.534 243.027C233.651 243.039 233.756 243.108 233.813 243.212C233.852 243.283 233.866 243.366 233.853 243.446L233.754 244.029C233.589 245.001 232.753 245.71 231.767 245.715L229.83 245.725Z",
    fill: "#B38B74"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M215.298 248.984C216.209 248.711 216.709 247.727 216.393 246.83C216.182 246.232 215.65 245.809 215.023 245.74L214.766 245.712C214.418 245.674 214.066 245.725 213.742 245.861L210.366 247.278C210.242 247.33 210.151 247.44 210.123 247.572C210.104 247.663 210.116 247.757 210.158 247.84L210.461 248.442C210.965 249.445 212.113 249.939 213.189 249.616L215.298 248.984Z",
    fill: "#B38B74"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M216.681 251.589C217.373 249.812 214.182 249.261 214.57 248.265C212.657 247.481 211.295 249.054 209.855 250.062C209.163 251.839 211.455 249 213.367 249.785C215.28 250.57 215.99 253.366 216.681 251.589Z",
    fill: "#B38B74"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M221.401 246.738C220.432 245.471 216.668 248.032 216.125 247.322C214.772 248.393 213.054 247.94 213.166 249.429C214.135 250.697 215.346 249.926 216.698 248.854C218.051 247.783 222.369 248.005 221.401 246.738Z",
    fill: "#B38B74"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M220.496 245.287C219.435 244.143 216 247.005 215.405 246.363C214.185 247.539 212.467 247.262 212.714 248.706C213.776 249.85 214.886 248.981 216.106 247.805C217.326 246.629 221.558 246.432 220.496 245.287Z",
    fill: "#B38B74"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M219.806 244.014C218.883 243.137 216.392 246.45 214.527 245.228C213.592 246.251 213.364 246.051 213.64 247.215C214.563 248.092 215.423 247.325 216.357 246.301C217.292 245.277 220.73 244.891 219.806 244.014Z",
    fill: "#B38B74"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M217.959 244.008C217.237 243.579 214.455 245.137 213.566 245.501C213.111 246.303 213.189 246.059 213.534 246.771C214.256 247.201 214.888 246.771 215.155 245.774C215.611 244.972 218.68 244.438 217.959 244.008Z",
    fill: "#B38B74"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M215.044 248.115C215.832 247.84 216.234 246.957 215.923 246.182C215.716 245.665 215.234 245.315 214.681 245.278L214.455 245.263C214.148 245.243 213.841 245.302 213.562 245.433L210.652 246.808C210.545 246.859 210.47 246.959 210.451 247.076C210.437 247.156 210.452 247.239 210.491 247.31L210.779 247.826C211.259 248.687 212.283 249.077 213.215 248.752L215.044 248.115Z",
    fill: "#B38B74"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M208.858 255.927C207.982 251.333 208.792 246.95 211.565 246.473C214.337 245.997 212.175 251.37 212.968 255.987C213.762 260.603 214.039 258.043 211.267 258.519C208.771 258.948 209.734 260.521 208.858 255.927Z",
    fill: "#B38B74"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M238.973 251.031C238.266 246.408 236.039 242.547 233.266 243.023C230.494 243.5 234.326 247.843 235.119 252.46C235.912 257.076 234.796 254.755 237.568 254.279C240.064 253.85 239.681 255.654 238.973 251.031Z",
    fill: "#B38B74"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M228.2 256.752L220.292 258.111",
    stroke: "#F2E144",
    strokeWidth: 0.39361
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M226.373 256.872C224.695 257.717 223.723 257.856 221.942 257.634L221.793 256.769L226.224 256.008L226.373 256.872Z",
    fill: "#A09A9A"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M228.762 256.662L228.226 256.902L228.167 256.558L228.762 256.662Z",
    fill: "#DBCAAB"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M228.762 256.662L228.673 256.702L228.663 256.643L228.762 256.662Z",
    fill: "black"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M220.317 258.261L219.942 258.325C219.87 258.337 219.803 258.289 219.79 258.218L219.776 258.133C219.763 258.062 219.811 257.994 219.883 257.982L220.258 257.917L220.317 258.261Z",
    fill: "#ED9191"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M236.572 282.286L234.048 282.719L233.94 282.09C234.991 282.274 235.541 282.157 236.464 281.656L236.572 282.286Z",
    fill: "black"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M224.523 284.415L221.999 284.849L221.891 284.219C222.942 284.403 223.492 284.287 224.415 283.785L224.523 284.415Z",
    fill: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.339 336.159L280.333 321.211L256.074 180.03L169.079 194.978L193.339 336.159Z",
    fill: "black",
    fillOpacity: 0.1
  })))), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M215.387 196.736C215.387 198.948 215.507 200.741 218.12 200.741C220.733 200.741 226.342 202.953 226.342 200.741C226.342 198.529 222.494 196.411 219.881 196.411C217.268 196.411 215.387 194.524 215.387 196.736Z",
    fill: "#C4C4C4"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M215.819 195.746C215.819 196.76 215.319 199.715 216.508 199.715C217.697 199.715 228.021 202.7 226.151 199.715C209.784 201.191 221.857 195.952 220.667 195.952C219.478 195.952 215.819 194.732 215.819 195.746Z",
    fill: "black"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M213.353 196.462C213.353 198.674 213.232 200.467 210.619 200.467C208.006 200.467 202.397 202.679 202.397 200.467C202.397 198.255 205.951 196.104 208.564 196.104C211.177 196.104 213.353 194.25 213.353 196.462Z",
    fill: "#C4C4C4"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M212.955 195.472C212.955 196.486 213.456 199.441 212.267 199.441C211.077 199.441 200.754 202.426 202.623 199.441C218.991 200.917 207.408 196.137 208.597 196.137C209.786 196.137 212.955 194.458 212.955 195.472Z",
    fill: "black"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M201.479 159.787H226.998L222.701 196.918H205.678L201.479 159.787Z",
    fill: "#617483"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M199.97 130.529C199.97 125.601 203.965 121.607 208.892 121.607H218.732C223.66 121.607 227.654 125.601 227.654 130.529V161.493C216.935 164.845 210.883 165.206 199.97 161.493V130.529Z",
    fill: "#C4C4C4"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M214.337 196.389L214.731 165.294",
    stroke: "black",
    strokeOpacity: 0.03,
    strokeWidth: 0.656017
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M218.19 118.238C218.19 123.334 220.772 125.084 213.92 125.084C207.068 125.084 208.925 123.334 208.925 118.238C208.925 113.142 207.068 109.011 213.92 109.011C220.772 109.011 218.19 113.142 218.19 118.238Z",
    fill: "#B38B74"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M221.037 108.344C219.277 115.867 218.129 116.949 213.908 116.949C209.687 116.949 207.982 115.08 206.265 108.344C203.98 101.402 209.687 97.662 213.908 97.662C218.129 97.662 222.983 101.795 221.037 108.344Z",
    fill: "#B38B74"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M207.409 107.098C207.409 108.034 207.667 110.127 206.863 110.127C206.059 110.127 204.497 108.034 204.497 107.098C204.497 106.162 205.149 105.403 205.953 105.403C206.757 105.403 207.409 106.162 207.409 107.098Z",
    fill: "#B38B74"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M219.887 107.098C219.887 108.034 219.629 110.127 220.433 110.127C221.238 110.127 222.8 108.034 222.8 107.098C222.8 106.162 222.148 105.403 221.344 105.403C220.539 105.403 219.887 106.162 219.887 107.098Z",
    fill: "#B38B74"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M219.887 107.098C219.887 108.034 219.629 110.127 220.433 110.127C221.238 110.127 222.8 108.034 222.8 107.098C222.8 106.162 222.148 105.403 221.344 105.403C220.539 105.403 219.887 106.162 219.887 107.098Z",
    fill: "#B38B74"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M216.994 111.765C216.994 112.316 216.651 112.836 216.05 113.227C215.451 113.616 214.614 113.863 213.681 113.863C212.748 113.863 211.911 113.616 211.312 113.227C210.711 112.836 210.368 112.316 210.368 111.765C210.368 111.623 210.391 111.54 210.417 111.493C210.44 111.453 210.47 111.43 210.519 111.417C210.575 111.402 210.657 111.401 210.772 111.419C210.886 111.437 211.02 111.472 211.175 111.519C211.28 111.55 211.394 111.587 211.515 111.626C212.1 111.814 212.86 112.059 213.681 112.059C214.502 112.059 215.262 111.814 215.847 111.626C215.968 111.587 216.082 111.55 216.187 111.519C216.342 111.472 216.476 111.437 216.59 111.419C216.705 111.401 216.787 111.402 216.843 111.417C216.892 111.43 216.922 111.453 216.945 111.493C216.971 111.54 216.994 111.623 216.994 111.765Z",
    fill: "white",
    stroke: "#D99584",
    strokeWidth: 0.328008
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M213.246 108.625C213.568 108.572 212.942 109.142 212.514 109.142C211.955 109.142 211.611 108.969 211.74 108.668C211.74 108.407 212.087 108.195 212.514 108.195C212.942 108.195 213.504 108.582 213.246 108.625Z",
    fill: "#C39C86"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M214.324 108.625C214.002 108.572 214.627 109.142 215.055 109.142C215.614 109.142 215.958 108.969 215.829 108.668C215.829 108.407 215.483 108.195 215.055 108.195C214.627 108.195 214.066 108.582 214.324 108.625Z",
    fill: "#C39C86"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M208.22 104.862H213.181V106.368C213.181 107.718 212.087 108.812 210.737 108.812H210.663C209.314 108.812 208.22 107.718 208.22 106.368V104.862Z",
    stroke: "black",
    strokeWidth: 0.361241
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M214.433 104.862H219.394V106.368C219.394 107.718 218.3 108.812 216.951 108.812H216.877C215.527 108.812 214.433 107.718 214.433 106.368V104.862Z",
    stroke: "black",
    strokeWidth: 0.361241
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M214.599 106.519C214.599 106.45 214.579 106.381 214.539 106.318C214.5 106.254 214.442 106.196 214.369 106.147C214.296 106.099 214.209 106.06 214.113 106.034C214.018 106.007 213.916 105.994 213.812 105.994C213.709 105.994 213.606 106.007 213.511 106.034C213.415 106.06 213.329 106.099 213.255 106.147C213.182 106.196 213.124 106.254 213.085 106.318C213.045 106.381 213.025 106.45 213.025 106.519L213.255 107.076C213.255 107.053 213.553 106.472 213.567 106.451C213.58 106.429 213.6 106.41 213.624 106.393C213.649 106.377 213.678 106.364 213.71 106.355C213.743 106.346 213.777 106.341 213.812 106.341C213.847 106.341 213.882 106.346 213.914 106.355C213.946 106.364 213.975 106.377 214 106.393C214.025 106.41 214.044 106.429 214.058 106.451C214.071 106.472 214.369 107.053 214.369 107.076L214.599 106.519Z",
    fill: "black"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M214.271 104.682H213.353V106.191H214.271V104.682Z",
    fill: "black"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M205.799 106.847C204.846 107.412 206.395 107.768 205.799 108.421",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M221.629 106.847C222.582 107.412 221.032 107.768 221.629 108.421",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M213.848 109.657C214.727 109.657 215.44 109.234 215.44 108.711C215.44 108.188 214.727 107.765 213.848 107.765C212.969 107.765 212.256 108.188 212.256 108.711C212.256 109.234 212.969 109.657 213.848 109.657Z",
    fill: "#CFA68F"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M217.104 112.095C217.104 112.783 215.649 114.719 213.693 114.719C211.736 114.719 210.249 112.553 210.249 111.865C210.249 111.177 211.736 113.61 213.693 113.61C215.649 113.61 217.104 111.406 217.104 112.095Z",
    fill: "#D99584"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M211.975 105.562C211.975 105.919 211.161 105.419 210.354 105.419C209.546 105.419 208.892 105.968 208.892 105.611C208.892 105.254 209.546 105.141 210.354 105.141C211.161 105.141 211.975 105.205 211.975 105.562Z",
    fill: "black"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M218.535 105.674C218.535 106.053 217.719 105.436 216.983 105.436C216.246 105.436 215.649 105.95 215.649 105.571C215.649 105.192 216.246 105.141 216.983 105.141C217.719 105.141 218.535 105.295 218.535 105.674Z",
    fill: "black"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M207.777 109.175C207.777 110.915 208.284 111.898 207.777 111.898C207.27 111.898 206.151 109.931 206.151 108.191C206.151 106.452 205.219 103.452 206.151 102.812C207.777 101.697 207.777 107.436 207.777 109.175Z",
    fill: "black"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M219.548 109.338C219.548 111.077 219.041 112.061 219.548 112.061C220.055 112.061 221.174 110.093 221.174 108.354C221.174 106.615 222.107 103.747 221.174 103.107C219.548 101.992 219.548 107.599 219.548 109.338Z",
    fill: "black"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M206.203 99.63C206.203 96.732 208.552 94.382 211.451 94.382H215.78C218.679 94.382 221.029 96.732 221.029 99.63V103.566H206.203V99.63Z",
    fill: "#D6C2A2"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M205.743 103.567C205.743 102.117 206.918 100.942 208.367 100.942H218.864C220.313 100.942 221.488 102.117 221.488 103.567H205.743Z",
    fill: "#836B3D"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M220.635 113.983C220.635 117.578 217.58 120.492 213.812 120.492C210.044 120.492 206.99 117.578 206.99 113.983C206.99 100.552 210.044 115.941 213.812 115.941C217.58 115.941 220.635 100.414 220.635 113.983Z",
    fill: "url(#paint35_linear_57_182)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M218.339 110.947C218.339 111.653 216.356 110.783 213.911 110.783C211.465 110.783 209.482 111.653 209.482 110.947C209.482 110.24 211.465 109.667 213.911 109.667C216.356 109.667 218.339 110.24 218.339 110.947Z",
    fill: "black"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M215.846 96.252H211.385C211.113 96.252 210.893 96.4722 210.893 96.744V99.04C210.893 99.3118 211.113 99.532 211.385 99.532H215.846C216.118 99.532 216.338 99.3118 216.338 99.04V96.744C216.338 96.4722 216.118 96.252 215.846 96.252Z",
    fill: "#E5E5E5",
    stroke: "#79643D",
    strokeWidth: 0.0656017
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M210.532 107.503C211.293 107.503 211.91 107.106 211.91 106.617C211.91 106.128 211.293 105.731 210.532 105.731C209.771 105.731 209.154 106.128 209.154 106.617C209.154 107.106 209.771 107.503 210.532 107.503Z",
    fill: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M210.532 107.503C211.293 107.503 211.91 107.106 211.91 106.617C211.91 106.128 211.293 105.731 210.532 105.731C209.771 105.731 209.154 106.128 209.154 106.617C209.154 107.106 209.771 107.503 210.532 107.503Z",
    fill: "white"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M217.092 107.437C217.853 107.437 218.47 107.04 218.47 106.551C218.47 106.062 217.853 105.665 217.092 105.665C216.331 105.665 215.714 106.062 215.714 106.551C215.714 107.04 216.331 107.437 217.092 107.437Z",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M210.565 107.24C210.909 107.24 211.188 106.961 211.188 106.617C211.188 106.273 210.909 105.994 210.565 105.994C210.221 105.994 209.942 106.273 209.942 106.617C209.942 106.961 210.221 107.24 210.565 107.24Z",
    fill: "#C4C4C4"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M210.565 107.24C210.909 107.24 211.188 106.961 211.188 106.617C211.188 106.273 210.909 105.994 210.565 105.994C210.221 105.994 209.942 106.273 209.942 106.617C209.942 106.961 210.221 107.24 210.565 107.24Z",
    fill: "#413026"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M231.383 129.576C231.426 126.179 228.868 123.311 225.489 122.966L219.88 122.394L223.915 141.615H231.229L231.383 129.576Z",
    fill: "#C4C4C4"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M216.994 107.24C217.338 107.24 217.617 106.961 217.617 106.617C217.617 106.273 217.338 105.994 216.994 105.994C216.65 105.994 216.371 106.273 216.371 106.617C216.371 106.961 216.65 107.24 216.994 107.24Z",
    fill: "#413026"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M218.503 131.677H224.013V136.958C224.013 137.664 223.44 138.237 222.734 138.237H219.782C219.075 138.237 218.503 137.664 218.503 136.958V131.677Z",
    stroke: "#939191",
    strokeWidth: 0.0656017
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M196.314 129.788C196.266 126.524 198.626 123.722 201.85 123.213L208.695 122.132L203.775 142.14L196.493 142.042L196.314 129.788Z",
    fill: "#C4C4C4"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M205.087 104.944H208.039V105.666C206.881 105.26 206.234 105.284 205.087 105.666V104.944Z",
    fill: "black"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M219.191 104.879H222.143V105.6C220.985 105.194 220.338 105.218 219.191 105.6V104.879Z",
    fill: "black"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M206.325 136.553C206.294 135.808 206.89 135.187 207.636 135.187H220.765C221.515 135.187 222.113 135.814 222.075 136.563L221.189 154.473C221.154 155.171 220.578 155.72 219.878 155.72H208.38C207.676 155.72 207.098 155.165 207.069 154.462L206.325 136.553Z",
    fill: "#B9A689"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M205.774 145.916C206.838 146.042 207.578 147.036 207.394 148.091C207.271 148.8 206.752 149.375 206.059 149.57L205.753 149.657C205.372 149.764 204.97 149.774 204.585 149.687L200.453 148.751C200.305 148.718 200.183 148.614 200.127 148.474C200.087 148.375 200.082 148.265 200.114 148.164L200.343 147.428C200.718 146.221 201.901 145.454 203.156 145.603L205.774 145.916Z",
    fill: "#B38B74"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M206.792 142.746C207.925 144.592 204.407 145.815 205.042 146.849C203.023 148.088 201.168 146.598 199.335 145.751C198.202 143.905 201.36 146.627 203.38 145.388C205.399 144.149 205.66 140.901 206.792 142.746Z",
    fill: "#B38B74"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M213.1 147.242C212.247 148.838 207.471 146.708 206.993 147.602C205.247 146.669 203.383 147.501 203.22 145.822C204.073 144.227 205.599 144.853 207.345 145.787C209.091 146.72 213.953 145.647 213.1 147.242Z",
    fill: "#B38B74"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M212.356 149.03C211.373 150.507 206.913 147.979 206.362 148.806C204.746 147.731 202.849 148.368 202.848 146.714C203.831 145.237 205.261 145.992 206.877 147.068C208.493 148.143 213.339 147.554 212.356 149.03Z",
    fill: "#B38B74"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M211.82 150.579C210.942 151.732 207.755 148.656 205.874 150.373C204.613 149.413 204.104 149.544 204.19 148.196C205.068 147.043 206.195 147.733 207.456 148.694C208.717 149.655 212.698 149.426 211.82 150.579Z",
    fill: "#B38B74"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M209.723 150.94C208.987 151.556 205.522 150.352 204.441 150.117C203.767 149.312 203.904 149.569 204.157 148.71C204.893 148.094 205.695 148.452 206.193 149.51C206.867 150.315 210.458 150.323 209.723 150.94Z",
    fill: "#B38B74"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M205.648 146.932C206.577 147.084 207.188 147.984 206.987 148.903C206.852 149.521 206.375 150.006 205.76 150.151L205.487 150.215C205.149 150.294 204.796 150.288 204.461 150.197L200.87 149.219C200.742 149.184 200.639 149.088 200.595 148.963C200.563 148.875 200.564 148.779 200.595 148.69L200.824 148.053C201.199 147.009 202.267 146.38 203.362 146.559L205.648 146.932Z",
    fill: "#B38B74"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M221.692 142.914C220.559 144.76 224.076 145.982 223.442 147.017C225.461 148.256 227.316 146.766 229.149 145.919C230.281 144.073 227.124 146.795 225.104 145.556C223.085 144.316 222.824 141.068 221.692 142.914Z",
    fill: "#B38B74"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M215.383 147.41C216.237 149.006 221.013 146.875 221.491 147.77C223.237 146.836 225.101 147.669 225.264 145.99C224.411 144.394 222.885 145.021 221.139 145.954C219.393 146.888 214.53 145.814 215.383 147.41Z",
    fill: "#B38B74"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M216.127 149.198C217.11 150.675 221.571 148.146 222.121 148.974C223.737 147.899 225.635 148.535 225.636 146.882C224.653 145.405 223.223 146.16 221.607 147.235C219.991 148.311 215.145 147.721 216.127 149.198Z",
    fill: "#B38B74"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M216.663 150.747C217.541 151.899 221.017 148.689 222.898 150.406C224.159 149.445 224.379 149.712 224.293 148.363C223.415 147.211 222.289 147.901 221.028 148.861C219.766 149.822 215.785 149.594 216.663 150.747Z",
    fill: "#B38B74"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M218.761 151.107C219.497 151.723 222.962 150.52 224.043 150.285C224.717 149.48 224.58 149.736 224.327 148.878C223.591 148.262 222.789 148.619 222.291 149.678C221.617 150.483 218.025 150.491 218.761 151.107Z",
    fill: "#B38B74"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M223.228 146.945C222.299 147.096 221.688 147.996 221.888 148.915C222.023 149.533 222.501 150.018 223.116 150.163L223.388 150.227C223.727 150.307 224.079 150.3 224.415 150.209L228.005 149.231C228.133 149.196 228.236 149.101 228.281 148.975C228.312 148.887 228.312 148.791 228.28 148.703L228.051 148.066C227.676 147.021 226.609 146.392 225.513 146.571L223.228 146.945Z",
    fill: "#B38B74"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M231.426 139.582C231.525 144.863 229.749 149.586 226.506 149.586C223.263 149.586 226.768 144.019 226.768 138.729C226.768 133.439 225.953 136.236 229.196 136.236C232.115 136.236 231.328 134.301 231.426 139.582Z",
    fill: "#B38B74"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M196.258 139.271C196.16 144.552 197.935 149.275 201.178 149.275C204.421 149.275 200.916 143.708 200.916 138.418C200.916 133.129 201.731 135.925 198.488 135.925C195.569 135.925 196.356 133.99 196.258 139.271Z",
    fill: "#B38B74"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M209.614 134.99H218.864",
    stroke: "#F2E144",
    strokeWidth: 0.39361
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M211.713 135.18C213.784 134.561 214.916 134.592 216.895 135.18V136.171H211.713V135.18Z",
    fill: "#A09A9A"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M208.958 134.957L209.614 134.793V135.187L208.958 134.957Z",
    fill: "#DBCAAB"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M208.958 134.957L209.067 134.929V134.997L208.958 134.957Z",
    fill: "black"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M218.864 134.793H219.323C219.395 134.793 219.454 134.852 219.454 134.924V135.055C219.454 135.128 219.395 135.187 219.323 135.187H218.864V134.793Z",
    fill: "#ED9191"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M223.349 145.768C222.286 145.895 221.546 146.888 221.729 147.944C221.852 148.653 222.372 149.228 223.064 149.423L223.371 149.509C223.752 149.617 224.153 149.627 224.539 149.54L228.671 148.604C228.818 148.57 228.94 148.467 228.997 148.326C229.037 148.227 229.041 148.118 229.01 148.016L228.781 147.28C228.405 146.073 227.222 145.306 225.967 145.456L223.349 145.768Z",
    fill: "#B38B74"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_57_182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_57_182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 197,
    width: 61,
    height: 76
  }, _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4993 257.906C60.9703 259.396 61.6023 257.928 58.1413 257.315C54.6803 256.702 54.5343 258.309 51.9673 255.686C51.4823 258.424 53.8943 261.141 57.3553 261.754C60.8153 262.367 64.0143 260.644 64.4993 257.906Z",
    fill: "#EEDDA0"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M68.629 202.619C68.876 201.225 69.172 200.111 71.23 200.476C73.288 200.841 77.954 200.229 77.707 201.623C77.46 203.018 74.191 203.816 72.133 203.451C70.075 203.087 68.382 204.014 68.629 202.619Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M68.864 203.315C68.977 202.673 68.912 200.731 69.855 200.898C70.798 201.065 79.319 200.624 77.502 202.252C64.689 199.019 72.641 203.664 71.698 203.497C70.755 203.33 68.75 203.958 68.864 203.315Z",
    fill: "#E1AAC4"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0031 202.156C66.2371 200.759 66.3321 199.611 64.2721 199.258C62.2111 198.905 58.0231 196.751 57.7881 198.148C57.5541 199.545 60.3641 201.402 62.4241 201.754C64.4851 202.107 65.7681 203.552 66.0031 202.156Z",
    fill: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5493 202.732C65.6573 202.089 66.3693 200.282 65.4253 200.121C64.4813 199.959 56.6053 196.662 57.7713 198.81C70.9193 200.098 61.8753 201.783 62.8193 201.944C63.7633 202.106 65.4403 203.375 65.5493 202.732Z",
    fill: "#E1AAC4"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1831 230.175L71.7991 233.622C74.2631 219.653 72.3441 213.436 72.5261 203.444L68.3051 202.496C62.1721 212.926 76.3031 218.665 55.1831 230.175Z",
    fill: "#65BAC6"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5761 232.856L53.6621 231.829C55.3131 217.751 59.0671 211.246 61.7491 201.703L66.0281 202.213C68.8701 214.157 53.8141 214.885 70.5761 232.856Z",
    fill: "#65BAC6"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8402 257.053C88.8572 256.555 87.3232 255.279 87.8932 255C87.1382 254.049 85.8162 254.045 84.6702 253.983C83.6532 254.481 85.9362 254.274 86.6922 255.225C87.4472 256.175 86.8232 257.552 87.8402 257.053Z",
    fill: "#F3CEB9"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1544 256.626C92.0854 255.789 89.1164 255.596 89.0784 255.127C87.9574 255.119 87.1874 254.368 86.7104 255.013C86.7794 255.85 87.7154 255.934 88.8364 255.942C89.9574 255.95 92.2224 257.463 92.1544 256.626Z",
    fill: "#F3CEB9"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1861 255.735C92.0231 254.918 89.1251 254.956 89.0331 254.498C87.9461 254.576 87.1131 253.897 86.7261 254.569C86.8901 255.386 87.8061 255.396 88.8931 255.318C89.9801 255.239 92.3501 256.553 92.1861 255.735Z",
    fill: "#F3CEB9"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2711 254.988C92.0861 254.325 89.8121 254.905 89.2401 253.791C88.3631 253.902 88.0371 253.698 87.7671 254.265C87.9521 254.927 88.6961 254.897 89.5721 254.786C90.4491 254.676 92.4561 255.65 92.2711 254.988Z",
    fill: "#F3CEB9"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2702 254.377C91.0332 253.963 88.4942 253.552 87.8802 253.407C87.3432 253.585 87.9392 253.644 87.8702 254.048C88.1062 254.461 88.6052 254.494 89.1102 254.175C89.6472 253.997 91.5062 254.79 91.2702 254.377Z",
    fill: "#F3CEB9"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4413 255.161C88.8423 255.273 89.2643 255.031 89.3713 254.628C89.4493 254.333 89.3363 254.025 89.0873 253.854L88.8633 253.701C88.7373 253.614 88.5933 253.554 88.4413 253.525L86.2593 253.108C86.2023 253.097 86.1433 253.112 86.0973 253.148C86.0543 253.182 86.0263 253.232 86.0213 253.285L85.9873 253.633C85.9403 254.109 86.2383 254.545 86.7003 254.674L88.4413 255.161Z",
    fill: "#F3CEB9"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8542 247.149C48.9092 250.954 51.2782 254.841 55.1382 255.525L61.7622 256.698C65.4122 257.345 68.8682 254.84 69.3442 251.165C70.5182 242.097 71.3532 234.782 73.2082 230.93C65.6012 228.461 61.1122 227.638 52.6662 227.292C52.1692 235.368 51.4562 240.701 49.8542 247.149Z",
    fill: "#848484"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7553 232.539C36.8673 231.793 35.7673 233.192 35.2693 232.774C34.3393 233.506 34.7093 234.563 34.9583 235.487C35.8463 236.232 34.9503 234.436 35.8803 233.704C36.8103 232.971 38.6433 233.284 37.7553 232.539Z",
    fill: "#F3CEB9"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0194 229.15C35.0314 229.318 35.6394 231.716 35.0864 231.81C35.3944 232.707 34.7084 233.424 35.6204 233.717C36.6084 233.549 36.4444 232.79 36.1354 231.893C35.8274 230.996 37.0064 228.982 36.0194 229.15Z",
    fill: "#F3CEB9"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9373 229.244C34.0003 229.486 34.8673 231.796 34.3423 231.931C34.7443 232.789 34.1633 233.547 35.0803 233.765C36.0183 233.524 35.7713 232.79 35.3683 231.932C34.9663 231.074 35.8743 229.003 34.9373 229.244Z",
    fill: "#F3CEB9"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0141 229.278C33.2691 229.515 34.6111 231.253 33.4331 231.861C33.8141 232.547 33.6621 232.835 34.4201 232.975C35.1651 232.737 34.9171 232.147 34.5361 231.461C34.1541 230.775 34.7591 229.04 34.0141 229.278Z",
    fill: "#F3CEB9"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5622 230.161C33.1322 230.406 33.3562 232.49 33.3562 233C33.7222 233.405 33.6242 232.921 34.1302 232.922C34.5602 232.677 34.4582 232.274 33.9312 231.913C33.5652 231.509 33.9922 229.915 33.5622 230.161Z",
    fill: "#F3CEB9"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2813 232.72C35.3163 232.169 34.8753 231.672 34.3203 231.639C33.9833 231.619 33.6723 231.778 33.5023 232.058L33.4833 232.088C33.3813 232.256 33.3333 232.455 33.3463 232.659L33.4523 234.282C33.4573 234.361 33.5033 234.434 33.5743 234.474C33.6123 234.496 33.6553 234.506 33.6973 234.504L34.0333 234.489C34.6923 234.458 35.2033 233.956 35.2453 233.297L35.2813 232.72Z",
    fill: "#F3CEB9"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2243 256.399C61.5383 254.627 63.6673 253.127 58.8733 252.278C54.0793 251.428 55.0563 253.479 54.7423 255.251C54.4283 257.023 52.6113 258.175 57.4053 259.024C62.2003 259.873 60.9103 258.171 61.2243 256.399Z",
    fill: "#F3CEB9"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2731 256.513C58.5791 255.929 57.6251 255.76 56.7721 256.07L56.6431 256.117C54.2051 257.004 54.5131 260.547 57.0681 260.999L57.3021 261.041C59.8571 261.493 61.3631 258.272 59.3781 256.602L59.2731 256.513Z",
    fill: "#E4CFB0"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3091 264.632C63.4251 259.185 63.6381 258.105 57.9481 257.098C52.2581 256.09 52.9791 257.175 49.3851 261.988C48.6381 266.206 51.3731 270.218 55.4941 270.948C59.6161 271.678 63.5621 268.85 64.3091 264.632Z",
    fill: "#F3CEB9"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2734 256.299C58.6224 255.825 57.7894 255.678 57.0154 255.899C54.3454 256.661 54.5434 260.509 57.2774 260.993C60.0114 261.477 61.5194 257.931 59.2734 256.299Z",
    fill: "#F3CEB9"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0785 259.798C60.0555 259.926 58.5805 259.533 57.6695 259.371C56.7575 259.21 55.0095 259.134 55.0325 259.006C55.0555 258.878 56.8475 258.7 57.7595 258.862C58.6715 259.023 60.1005 259.67 60.0785 259.798Z",
    fill: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M60.035 259.853C60.012 259.981 58.492 259.659 57.58 259.498C56.669 259.336 55.112 259.113 55.135 258.985C55.158 258.857 56.878 258.152 57.79 258.314C58.702 258.475 60.058 259.725 60.035 259.853Z",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1933 259.892C60.2163 259.764 58.9203 258.275 57.8063 258.078C56.6923 257.88 54.8503 258.913 54.8283 259.041C54.8053 259.169 56.6373 258.189 57.7513 258.386C58.8663 258.584 60.1713 260.02 60.1933 259.892Z",
    fill: "#DE4C66"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2953 259.877C60.2733 260.005 58.6303 260.14 57.5593 259.658C56.5903 259.725 54.8053 259.169 54.8283 259.041C54.8513 258.913 56.4913 259.203 57.6053 259.4C58.7193 259.598 60.3183 259.749 60.2953 259.877Z",
    fill: "#DE4C66"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9761 264.311C56.0441 263.927 55.1041 264.369 54.1141 264.193C53.1231 264.018 52.8371 263.755 52.4071 263.386C52.3391 263.77 53.0871 264.224 54.0771 264.399C55.0681 264.575 55.9081 264.694 55.9761 264.311Z",
    fill: "#D5C1A0"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M57.902 264.625C57.97 264.241 58.778 264.913 59.768 265.089C60.759 265.264 61.118 265.115 61.648 264.917C61.58 265.301 60.722 265.47 59.732 265.295C58.741 265.119 57.834 265.009 57.902 264.625Z",
    fill: "#C4B397"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3144 261.872C55.3504 260.973 56.2254 260.853 56.7014 261.167",
    stroke: "black",
    strokeWidth: 0.0713772
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8724 262.146C59.0874 261.633 58.3904 261.237 57.8354 261.368",
    stroke: "black",
    strokeWidth: 0.0713772
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4911 261.101C56.6076 261.122 56.6975 261.164 56.692 261.195C56.6864 261.227 56.5876 261.235 56.4711 261.214C56.3547 261.194 56.2647 261.152 56.2703 261.121C56.2758 261.089 56.3747 261.081 56.4911 261.101Z",
    fill: "black"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0512 261.377C58.1676 261.398 58.2575 261.44 58.252 261.471C58.2465 261.503 58.1476 261.511 58.0312 261.49C57.9147 261.47 57.8248 261.428 57.8303 261.397C57.8358 261.365 57.9347 261.357 58.0512 261.377Z",
    fill: "black"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0632 263.36C55.7112 263.173 55.3962 262.721 54.7532 262.673C54.1102 262.625 53.5402 262.77 53.5352 263.043C53.9582 263.335 54.0461 263.578 54.6891 263.626C55.3321 263.674 55.5892 263.549 56.0632 263.36Z",
    fill: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7799 262.685C54.5323 262.641 54.3029 262.766 54.2677 262.966C54.2324 263.165 54.4046 263.361 54.6522 263.405C54.8998 263.449 55.1292 263.323 55.1644 263.124C55.1997 262.925 55.0275 262.728 54.7799 262.685Z",
    fill: "url(#paint36_radial_57_182)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0632 263.36C55.7112 263.173 55.3662 263.481 54.7232 263.432C54.0802 263.384 53.5402 262.77 53.5352 263.043C53.9582 263.335 54.0461 263.578 54.6891 263.626C55.3321 263.674 55.5892 263.549 56.0632 263.36Z",
    fill: "#D3AC97"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6123 263.635C58.0083 263.58 58.4593 263.264 59.0793 263.439C59.7003 263.615 60.1853 263.947 60.0963 264.206C59.5983 264.334 59.4333 264.532 58.8123 264.356C58.1913 264.181 57.9933 263.975 57.6123 263.635Z",
    fill: "white"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0502 263.441C59.2978 263.484 59.47 263.681 59.4347 263.88C59.3994 264.079 59.1701 264.205 58.9225 264.161C58.6749 264.117 58.5027 263.921 58.538 263.722C58.5732 263.523 58.8025 263.397 59.0502 263.441Z",
    fill: "url(#paint37_radial_57_182)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6123 263.635C58.0083 263.58 58.2263 263.987 58.8463 264.163C59.4673 264.338 60.1853 263.947 60.0963 264.206C59.5983 264.334 59.4333 264.532 58.8123 264.356C58.1913 264.181 57.9933 263.975 57.6123 263.635Z",
    fill: "#D3AC97"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M54.86 259.042C54.722 259.044 54.632 259.076 54.561 259.122",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M54.52 258.996C54.553 259.108 54.612 259.178 54.684 259.233",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1172 259.814C60.2472 259.864 60.3202 259.924 60.3712 259.992",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4533 259.888C60.3833 259.982 60.3043 260.027 60.2183 260.054",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6915 261.216C61.1867 261.304 61.529 261.709 61.456 262.122C61.383 262.534 60.9223 262.797 60.427 262.709C59.9318 262.622 59.5895 262.216 59.6625 261.804C59.7355 261.392 60.1962 261.129 60.6915 261.216Z",
    fill: "#E99985"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2764 260.133C54.7717 260.221 55.114 260.626 55.0409 261.039C54.9679 261.451 54.5072 261.714 54.012 261.626C53.5167 261.539 53.1744 261.133 53.2475 260.721C53.3205 260.309 53.7812 260.046 54.2764 260.133Z",
    fill: "#E99985"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7012 261.167C57.1852 260.85 57.4292 260.916 57.8352 261.368",
    stroke: "black",
    strokeWidth: 0.0719827
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M60.145 264.449L60.024 264.222",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0073 264.478L59.8863 264.251",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8589 264.559L59.7379 264.332",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7202 264.588L59.5992 264.361",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4688 264.657L59.4243 264.416",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M59.166 264.69L59.179 264.424",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9722 264.655L59.0041 264.418",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M58.751 264.61L58.8399 264.386",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5381 264.573L58.627 264.349",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M58.353 264.487L58.4419 264.263",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1694 264.401L58.2583 264.177",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0249 264.312L58.1648 264.108",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9365 264.133L58.051 264.045",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7944 264.001L57.9089 263.913",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6836 263.875L57.7981 263.787",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3882 263.253L53.5799 263.081",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5083 263.328L53.7001 263.156",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6191 263.455L53.8109 263.283",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7383 263.53L53.93 263.357",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9521 263.681L54.0767 263.47",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2241 263.816L54.3031 263.562",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M54.418 263.85L54.4696 263.616",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6416 263.883L54.6352 263.642",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8545 263.922L54.8481 263.681",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0566 263.905L55.0503 263.664",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2607 263.887L55.2544 263.646",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4268 263.852L55.3654 263.613",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5708 263.716L55.4936 263.593",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7495 263.641L55.6723 263.519",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8965 263.56L55.8193 263.437",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4881 263.19C56.5061 262.977 56.3731 262.733 56.0721 262.515C55.7761 262.299 55.3451 262.131 54.8491 262.073C54.3791 262.018 53.7201 262.223 53.1591 262.532C52.8811 262.684 52.6381 262.856 52.4641 263.022C52.4111 263.072 52.3651 263.121 52.3281 263.167C52.5431 263.134 52.7331 263.133 52.9051 263.159C53.1651 263.197 53.3751 263.291 53.5631 263.396C53.6521 263.446 53.7351 263.497 53.8151 263.546C54.0831 263.711 54.3251 263.86 54.6911 263.903C55.1881 263.962 55.6391 263.898 55.9661 263.756C56.2971 263.612 56.4691 263.404 56.4881 263.19Z",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3382 263.341C57.3942 263.134 57.6032 262.951 57.9602 262.849C58.3132 262.748 58.7752 262.739 59.2612 262.855C59.7212 262.964 60.2702 263.384 60.6912 263.866C60.8992 264.105 61.0682 264.35 61.1752 264.566C61.2072 264.631 61.2332 264.692 61.2532 264.748C61.0622 264.643 60.8842 264.577 60.7142 264.542C60.4572 264.488 60.2272 264.504 60.0142 264.539C59.9132 264.555 59.8182 264.575 59.7262 264.593C59.4172 264.656 59.1392 264.713 58.7802 264.627C58.2942 264.512 57.8922 264.297 57.6342 264.052C57.3722 263.802 57.2822 263.548 57.3382 263.341Z",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M51.047 257.302C54.193 257.328 49.229 261.804 49.442 264.461C49.655 267.118 61.177 268.808 53.083 269.299C53.22 267.759 47.805 268.939 47.592 266.282C47.379 263.625 53.974 258.097 51.047 257.302Z",
    fill: "#EEDDA0"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0474 257.302C54.1944 257.328 50.2554 262.054 50.4694 264.711C50.6824 267.368 56.8024 268.111 48.7084 268.602C48.8454 267.063 48.8894 268.836 48.6764 266.179C48.4634 263.522 53.9744 258.097 51.0474 257.302Z",
    fill: "#EEDDA0"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1284 259.436C62.1644 258.38 62.8904 264.081 61.7774 266.503C60.5144 267.615 52.6784 269.094 60.1114 272.336C60.5114 270.843 63.6604 269.881 64.7724 267.459C65.8854 265.037 62.1064 259.177 65.1284 259.436Z",
    fill: "#EEDDA0"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3303 263.475C55.3103 262.821 51.4833 266.866 52.1993 268.593C52.9163 270.32 64.1373 268.988 56.5803 271.043C56.4113 269.987 50.6033 270.827 49.8873 269.1C49.1713 267.374 55.2513 263.38 52.3303 263.475Z",
    fill: "#EEDDA0"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M50.658 262.572C53.638 261.918 49.811 265.963 50.527 267.69C51.243 269.416 57.949 268.354 50.392 270.409C50.223 269.353 48.931 269.924 48.215 268.197C47.498 266.47 53.579 262.477 50.658 262.572Z",
    fill: "#EEDDA0"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5314 264.223C56.5104 263.569 52.6834 267.614 53.4004 269.341C54.1164 271.068 70.7044 264.815 57.7804 271.791C57.6614 272.464 51.8044 271.575 51.0874 269.848C50.3714 268.122 56.4524 264.128 53.5314 264.223Z",
    fill: "#EEDDA0"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5554 264.458C57.5354 263.804 53.7074 267.849 54.4244 269.576C55.1404 271.303 60.0284 268.092 52.4714 270.147C52.3014 269.091 52.8284 271.81 52.1114 270.083C51.3954 268.357 57.4764 264.363 54.5554 264.458Z",
    fill: "#EEDDA0"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8462 264.687C58.8262 264.033 54.9992 268.078 55.7162 269.805C56.4322 271.531 60.3192 268.144 52.7612 270.198C52.5922 269.142 54.1202 272.039 53.4032 270.312C52.6872 268.585 58.7672 264.592 55.8462 264.687Z",
    fill: "#EEDDA0"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M56.825 264.807C59.805 264.152 55.978 268.198 56.694 269.924C57.41 271.651 61.939 268.377 54.381 270.432C54.212 269.376 55.098 272.159 54.382 270.432C53.665 268.705 59.746 264.712 56.825 264.807Z",
    fill: "#EEDDA0"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4101 263.756C63.4941 263.282 63.5911 262.208 63.8731 262.258C64.1541 262.308 64.5141 263.463 64.4301 263.936C64.3461 264.409 64.0501 264.753 63.7681 264.703C63.4871 264.653 63.3271 264.229 63.4101 263.756Z",
    fill: "#F3CEB9"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8643 263.978C64.1823 263.746 63.7773 263.492 64.0023 263.199",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8704 261.427C50.9544 260.954 51.2314 259.912 50.9504 259.862C50.6684 259.812 49.9344 260.773 49.8504 261.246C49.7664 261.72 49.9274 262.144 50.2084 262.194C50.4904 262.243 50.7864 261.9 50.8704 261.427Z",
    fill: "#F3CEB9"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3672 261.48C50.1482 261.153 50.6162 261.054 50.5052 260.701",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8153 252.436C50.1043 253.648 53.2093 252.932 54.7383 250.841L37.7793 241.964L35.1743 245.742L47.8153 252.436Z",
    fill: "#848484"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3334 255.707C63.4874 256.738 60.8365 253.246 63.3475 251.772L74.3034 247.694L77.1244 251.797L66.3334 255.707Z",
    fill: "#848484"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1553 252.735C58.1203 252.143 59.3943 252.328 61.9703 253.943L66.4903 228.99C63.7513 228.282 62.1963 228.035 59.3793 227.763L55.1553 252.735Z",
    fill: "#E1AAC4"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6064 262.058L52.8954 262.757",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4814 263.046C56.7154 263.479 56.9134 263.505 57.3624 263.229",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3993 264.245L61.0093 264.115",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4591 259.497C51.4891 259.324 51.4651 259.159 51.4011 259.033C51.3381 258.907 51.2371 258.822 51.1161 258.8C50.9951 258.779 50.8711 258.824 50.7681 258.921C50.6651 259.018 50.5851 259.164 50.5541 259.337C50.5241 259.51 50.5491 259.674 50.6121 259.8C50.6751 259.926 50.7761 260.012 50.8971 260.033C51.0191 260.055 51.1431 260.009 51.2451 259.912C51.3481 259.816 51.4281 259.67 51.4591 259.497Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3113 259.578C51.3423 259.405 51.3173 259.24 51.2543 259.114C51.1903 258.988 51.0903 258.903 50.9683 258.881C50.8473 258.86 50.7233 258.905 50.6203 259.002C50.5183 259.099 50.4383 259.245 50.4073 259.418C50.3763 259.591 50.4013 259.755 50.4653 259.881C50.5283 260.007 50.6293 260.093 50.7503 260.114C50.8713 260.136 50.9953 260.09 51.0983 259.993C51.2013 259.897 51.2813 259.751 51.3113 259.578Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5354 262.027C64.5664 261.854 64.5415 261.69 64.4775 261.564C64.4145 261.438 64.3134 261.352 64.1924 261.331C64.0714 261.309 63.9474 261.355 63.8444 261.452C63.7414 261.548 63.6614 261.694 63.6314 261.867C63.6004 262.04 63.6254 262.205 63.6884 262.331C63.7524 262.457 63.8524 262.542 63.9744 262.564C64.0954 262.585 64.2195 262.54 64.3225 262.443C64.4245 262.346 64.5044 262.2 64.5354 262.027Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M64.388 262.108C64.418 261.935 64.393 261.771 64.33 261.645C64.267 261.519 64.166 261.433 64.045 261.411C63.923 261.39 63.799 261.436 63.697 261.532C63.594 261.629 63.514 261.775 63.483 261.948C63.453 262.121 63.477 262.286 63.541 262.412C63.604 262.538 63.705 262.623 63.826 262.645C63.947 262.666 64.071 262.62 64.174 262.524C64.277 262.427 64.357 262.281 64.388 262.108Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0682 245.59L40.2712 243.761C38.0802 239.884 37.1322 237.704 36.1062 233.798C34.1962 233.973 33.0662 234.024 32.6992 235.456C33.9642 239.354 34.5362 241.416 35.0682 245.59Z",
    fill: "#848484"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3444 247.647L73.9824 252.549C79.0474 253.345 81.7634 253.988 86.3144 255.607C87.0254 254.181 87.5014 253.369 86.1804 252.261C81.5274 250.813 78.9434 249.768 74.3444 247.647Z",
    fill: "#848484"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4394 252.073C54.5643 252.095 54.6511 252.195 54.6333 252.295C54.6155 252.395 54.4999 252.459 54.375 252.437C54.2501 252.415 54.1633 252.315 54.1811 252.215C54.1989 252.115 54.3145 252.051 54.4394 252.073Z",
    fill: "#ABA4A4"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2245 253.629C63.3494 253.651 63.4362 253.751 63.4184 253.851C63.4007 253.951 63.285 254.015 63.1602 253.993C63.0353 253.971 62.9485 253.871 62.9663 253.771C62.984 253.671 63.0997 253.607 63.2245 253.629Z",
    fill: "#ABA4A4"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3711 252.275C56.1181 249.525 53.1501 247.883 55.3911 245.013",
    stroke: "white",
    strokeWidth: 0.196805
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2394 253.832C62.5424 250.649 65.8944 250.127 64.7764 246.662",
    stroke: "white",
    strokeWidth: 0.196805
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7495 263.641L55.6723 263.519",
    stroke: "#B1A185",
    strokeWidth: 0.0650498
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2533 244.916C36.3323 244.472 35.8183 244.009 35.1043 243.882C34.3913 243.756 35.6884 240.961 34.6104 242.724C34.8234 243.779 34.5933 245.452 35.4053 245.944C40.9523 249.042 36.1753 245.36 36.2533 244.916Z",
    fill: "#848484"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M74.214 248.838C73.784 249.101 72.821 249.355 72.361 248.876C71.901 248.397 69.667 250.527 71.023 248.906C72.227 248.583 74.015 247.342 74.903 247.728C80.696 250.484 74.644 248.575 74.214 248.838Z",
    fill: "#848484"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4371 241.374C54.0791 237.746 50.7671 235.145 46.2541 234.346C41.7411 233.546 37.7371 234.852 37.0941 238.479C36.4521 242.106 39.5891 245.694 44.1021 246.494C48.6151 247.293 52.7941 245.001 53.4371 241.374Z",
    fill: "url(#paint38_linear_57_182)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M50.709 238.213C51.352 234.586 50.977 235.102 46.464 234.303C41.951 233.504 41.426 232.828 40.783 236.455C40.141 240.082 40.496 243.178 45.009 243.977C49.522 244.777 50.067 241.84 50.709 238.213Z",
    fill: "url(#paint39_linear_57_182)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6624 241.236C53.3044 237.609 50.2104 238.288 45.6974 237.489C41.1854 236.689 38.5444 234.995 37.9024 238.622C37.2594 242.249 39.7504 244.788 44.2634 245.587C48.7764 246.387 52.0194 244.863 52.6624 241.236Z",
    fill: "url(#paint40_linear_57_182)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2333 235.413C44.0943 236.198 44.6173 236.947 45.4023 237.086L46.1773 237.223C46.9623 237.362 47.7113 236.838 47.8503 236.054L47.9813 235.317C48.0443 234.96 47.8063 234.62 47.4493 234.557L45.1243 234.145C44.7673 234.082 44.4263 234.32 44.3633 234.676L44.2333 235.413Z",
    fill: "#C4C4C4"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9365 237.27L45.4237 234.144",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8838 237.562L47.3618 234.488",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8496 237.378L46.3276 234.304",
    stroke: "black",
    strokeWidth: 0.0656017
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0303 289.379L89.61 303.122L107.12 204.271L57.819 199.196L29.541 190.528L12.0303 289.379Z",
    fill: "black",
    fillOpacity: 0.1
  })))), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M22.623 121.216C22.623 116.657 20.3765 112.284 16.3777 109.06C12.3788 105.837 6.95515 104.026 1.29995 104.026C-4.35525 104.026 -9.77885 105.837 -13.7776 109.06C-17.7764 112.284 -20.0229 116.657 -20.0229 121.216H1.29995H22.623Z",
    fill: "white"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.7923 132.041C-6.05704 132.041 0.213661 126.986 0.213661 120.75C0.213661 114.514 -6.05704 109.459 -13.7923 109.459C-21.5276 109.459 -27.7983 114.514 -27.7983 120.75C-27.7983 126.986 -21.5276 132.041 -13.7923 132.041Z",
    fill: "white"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2023 129.239C19.9376 129.239 26.2083 124.184 26.2083 117.948C26.2083 111.712 19.9376 106.657 12.2023 106.657C4.46699 106.657 -1.80371 111.712 -1.80371 117.948C-1.80371 124.184 4.46699 129.239 12.2023 129.239Z",
    fill: "white"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2194 131.886C21.9547 131.886 28.2254 126.831 28.2254 120.595C28.2254 114.359 21.9547 109.304 14.2194 109.304C6.48408 109.304 0.213379 114.359 0.213379 120.595C0.213379 126.831 6.48408 131.886 14.2194 131.886Z",
    fill: "white"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M0.218403 134.843C9.87295 134.843 17.6995 128.533 17.6995 120.75C17.6995 112.967 9.87295 106.657 0.218403 106.657C-9.43614 106.657 -17.2627 112.967 -17.2627 120.75C-17.2627 128.533 -9.43614 134.843 0.218403 134.843Z",
    fill: "white"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2119 129.108C70.9979 126.517 71.3629 128.452 67.8489 128.452C64.3339 128.452 64.4699 126.451 61.4849 129.108C61.4849 125.648 64.3339 122.843 67.8489 122.843C71.3629 122.843 74.2119 125.648 74.2119 129.108Z",
    fill: "#EEDDA0"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6362 197.738C68.6362 199.5 68.7332 200.928 70.8232 200.928C72.9142 200.928 77.4012 202.69 77.4012 200.928C77.4012 199.167 74.3222 197.479 72.2312 197.479C70.1412 197.479 68.6362 195.976 68.6362 197.738Z",
    fill: "white"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9881 196.936C68.9881 197.748 68.5861 200.113 69.5431 200.113C70.5011 200.113 78.8141 202.502 77.3081 200.113C64.1281 201.295 72.7691 197.329 71.8111 197.329C70.8531 197.329 68.9881 196.125 68.9881 196.936Z",
    fill: "#E1AAC4"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9682 197.736C65.9562 199.498 65.8492 200.925 63.7592 200.91C61.6682 200.895 57.1692 202.625 57.1812 200.863C57.1942 199.102 60.2852 197.436 62.3752 197.451C64.4662 197.466 65.9812 195.974 65.9682 197.736Z",
    fill: "white"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M65.622 196.931C65.616 197.743 66.002 200.111 65.044 200.104C64.087 200.097 55.757 202.427 57.279 200.049C70.45 201.324 61.839 197.297 62.796 197.304C63.754 197.311 65.627 196.12 65.622 196.931Z",
    fill: "#E1AAC4"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2021 161.06L77.1642 160.443C77.1542 178.093 74.1801 185.292 72.6161 197.574L68.2942 197.819C64.0752 183.71 78.9901 179.745 60.2021 161.06Z",
    fill: "#65BAC6"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8269 161.116L58.9919 158.705C58.1639 176.31 60.7239 185.095 61.7009 197.367L66.0029 197.671C70.8849 183.655 56.1869 179.496 75.8269 161.116Z",
    fill: "#65BAC6"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0468 135.218C97.9608 136.05 96.2278 137.28 96.7408 137.746C95.8308 138.746 94.5288 138.464 93.3898 138.292C92.4748 137.461 94.6868 138.21 95.5968 137.209C96.5058 136.209 96.1318 134.387 97.0468 135.218Z",
    fill: "#F3CEB9"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M101.219 136.678C101.006 137.688 98.0491 137.281 97.9291 137.847C96.8241 137.614 95.9351 138.367 95.5781 137.473C95.7921 136.462 96.7281 136.563 97.8331 136.796C98.9391 137.03 101.433 135.668 101.219 136.678Z",
    fill: "#F3CEB9"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M101.097 137.776C100.793 138.742 97.9461 138.067 97.7761 138.608C96.7191 138.276 95.7811 138.927 95.5171 138.021C95.8201 137.055 96.7241 137.241 97.7811 137.573C98.8381 137.905 101.4 136.811 101.097 137.776Z",
    fill: "#F3CEB9"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M101.049 138.71C100.752 139.482 98.6138 138.278 97.8558 139.518C97.0118 139.193 96.6558 139.372 96.4878 138.619C96.7858 137.847 97.5128 138.046 98.3568 138.372C99.2008 138.698 101.347 137.939 101.049 138.71Z",
    fill: "#F3CEB9"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M99.957 139.242C99.652 139.697 97.08 139.65 96.45 139.694C95.953 139.36 96.55 139.417 96.552 138.906C96.857 138.452 97.353 138.52 97.795 139.021C98.293 139.354 100.262 138.787 99.957 139.242Z",
    fill: "#F3CEB9"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0858 137.695C97.6188 137.63 98.0968 138.026 98.1338 138.561C98.1578 138.921 97.9738 139.263 97.6588 139.44L97.5198 139.519C97.3478 139.616 97.1528 139.669 96.9548 139.673L94.8318 139.708C94.7558 139.709 94.6838 139.674 94.6398 139.612C94.6088 139.569 94.5928 139.516 94.5968 139.462L94.6208 139.077C94.6598 138.445 95.1448 137.93 95.7738 137.854L97.0858 137.695Z",
    fill: "#F3CEB9"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7992 137.168C57.5462 133.314 60.5552 129.994 64.4162 129.994H71.3492C75.0392 129.994 78.0022 133.037 77.8692 136.725C77.4302 148.873 76.8712 158.674 78.0832 164.047C70.1612 165.422 65.5982 165.456 57.2212 164.047C58.2112 153.273 58.3992 146.343 57.7992 137.168Z",
    fill: "#848484"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4538 154.383C42.4498 155.103 41.6098 153.151 41.0468 153.555C40.2588 152.456 40.8068 151.241 41.2138 150.164C42.2178 149.443 41.0228 151.45 41.8108 152.548C42.5988 153.647 44.4578 153.663 43.4538 154.383Z",
    fill: "#F3CEB9"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1532 158.158C40.2092 157.738 41.2272 154.932 40.6982 154.696C41.1582 153.664 40.6082 152.637 41.5572 152.476C42.5002 152.896 42.2062 153.79 41.7462 154.822C41.2862 155.854 42.0962 158.578 41.1532 158.158Z",
    fill: "#F3CEB9"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1039 157.807C39.2239 157.308 40.4799 154.666 39.9869 154.386C40.5329 153.422 40.0929 152.368 41.0339 152.3C41.9149 152.799 41.5429 153.644 40.9969 154.608C40.4509 155.572 40.9849 158.306 40.1039 157.807Z",
    fill: "#F3CEB9"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2008 157.566C38.5088 157.113 40.1338 155.275 39.0788 154.274C39.5748 153.517 39.4738 153.131 40.2448 153.125C40.9368 153.577 40.5908 154.247 40.0948 155.004C39.5998 155.761 39.8928 158.018 39.2008 157.566Z",
    fill: "#F3CEB9"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M38.91 156.386C38.529 155.993 39.113 153.488 39.203 152.863C39.633 152.446 39.452 153.018 39.951 153.127C40.332 153.52 40.161 153.992 39.579 154.319C39.148 154.735 39.29 156.78 38.91 156.386Z",
    fill: "#F3CEB9"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0242 153.903C40.9762 154.438 40.4892 154.823 39.9572 154.746C39.6002 154.694 39.3052 154.442 39.1972 154.098L39.1492 153.946C39.0902 153.756 39.0791 153.555 39.1181 153.361L39.5272 151.277C39.5422 151.203 39.5922 151.14 39.6622 151.11C39.7112 151.088 39.7652 151.084 39.8172 151.099L40.1892 151.203C40.7992 151.374 41.2001 151.956 41.1431 152.587L41.0242 153.903Z",
    fill: "#F3CEB9"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7238 130.243C70.7238 132.482 72.5588 134.783 67.6908 134.783C62.8218 134.783 64.1408 132.482 64.1408 130.243C64.1408 128.004 62.5538 126.199 67.4218 126.199C72.2908 126.199 70.7238 128.004 70.7238 130.243Z",
    fill: "#F3CEB9"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0349 129.528C68.1499 130.165 66.9569 130.165 66.0719 129.528L64.3679 128.302C62.3689 126.863 63.3859 123.706 65.8499 123.706H69.2569C71.7209 123.706 72.7389 126.863 70.7389 128.302L69.0349 129.528Z",
    fill: "#E4CFB0"
  }))), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M75.199 120.827C73.377 127.309 73.399 128.677 67.62 128.677C61.842 128.677 62.742 127.504 60.042 120.827C60.042 115.497 63.435 111.176 67.62 111.176C71.806 111.176 75.199 115.497 75.199 120.827Z",
    fill: "#F3CEB9"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9989 129.814C68.1629 130.32 67.1149 130.32 66.2789 129.814L64.3209 128.627C62.0499 127.251 63.0259 123.759 65.6809 123.759H69.5969C72.2529 123.759 73.2279 127.251 70.9569 128.627L68.9989 129.814Z",
    fill: "#F3CEB9"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M70.188 125.831C70.188 125.669 68.668 125.831 67.742 125.831C66.816 125.831 65.082 125.545 65.082 125.706C65.082 125.868 66.816 126.474 67.742 126.474C68.668 126.474 70.188 125.992 70.188 125.831Z",
    fill: "white"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1562 125.754C70.1562 125.593 68.6032 125.657 67.6772 125.657C66.7512 125.657 65.1802 125.593 65.1802 125.754C65.1802 125.916 66.7512 127.153 67.6772 127.153C68.6032 127.153 70.1562 125.916 70.1562 125.754Z",
    fill: "white"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3192 125.741C70.3192 125.902 68.7832 127.446 67.6522 127.446C66.5202 127.446 64.8872 125.78 64.8872 125.619C64.8872 125.457 66.5202 127.055 67.6522 127.055C68.7832 127.055 70.3192 125.579 70.3192 125.741Z",
    fill: "#DE4C66"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4162 125.781C70.4162 125.62 68.8232 125.098 67.6842 125.456C66.7412 125.163 64.8872 125.457 64.8872 125.619C64.8872 125.78 66.5532 125.781 67.6842 125.781C68.8162 125.781 70.4162 125.943 70.4162 125.781Z",
    fill: "#DE4C66"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9362 119.412C66.9362 119.897 66.0882 119.152 65.0822 119.152C64.0762 119.152 63.7492 119.412 63.2612 119.77C63.2612 119.285 64.0762 118.892 65.0822 118.892C66.0882 118.892 66.9362 118.927 66.9362 119.412Z",
    fill: "#D5C1A0"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8882 119.444C68.8882 119.929 69.8012 119.282 70.8072 119.282C71.8122 119.282 72.1402 119.542 72.6282 119.9C72.6282 119.415 71.8122 119.022 70.8072 119.022C69.8012 119.022 68.8882 118.959 68.8882 119.444Z",
    fill: "#C4B397"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8452 122.473C65.7382 123.365 66.5792 123.702 67.1022 123.421",
    stroke: "black",
    strokeWidth: 0.0713772
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4269 122.475C69.5329 123.367 68.7779 123.702 68.2539 123.421",
    stroke: "black",
    strokeWidth: 0.0713772
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M66.885 123.455C67.0033 123.455 67.0992 123.423 67.0992 123.384C67.0992 123.345 67.0033 123.313 66.885 123.313C66.7668 123.313 66.6709 123.345 66.6709 123.384C66.6709 123.423 66.7668 123.455 66.885 123.455Z",
    fill: "black"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M68.468 123.455C68.5863 123.455 68.6822 123.423 68.6822 123.384C68.6822 123.345 68.5863 123.313 68.468 123.313C68.3498 123.313 68.2539 123.345 68.2539 123.384C68.2539 123.423 68.3498 123.455 68.468 123.455Z",
    fill: "black"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8569 120.595C66.4769 120.748 66.0879 121.233 65.4469 121.153C64.8049 121.072 64.2699 120.771 64.3119 120.435C64.7799 120.169 64.9079 119.891 65.5499 119.971C66.1919 120.052 66.4229 120.261 66.8569 120.595Z",
    fill: "white"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4748 121.145C65.2233 121.145 65.0195 120.941 65.0195 120.69C65.0195 120.438 65.2233 120.235 65.4748 120.235C65.7263 120.235 65.9302 120.438 65.9302 120.69C65.9302 120.941 65.7263 121.145 65.4748 121.145Z",
    fill: "url(#paint41_radial_57_182)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M66.857 120.595C66.477 120.748 66.192 120.296 65.55 120.216C64.908 120.136 64.27 120.771 64.312 120.435C64.78 120.169 64.908 119.891 65.55 119.971C66.192 120.052 66.423 120.261 66.857 120.595Z",
    fill: "#D3AC97"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4302 120.595C68.8102 120.748 69.1992 121.233 69.8412 121.153C70.4832 121.072 71.0182 120.771 70.9762 120.435C70.5082 120.169 70.3792 119.891 69.7382 119.971C69.0962 120.052 68.8652 120.261 68.4302 120.595Z",
    fill: "white"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8118 121.145C70.0633 121.145 70.2672 120.941 70.2672 120.69C70.2672 120.438 70.0633 120.235 69.8118 120.235C69.5603 120.235 69.3564 120.438 69.3564 120.69C69.3564 120.941 69.5603 121.145 69.8118 121.145Z",
    fill: "url(#paint42_radial_57_182)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4302 120.595C68.8102 120.748 69.0962 120.296 69.7382 120.216C70.3792 120.136 71.0182 120.771 70.9762 120.435C70.5082 120.169 70.3792 119.891 69.7382 119.971C69.0962 120.052 68.8652 120.261 68.4302 120.595Z",
    fill: "#D3AC97"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9192 125.624C64.7832 125.592 64.7012 125.534 64.6382 125.462",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5762 125.607C64.6282 125.477 64.6982 125.404 64.7792 125.353",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M70.23 125.819C70.366 125.787 70.449 125.729 70.511 125.657",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5741 125.802C70.5211 125.672 70.4521 125.599 70.3711 125.548",
    stroke: "black",
    strokeWidth: 0.0650498
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.0401 124.225C71.543 124.225 71.9508 123.803 71.9508 123.282C71.9508 122.761 71.543 122.339 71.0401 122.339C70.5371 122.339 70.1294 122.761 70.1294 123.282C70.1294 123.803 70.5371 124.225 71.0401 124.225Z",
    fill: "#E99985"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_57_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5352 124.16C65.0382 124.16 65.4459 123.738 65.4459 123.217C65.4459 122.696 65.0382 122.274 64.5352 122.274C64.0323 122.274 63.6245 122.696 63.6245 123.217C63.6245 123.738 64.0323 124.16 64.5352 124.16Z",
    fill: "#E99985"
  }))), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1021 123.421C67.5241 123.914 67.776 123.887 68.254 123.421",
    stroke: "black",
    strokeWidth: 0.0719827
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0674 120.148L70.9086 120.4",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9365 120.083L70.7777 120.335",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8057 119.952L70.6469 120.204",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6733 119.886L70.5145 120.138",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M70.437 119.746L70.3512 120.031",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1438 119.64L70.1108 119.969",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9463 119.64L69.9363 119.938",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7207 119.648L69.7691 119.943",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5059 119.646L69.5542 119.94",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3091 119.711L69.3575 120.006",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1118 119.777L69.1602 120.072",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9556 119.855L69.0577 120.135",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8379 120.053L68.9352 120.186",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6758 120.184L68.7731 120.317",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5439 120.316L68.6413 120.449",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2021 120.146L64.3611 120.399",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M64.334 120.081L64.492 120.333",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4648 119.949L64.6238 120.202",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5962 119.884L64.7552 120.136",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M64.833 119.744L64.919 120.03",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M65.126 119.638L65.159 119.967",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3232 119.638L65.3332 119.936",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M65.548 119.646L65.5 119.94",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7648 119.644L65.7158 119.938",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9611 119.71L65.9131 120.004",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1579 119.775L66.1099 120.07",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3139 119.854L66.2119 120.134",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M66.432 120.052L66.334 120.184",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5951 120.183L66.4971 120.316",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7259 120.314L66.6289 120.447",
    stroke: "#B19585",
    strokeWidth: 0.0650498
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2448 120.895C67.2228 121.199 67.0288 121.477 66.7018 121.675C66.3738 121.874 65.9248 121.984 65.4328 121.949C65.2088 121.932 64.9418 121.83 64.6628 121.662C64.3868 121.495 64.1088 121.271 63.8618 121.024C63.6158 120.777 63.4048 120.512 63.2608 120.268C63.1958 120.159 63.1468 120.058 63.1138 119.969C63.3318 120.065 63.5298 120.11 63.7158 120.117C63.9838 120.127 64.2118 120.056 64.4168 119.967C64.5158 119.924 64.6068 119.879 64.6958 119.836C64.9868 119.693 65.2438 119.567 65.6028 119.593C66.0948 119.629 66.5238 119.802 66.8188 120.045C67.1148 120.289 67.2668 120.592 67.2448 120.895Z",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M68.109 120.895C68.131 121.199 68.325 121.477 68.652 121.675C68.98 121.874 69.429 121.984 69.921 121.949C70.145 121.932 70.412 121.83 70.691 121.662C70.967 121.495 71.245 121.271 71.492 121.024C71.738 120.777 71.949 120.512 72.093 120.268C72.158 120.159 72.207 120.058 72.24 119.969C72.022 120.065 71.824 120.11 71.638 120.117C71.37 120.127 71.142 120.056 70.937 119.967C70.838 119.924 70.747 119.879 70.658 119.836C70.367 119.693 70.11 119.567 69.751 119.593C69.259 119.629 68.83 119.802 68.535 120.045C68.239 120.289 68.087 120.592 68.109 120.895Z",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8612 126.929C63.9642 127.58 59.8562 121.019 60.5292 117.81C61.2022 114.601 72.8422 115.031 64.9582 112.673C64.8242 114.589 59.6992 111.969 59.0252 115.178C58.3522 118.387 63.8812 126.591 60.8612 126.929Z",
    fill: "#EEDDA0"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M60.861 126.929C63.964 127.58 60.91 120.935 61.584 117.727C62.257 114.518 68.413 114.935 60.529 112.577C60.395 114.493 60.748 112.33 60.075 115.539C59.401 118.748 63.882 126.591 60.861 126.929Z",
    fill: "#EEDDA0"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0981 127.37C71.9951 128.021 73.7051 121.194 73.0311 117.985C71.9821 116.349 64.5241 112.836 72.4081 110.477C72.5421 112.393 75.4741 114.255 76.1471 117.464C76.8211 120.673 72.0771 127.032 75.0981 127.37Z",
    fill: "#EEDDA0"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2009 119.645C66.0209 121.093 62.9579 115.307 63.9649 113.346C64.9719 111.386 75.7889 115.453 68.7049 111.296C68.3549 112.553 62.7829 110.262 61.7769 112.223C60.7699 114.183 66.0609 120.395 63.2009 119.645Z",
    fill: "#EEDDA0"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3969 120.388C64.2169 121.836 61.1539 116.05 62.1609 114.09C63.1669 112.13 69.5849 114.887 62.5019 110.729C62.1509 111.986 60.9789 111.006 59.9719 112.966C58.9659 114.926 64.2569 121.138 61.3969 120.388Z",
    fill: "#EEDDA0"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5129 118.989C67.3339 120.437 64.2709 114.65 65.2769 112.69C66.2839 110.73 81.5269 121.991 70.0179 110.639C70.0179 109.789 64.0949 109.606 63.0889 111.566C62.0819 113.527 67.3729 119.738 64.5129 118.989Z",
    fill: "#EEDDA0"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5629 118.923C68.3829 120.371 65.3199 114.585 66.3269 112.625C67.3329 110.665 71.5859 115.659 64.5029 111.501C64.1519 112.758 65.1449 109.541 64.1379 111.501C63.1319 113.461 68.4229 119.673 65.5629 118.923Z",
    fill: "#EEDDA0"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M66.875 118.923C69.695 120.371 66.632 114.585 67.638 112.625C68.645 110.665 71.881 115.659 64.798 111.501C64.447 112.758 66.457 109.541 65.45 111.501C64.443 113.461 69.734 119.673 66.875 118.923Z",
    fill: "#EEDDA0"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8591 118.989C70.6791 120.437 67.6161 114.65 68.6231 112.69C69.6301 110.73 73.5181 115.724 66.4341 111.567C66.0841 112.824 67.4411 109.606 66.4351 111.567C65.4281 113.527 70.7191 119.738 67.8591 118.989Z",
    fill: "#EEDDA0"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1611 121.706C74.1611 122.303 74.0691 123.641 74.3551 123.641C74.6411 123.641 75.1961 122.303 75.1961 121.706C75.1961 121.108 74.9641 120.623 74.6781 120.623C74.3931 120.623 74.1611 121.108 74.1611 121.706Z",
    fill: "#F3CEB9"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M74.646 121.531C74.918 121.885 74.475 122.107 74.646 122.515",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4061 121.837C61.4061 122.435 61.4981 123.772 61.2121 123.772C60.9261 123.772 60.3701 122.435 60.3701 121.837C60.3701 121.239 60.6021 120.754 60.8881 120.754C61.1741 120.754 61.4061 121.239 61.4061 121.837Z",
    fill: "#F3CEB9"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9198 121.663C60.6478 122.016 61.0908 122.239 60.9198 122.647",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0629 132.497C58.9499 131.339 62.2279 132.752 63.3689 135.646L45.1208 142.84L43.2148 137.647L56.0629 132.497Z",
    fill: "#848484"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6492 132.211C72.9162 130.251 69.7022 133.926 72.0082 136.374L82.0842 143.747L85.5782 139.333L75.6492 132.211Z",
    fill: "#848484"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1091 133.415C66.9261 134.784 68.2131 134.835 71.0301 133.415L71.1291 164.966C68.3091 165.239 66.7341 165.204 63.9131 164.927L64.1091 133.415Z",
    fill: "#E1AAC4"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2559 121.007L63.6319 120.647",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2139 121.071C67.5199 120.591 67.7189 120.602 68.1129 121.037",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2339 121.104L71.8579 120.744",
    stroke: "#EF4B9A",
    strokeWidth: 0.328008
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M61.649 124.329C61.649 124.551 61.5959 124.75 61.5099 124.892C61.4239 125.035 61.31 125.117 61.19 125.117C61.07 125.117 60.9559 125.035 60.8699 124.892C60.7849 124.75 60.731 124.551 60.731 124.329C60.731 124.108 60.7849 123.909 60.8699 123.766C60.9559 123.623 61.07 123.542 61.19 123.542C61.31 123.542 61.4239 123.623 61.5099 123.766C61.5959 123.909 61.649 124.108 61.649 124.329Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5181 124.198C61.5181 124.42 61.4641 124.619 61.3791 124.761C61.2931 124.904 61.1791 124.985 61.0591 124.985C60.9391 124.985 60.8251 124.904 60.7391 124.761C60.6541 124.619 60.6001 124.42 60.6001 124.198C60.6001 123.977 60.6541 123.778 60.7391 123.635C60.8251 123.492 60.9391 123.411 61.0591 123.411C61.1791 123.411 61.2931 123.492 61.3791 123.635C61.4641 123.778 61.5181 123.977 61.5181 124.198Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9659 124.067C74.9659 124.288 74.9118 124.487 74.8268 124.63C74.7408 124.773 74.6269 124.854 74.5069 124.854C74.3869 124.854 74.2728 124.773 74.1868 124.63C74.1018 124.487 74.0479 124.288 74.0479 124.067C74.0479 123.845 74.1018 123.646 74.1868 123.504C74.2728 123.361 74.3869 123.28 74.5069 123.28C74.6269 123.28 74.7408 123.361 74.8268 123.504C74.9118 123.646 74.9659 123.845 74.9659 124.067Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M74.835 123.936C74.835 124.157 74.781 124.356 74.696 124.499C74.61 124.642 74.496 124.723 74.376 124.723C74.256 124.723 74.142 124.642 74.056 124.499C73.971 124.356 73.917 124.157 73.917 123.936C73.917 123.714 73.971 123.515 74.056 123.373C74.142 123.23 74.256 123.149 74.376 123.149C74.496 123.149 74.61 123.23 74.696 123.373C74.781 123.515 74.835 123.714 74.835 123.936Z",
    stroke: "#DBA722",
    strokeWidth: 0.0656017
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0839 137.811L47.8889 141.18C45.0549 145.454 43.7409 147.919 42.0499 152.483C40.1989 151.853 39.0959 151.546 38.9839 149.711C40.9089 145.211 41.8329 142.809 43.0839 137.811Z",
    fill: "#848484"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1172 143.813L82.6152 137.729C87.7422 137.854 90.5292 137.655 95.2922 136.659C95.7442 138.56 96.0712 139.658 94.5772 140.73C89.7422 141.494 87.0152 142.213 82.1172 143.813Z",
    fill: "#848484"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2892 134.072C63.416 134.072 63.5188 133.969 63.5188 133.842C63.5188 133.715 63.416 133.612 63.2892 133.612C63.1624 133.612 63.0596 133.715 63.0596 133.842C63.0596 133.969 63.1624 134.072 63.2892 134.072Z",
    fill: "#ABA4A4"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M72.211 134.072C72.3379 134.072 72.4407 133.969 72.4407 133.842C72.4407 133.715 72.3379 133.612 72.211 133.612C72.0842 133.612 71.9814 133.715 71.9814 133.842C71.9814 133.969 72.0842 134.072 72.211 134.072Z",
    fill: "#ABA4A4"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2558 133.809C64.4978 137.558 61.2878 138.925 62.9938 142.927",
    stroke: "white",
    strokeWidth: 0.196805
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2612 133.825C71.0192 137.574 74.2292 138.941 72.5232 142.944",
    stroke: "white",
    strokeWidth: 0.196805
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5951 120.183L66.4971 120.316",
    stroke: "#B1A185",
    strokeWidth: 0.0650498
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1338 138.893C44.1338 139.455 43.5458 139.91 42.8218 139.91C42.0968 139.91 42.8868 143.616 42.1328 141.222C42.5258 139.975 42.5918 137.876 43.4778 137.45C49.4798 134.858 44.1338 138.331 44.1338 138.893Z",
    fill: "#848484"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1972 142.327C81.8192 141.911 80.9152 141.39 80.3792 141.878C79.8432 142.365 78.0152 139.27 79.0672 141.55C80.1962 142.207 81.7402 144.116 82.6822 143.836C88.8672 141.717 82.5742 142.742 82.1972 142.327Z",
    fill: "#848484"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4359 146.962C60.4359 151.545 56.7199 154.013 52.1369 154.013C47.5539 154.013 43.8379 151.545 43.8379 146.962C43.8379 142.379 47.5539 138.663 52.1369 138.663C56.7199 138.663 60.4359 142.379 60.4359 146.962Z",
    fill: "url(#paint43_linear_57_182)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1991 150.242C57.1991 154.825 56.9201 154.111 52.3371 154.111C47.7541 154.111 47.1191 154.825 47.1191 150.242C47.1191 145.659 48.0081 141.943 52.5921 141.943C57.1751 141.943 57.1991 145.659 57.1991 150.242Z",
    fill: "url(#paint44_linear_57_182)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6482 146.962C59.6482 151.545 56.7202 150.042 52.1372 150.042C47.5542 150.042 44.6582 151.545 44.6582 146.962C44.6582 142.379 47.5542 139.809 52.1372 139.809C56.7202 139.809 59.6482 142.379 59.6482 146.962Z",
    fill: "url(#paint45_linear_57_182)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M50.333 151.915C50.333 151.118 50.979 150.472 51.776 150.472H52.563C53.361 150.472 54.007 151.118 54.007 151.915V153.358C54.007 153.72 53.713 154.014 53.351 154.014H50.989C50.627 154.014 50.333 153.72 50.333 153.358V151.915Z",
    fill: "#C4C4C4"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3502 150.144L51.2842 154.08",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3179 150.21L53.252 154.08",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2681 150.21L52.2031 154.08",
    stroke: "black",
    strokeWidth: 0.0656017
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8611 44.5761C20.8611 43.9783 20.5681 43.6794 19.982 43.6794H15.8791C15.3224 43.6794 15 43.3506 15 42.7827V39.4348C15 38.837 15.3224 38.5381 15.8791 38.5381H30.8836C31.4697 38.5381 31.7627 38.837 31.7627 39.4348V42.7827C31.7627 43.3506 31.4697 43.6794 30.8836 43.6794H26.7808C26.224 43.6794 25.9016 43.9783 25.9016 44.5761V58.5652C25.9016 59.1331 25.6086 59.4619 25.0225 59.4619H21.7403C21.1835 59.4619 20.8611 59.1331 20.8611 58.5652V44.5761ZM37.6765 38.5381C38.2335 38.5381 38.5561 38.8669 38.5561 39.4348V46.9076C38.5561 47.4755 38.8777 47.8043 39.4352 47.8043H42.2478C42.8338 47.8043 43.1269 47.4755 43.1269 46.9076V39.4348C43.1269 38.8669 43.4494 38.5381 44.006 38.5381H47.2885C47.8746 38.5381 48.1677 38.837 48.1677 39.4348V58.5652C48.1677 59.1331 47.8746 59.4619 47.2885 59.4619H44.006C43.4494 59.4619 43.1269 59.1331 43.1269 58.5652V53.8424C43.1269 53.2446 42.8338 52.9457 42.2478 52.9457H39.4352C38.8777 52.9457 38.5561 53.2446 38.5561 53.8424V58.5652C38.5561 59.1331 38.263 59.4619 37.6765 59.4619H34.3943C33.8375 59.4619 33.5151 59.1331 33.5151 58.5652V39.4348C33.5151 38.837 33.8082 38.5381 34.3943 38.5381H37.6765ZM64.2745 38.5381C64.8606 38.5381 65.1537 38.837 65.1537 39.4348V42.7827C65.1537 43.3506 64.8606 43.6794 64.2745 43.6794H57.1824C56.6258 43.6794 56.3033 43.9783 56.3033 44.5761V45.5327C56.3033 46.1006 56.6258 46.4294 57.1824 46.4294H61.7247C62.3108 46.4294 62.6038 46.7283 62.6038 47.3261V50.6739C62.6038 51.2418 62.3108 51.5706 61.7247 51.5706H57.1824C56.6258 51.5706 56.3033 51.8695 56.3033 52.4673V53.4239C56.3033 53.9918 56.6258 54.3206 57.1824 54.3206H64.2745C64.8606 54.3206 65.1537 54.6195 65.1537 55.2173V58.5652C65.1537 59.163 64.8606 59.4619 64.2745 59.4619H51.9657C51.409 59.4619 51.0865 59.1331 51.0865 58.5652V39.4348C51.0865 38.837 51.409 38.5381 51.9657 38.5381H64.2745ZM89.666 38.5381C90.2521 38.5381 90.5451 38.837 90.5451 39.4348V42.7827C90.5451 43.3506 90.2521 43.6794 89.666 43.6794H82.2808C81.7242 43.6794 81.4017 43.9783 81.4017 44.5761V45.5327C81.4017 46.1006 81.7242 46.4294 82.2808 46.4294H87.1161C87.7022 46.4294 87.9953 46.7283 87.9953 47.3261V50.6739C87.9953 51.2418 87.7022 51.5706 87.1161 51.5706H82.2808C81.7242 51.5706 81.4017 51.8695 81.4017 52.4673V58.5652C81.4017 59.1331 81.1087 59.4619 80.5226 59.4619H77.065C76.5075 59.4619 76.1858 59.1331 76.1858 58.5652V39.4348C76.1858 38.837 76.5075 38.5381 77.065 38.5381H89.666ZM93.0012 38.5381C92.4446 38.5381 92.122 38.837 92.122 39.4348V52.7364C92.122 54.7092 92.5321 60 99.4777 60C106.423 60 106.833 54.7092 106.833 52.7364V39.4348C106.833 38.837 106.54 38.5381 105.954 38.5381H102.672C102.115 38.5381 101.793 38.837 101.793 39.4348V51.1522C101.793 53.4538 101.646 54.8587 99.4777 54.8587C97.3093 54.8587 97.1628 53.4538 97.1628 51.1522V39.4348C97.1628 38.837 96.8698 38.5381 96.2837 38.5381H93.0012ZM114.272 44.5761C114.272 43.9783 113.979 43.6794 113.393 43.6794H109.29C108.734 43.6794 108.411 43.3506 108.411 42.7827V39.4348C108.411 38.837 108.734 38.5381 109.29 38.5381H124.295C124.881 38.5381 125.174 38.837 125.174 39.4348V42.7827C125.174 43.3506 124.881 43.6794 124.295 43.6794H120.192C119.635 43.6794 119.313 43.9783 119.313 44.5761V58.5652C119.313 59.1331 119.02 59.4619 118.434 59.4619H115.151C114.595 59.4619 114.272 59.1331 114.272 58.5652V44.5761ZM127.63 38.5381C127.072 38.5381 126.751 38.837 126.751 39.4348V52.7364C126.751 54.7092 127.161 60 134.106 60C141.051 60 141.462 54.7092 141.462 52.7364V39.4348C141.462 38.837 141.169 38.5381 140.583 38.5381H137.3C136.744 38.5381 136.421 38.837 136.421 39.4348V51.1522C136.421 53.4538 136.275 54.8587 134.106 54.8587C131.937 54.8587 131.791 53.4538 131.791 51.1522V39.4348C131.791 38.837 131.498 38.5381 130.911 38.5381H127.63ZM156.55 51.9592C156.491 51.8097 156.52 51.6603 156.637 51.5706C158.191 50.4348 158.864 48.4918 158.864 45.712C158.864 40.8098 156.755 38.5381 151.538 38.5381H145.121C144.593 38.5381 144.212 38.9267 144.212 39.4647V58.5353C144.212 59.0733 144.593 59.4619 145.121 59.4619H148.402C148.93 59.4619 149.311 59.0733 149.311 58.5353V53.8125C149.311 53.2745 149.692 52.8859 150.22 52.8859H151.392C151.479 52.8859 151.568 52.9457 151.626 53.0353L154.674 59.0434C154.791 59.3124 155.055 59.4619 155.348 59.4619H158.688C159.597 59.4619 160.066 58.6249 159.656 57.8478L156.55 51.9592ZM151.714 43.6794C153.121 43.6794 153.824 43.8587 153.824 45.712C153.824 47.5652 153.121 47.7446 151.714 47.7446H150.22C149.692 47.7446 149.311 47.356 149.311 46.8179V44.606C149.311 44.0679 149.692 43.6794 150.22 43.6794H151.714ZM174.771 38.5381C175.357 38.5381 175.65 38.837 175.65 39.4348V42.7827C175.65 43.3506 175.357 43.6794 174.771 43.6794H167.679C167.122 43.6794 166.8 43.9783 166.8 44.5761V45.5327C166.8 46.1006 167.122 46.4294 167.679 46.4294H172.221C172.807 46.4294 173.1 46.7283 173.1 47.3261V50.6739C173.1 51.2418 172.807 51.5706 172.221 51.5706H167.679C167.122 51.5706 166.8 51.8695 166.8 52.4673V53.4239C166.8 53.9918 167.122 54.3206 167.679 54.3206H174.771C175.357 54.3206 175.65 54.6195 175.65 55.2173V58.5652C175.65 59.163 175.357 59.4619 174.771 59.4619H162.462C161.906 59.4619 161.583 59.1331 161.583 58.5652V39.4348C161.583 38.837 161.906 38.5381 162.462 38.5381H174.771ZM190.785 38.5381C191.371 38.5381 191.664 38.837 191.664 39.4348V58.5652C191.664 59.1331 191.371 59.4619 190.785 59.4619H187.561C187.004 59.4619 186.682 59.1331 186.682 58.5652V39.4348C186.682 38.837 187.004 38.5381 187.561 38.5381H190.785ZM208.149 45.2038C208.676 45.0842 208.941 44.7554 208.911 44.2174C208.735 42.0653 207.329 38.0598 201.292 38.0598C194.727 38.0598 194.2 43.3506 194.229 44.2473C194.229 51.1223 203.05 50.5544 203.607 53.0951C203.783 53.9022 202.728 54.769 201.292 54.769C199.914 54.769 198.83 53.9321 198.713 52.4972C198.655 51.8695 198.332 51.6005 197.746 51.7201L194.434 52.4673C193.907 52.587 193.643 52.9158 193.672 53.4538C193.818 55.7853 195.137 59.9103 201.292 59.9103C208.237 59.9103 209.234 54.6195 209.234 53.7228C209.234 46.8478 199.973 46.9076 199.562 44.5761C199.445 43.8886 200.148 43.2011 201.292 43.2011C202.669 43.2011 203.636 43.9783 203.841 45.2038C203.929 45.8017 204.222 46.0707 204.809 45.9511L208.149 45.2038ZM221.016 38.5381C220.43 38.568 220.137 38.8669 220.137 39.4647V58.5652C220.137 59.1331 220.46 59.4619 221.016 59.4619H228.255C233.764 59.4619 235.376 57.6685 235.376 53.9619C235.376 52.1086 234.497 50.6141 233.295 50.0462C234.497 48.7011 234.79 46.7283 234.79 45.712C234.79 40.8098 232.68 38.5381 227.17 38.5381H221.016ZM226.057 47.7446C225.5 47.7446 225.178 47.4457 225.178 46.8478V44.5761C225.178 43.9783 225.5 43.6794 226.057 43.6794H227.639C229.046 43.6794 229.75 43.8587 229.75 45.712C229.75 47.5652 229.046 47.7446 227.639 47.7446H226.057ZM226.028 55.2173C225.471 55.2173 225.148 54.9184 225.148 54.3206V52.9457C225.148 52.3478 225.471 52.0489 226.028 52.0489H227.932C229.339 52.0489 229.984 52.2581 229.984 53.663C229.984 55.0679 229.281 55.2173 227.873 55.2173H226.028ZM249.646 51.9592C249.588 51.8097 249.616 51.6603 249.734 51.5706C251.287 50.4348 251.961 48.4918 251.961 45.712C251.961 40.8098 249.851 38.5381 244.634 38.5381H238.217C237.69 38.5381 237.308 38.9267 237.308 39.4647V58.5353C237.308 59.0733 237.69 59.4619 238.217 59.4619H241.499C242.026 59.4619 242.407 59.0733 242.407 58.5353V53.8125C242.407 53.2745 242.788 52.8859 243.316 52.8859H244.488C244.576 52.8859 244.664 52.9457 244.723 53.0353L247.77 59.0434C247.887 59.3124 248.151 59.4619 248.444 59.4619H251.785C252.694 59.4619 253.162 58.6249 252.752 57.8478L249.646 51.9592ZM244.81 43.6794C246.217 43.6794 246.921 43.8587 246.921 45.712C246.921 47.5652 246.217 47.7446 244.81 47.7446H243.316C242.788 47.7446 242.407 47.356 242.407 46.8179V44.606C242.407 44.0679 242.788 43.6794 243.316 43.6794H244.81ZM258.783 38.5381C259.369 38.5381 259.662 38.837 259.662 39.4348V58.5652C259.662 59.1331 259.369 59.4619 258.783 59.4619H255.559C255.002 59.4619 254.68 59.1331 254.68 58.5652V39.4348C254.68 38.837 255.002 38.5381 255.559 38.5381H258.783ZM262.285 52.7364C262.285 54.7092 262.696 60 269.641 60C276.586 60 276.996 54.7092 276.996 52.7364V48.7011C276.996 48.1032 276.703 47.8043 276.117 47.8043H270.256C269.7 47.8043 269.377 48.1032 269.377 48.7011V51.0924C269.377 51.6603 269.7 51.9891 270.256 51.9891H271.956C271.956 53.4538 271.81 54.8587 269.641 54.8587C267.472 54.8587 267.326 53.4538 267.326 51.1522V46.8478C267.326 44.5462 267.472 43.1413 269.641 43.1413C271.311 43.1413 271.81 43.9783 271.927 45.413C271.986 46.0408 272.308 46.3098 272.894 46.1903L276.206 45.443C276.733 45.3233 276.996 44.9945 276.968 44.4565C276.821 42.1251 275.796 38 269.641 38C262.696 38 262.285 43.2908 262.285 45.2636V52.7364ZM283.739 38.5381C284.296 38.5381 284.618 38.8669 284.618 39.4348V46.9076C284.618 47.4755 284.941 47.8043 285.497 47.8043H288.311C288.897 47.8043 289.19 47.4755 289.19 46.9076V39.4348C289.19 38.8669 289.513 38.5381 290.069 38.5381H293.352C293.938 38.5381 294.231 38.837 294.231 39.4348V58.5652C294.231 59.1331 293.938 59.4619 293.352 59.4619H290.069C289.513 59.4619 289.19 59.1331 289.19 58.5652V53.8424C289.19 53.2446 288.897 52.9457 288.311 52.9457H285.497C284.941 52.9457 284.618 53.2446 284.618 53.8424V58.5652C284.618 59.1331 284.325 59.4619 283.739 59.4619H280.458C279.9 59.4619 279.578 59.1331 279.578 58.5652V39.4348C279.578 38.837 279.871 38.5381 280.458 38.5381H283.739ZM301.838 44.5761C301.838 43.9783 301.545 43.6794 300.959 43.6794H296.857C296.3 43.6794 295.977 43.3506 295.977 42.7827V39.4348C295.977 38.837 296.3 38.5381 296.857 38.5381H311.861C312.447 38.5381 312.74 38.837 312.74 39.4348V42.7827C312.74 43.3506 312.447 43.6794 311.861 43.6794H307.758C307.202 43.6794 306.879 43.9783 306.879 44.5761V58.5652C306.879 59.1331 306.586 59.4619 306 59.4619H302.717C302.161 59.4619 301.838 59.1331 301.838 58.5652V44.5761ZM320.119 38.5381C320.705 38.5381 321.028 38.837 320.998 39.4348L320.412 51.9891C320.383 52.5571 320.119 52.8859 319.533 52.8859H316.251C315.694 52.8859 315.401 52.5571 315.372 51.9891L314.786 39.4348C314.757 38.837 315.108 38.5381 315.665 38.5381H320.119ZM319.533 54.3206C320.119 54.3206 320.412 54.6195 320.412 55.2173V58.5652C320.412 59.1331 320.119 59.4619 319.533 59.4619H316.251C315.694 59.4619 315.372 59.1331 315.372 58.5652V55.2173C315.372 54.6195 315.694 54.3206 316.251 54.3206H319.533Z",
    fill: "#617483"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.904462 186.01C-1.40356 186.429 -2.14846 186.365 -2.56816 185.866C-2.98786 185.367 -2.92346 184.622 -2.42426 184.202C-1.92516 183.782 0.0824386 183.514 0.502139 184.013C0.921839 184.512 -0.405262 185.59 -0.904462 186.01Z",
    fill: "#F0AA95"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.61782 187.88C-3.19102 187.569 -3.40373 186.852 -3.09273 186.279C-2.78183 185.705 -2.06502 185.493 -1.49182 185.804C-0.91852 186.115 0.0662736 187.884 -0.244726 188.458C-0.555626 189.031 -2.04452 188.191 -2.61782 187.88Z",
    fill: "#F0AA95"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0774 191.801C10.2538 191.511 9.92976 190.992 9.59466 190.788C9.25956 190.583 8.67005 190.546 8.49365 190.836C8.95635 191.118 8.62066 191.632 8.95576 191.836C9.29086 192.041 9.90085 192.09 10.0774 191.801Z",
    fill: "#B4CB6F"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6123 201.444C8.42722 194.867 7.23472 190.187 9.30032 185.044",
    stroke: "#B4CB6F",
    strokeWidth: 0.656017
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3642 197.627C12.7338 200.821 13.1765 203.987 11.4421 203.644C9.7077 203.302 9.1745 200.594 9.4432 197.241C10.8307 179.923 8.9997 201.174 10.7341 201.516C12.4686 201.859 14.9959 190.636 13.3642 197.627Z",
    fill: "#677932"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83331 197.755C8.62231 200.913 8.338 204.097 10.0532 203.668C11.7684 203.24 12.1658 200.509 11.7303 197.174C9.4805 179.946 12.3694 201.079 10.6542 201.508C8.93901 201.936 5.85491 190.853 7.83331 197.755Z",
    fill: "#677932"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26679 183.01C7.26679 183.662 7.7954 184.191 8.4476 184.191C9.0997 184.191 9.6284 183.662 9.6284 183.01C9.6284 182.358 8.54209 180.648 7.88999 180.648C7.23779 180.648 7.26679 182.358 7.26679 183.01Z",
    fill: "#65BAC6"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35158 185.681C6.85078 186.101 7.59568 186.037 8.01538 185.538C8.43508 185.038 8.37058 184.294 7.87148 183.874C7.37228 183.454 5.36478 183.185 4.94508 183.685C4.52538 184.184 5.85248 185.262 6.35158 185.681Z",
    fill: "#65BAC6"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70278 182.98C9.26218 183.461 9.29488 184.208 9.77578 184.649C10.2566 185.089 11.0036 185.056 11.4441 184.576C11.8847 184.095 12.2385 182.1 11.7576 181.66C11.2767 181.219 10.1433 182.499 9.70278 182.98Z",
    fill: "#65BAC6"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9469 184.994C10.3872 184.659 9.66213 184.842 9.32733 185.401C8.99253 185.961 9.17483 186.686 9.73443 187.021C10.2941 187.356 12.3188 187.301 12.6536 186.741C12.9884 186.182 11.5065 185.329 10.9469 184.994Z",
    fill: "#65BAC6"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3411 186.766C10.3456 186.114 9.82071 185.581 9.16861 185.577C8.51641 185.572 7.98401 186.097 7.97951 186.749C7.97491 187.401 9.04921 189.119 9.70131 189.123C10.3534 189.128 10.3365 187.418 10.3411 186.766Z",
    fill: "#65BAC6"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06523 187.551C8.63853 187.241 8.85113 186.524 8.54023 185.95C8.22933 185.377 7.51253 185.165 6.93923 185.475C6.36603 185.786 5.38123 187.556 5.69213 188.13C6.00313 188.703 7.49203 187.862 8.06523 187.551Z",
    fill: "#65BAC6"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87392 186.29C8.13119 186.29 7.52909 185.688 7.52909 184.945C7.52909 184.202 8.13119 183.6 8.87392 183.6C9.61665 183.6 10.2188 184.202 10.2188 184.945C10.2188 185.688 9.61665 186.29 8.87392 186.29Z",
    fill: "#EEDDA0"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06993 192.078C5.84273 191.705 6.25993 191.036 6.69143 190.774C7.12283 190.511 7.88183 190.463 8.10903 190.836C7.51323 191.199 7.94553 191.861 7.51403 192.124C7.08263 192.387 6.29713 192.451 6.06993 192.078Z",
    fill: "#B4CB6F"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M326.864 191.636C327.05 191.331 326.708 190.784 326.355 190.568C326.002 190.353 325.381 190.314 325.195 190.62C325.683 190.916 325.329 191.459 325.682 191.674C326.035 191.889 326.678 191.941 326.864 191.636Z",
    fill: "#B4CB6F"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M326.779 191.584C326.956 191.294 326.632 190.775 326.296 190.571C325.961 190.367 325.372 190.33 325.195 190.62C325.658 190.901 325.322 191.416 325.658 191.62C325.993 191.824 326.603 191.874 326.779 191.584Z",
    fill: "#B4CB6F"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M327.402 201.247C325.217 194.67 324.024 189.99 326.09 184.847",
    stroke: "#B4CB6F",
    strokeWidth: 0.656017
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M329.892 197.299C329.261 200.493 329.704 203.659 327.97 203.316C326.235 202.974 325.702 200.266 325.971 196.913C327.358 179.595 325.527 200.846 327.262 201.188C328.996 201.531 331.523 190.308 329.892 197.299Z",
    fill: "#677932"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M324.361 197.427C325.15 200.585 324.866 203.769 326.581 203.34C328.296 202.912 328.693 200.181 328.258 196.846C326.008 179.618 328.897 200.751 327.182 201.18C325.467 201.608 322.382 190.525 324.361 197.427Z",
    fill: "#677932"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M324.056 182.813C324.056 183.465 324.584 183.994 325.237 183.994C325.889 183.994 326.417 183.465 326.417 182.813C326.417 182.161 325.331 180.452 324.679 180.452C324.027 180.452 324.056 182.161 324.056 182.813Z",
    fill: "#E97EB1"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M323.141 185.485C323.64 185.904 324.385 185.84 324.805 185.341C325.225 184.842 325.16 184.097 324.661 183.677C324.162 183.257 322.154 182.989 321.735 183.488C321.315 183.987 322.642 185.065 323.141 185.485Z",
    fill: "#E97EB1"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M326.492 182.784C326.052 183.264 326.085 184.011 326.565 184.452C327.046 184.892 327.793 184.86 328.234 184.379C328.674 183.898 329.028 181.904 328.547 181.463C328.066 181.023 326.933 182.303 326.492 182.784Z",
    fill: "#E97EB1"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M327.737 184.797C327.177 184.462 326.452 184.645 326.117 185.204C325.782 185.764 325.964 186.489 326.524 186.824C327.084 187.159 329.108 187.104 329.443 186.545C329.778 185.985 328.296 185.132 327.737 184.797Z",
    fill: "#E97EB1"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M327.131 186.569C327.136 185.917 326.611 185.385 325.959 185.38C325.306 185.375 324.774 185.9 324.77 186.553C324.765 187.205 325.839 188.922 326.491 188.926C327.143 188.931 327.127 187.221 327.131 186.569Z",
    fill: "#E97EB1"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M324.855 187.355C325.428 187.044 325.641 186.327 325.33 185.754C325.019 185.18 324.302 184.968 323.729 185.279C323.156 185.59 322.171 187.36 322.482 187.933C322.793 188.506 324.282 187.666 324.855 187.355Z",
    fill: "#E97EB1"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M325.663 186.094C324.92 186.094 324.318 185.492 324.318 184.749C324.318 184.006 324.92 183.404 325.663 183.404C326.406 183.404 327.008 184.006 327.008 184.749C327.008 185.492 326.406 186.094 325.663 186.094Z",
    fill: "#EEDDA0"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M323.228 191.584C323.051 191.294 323.375 190.775 323.71 190.571C324.045 190.367 324.635 190.33 324.811 190.62C324.349 190.901 324.684 191.416 324.349 191.62C324.014 191.824 323.404 191.874 323.228 191.584Z",
    fill: "#B4CB6F"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M322.772 191.861C322.545 191.489 322.962 190.82 323.394 190.557C323.825 190.294 324.584 190.247 324.811 190.619C324.216 190.982 324.648 191.645 324.216 191.908C323.785 192.17 322.999 192.234 322.772 191.861Z",
    fill: "#B4CB6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_57_182",
    x: 86.3576,
    y: 193.613,
    width: 45.7007,
    height: 86.0544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.984025,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_57_182",
    x: 120.102,
    y: 126.829,
    width: 9.62305,
    height: 6.70966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.260199
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1301
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_57_182",
    x: 124.789,
    y: 122.845,
    width: 7.02529,
    height: 7.09047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.301,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_57_182",
    x: 118.283,
    y: 122.78,
    width: 7.02529,
    height: 7.09047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.301,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_57_182",
    x: 144.833,
    y: 197.009,
    width: 43.335,
    height: 91.6855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.984025,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_57_182",
    x: 163.417,
    y: 122.091,
    width: 9.62305,
    height: 6.70991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.260199
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1301
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_57_182",
    x: 168.104,
    y: 118.107,
    width: 7.02529,
    height: 7.09047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.301,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_57_182",
    x: 161.598,
    y: 118.042,
    width: 7.02529,
    height: 7.09047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.301,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_57_182",
    x: 249.045,
    y: 195.442,
    width: 64.0631,
    height: 116.787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.984025,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_57_182",
    x: 202.051,
    y: 195.879,
    width: 40.2618,
    height: 99.1215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.984025,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_57_182",
    x: 30.7312,
    y: 195.714,
    width: 63.5201,
    height: 78.5903,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.984025,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_57_182",
    x: 63.3081,
    y: 123.706,
    width: 8.49121,
    height: 6.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.260199
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1301
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_57_182",
    x: 67.5274,
    y: 119.737,
    width: 7.02529,
    height: 7.09047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.301,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_57_182",
    x: 61.0225,
    y: 119.672,
    width: 7.02529,
    height: 7.09047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.301,
    result: "effect1_foregroundBlur_57_182"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.036 273.274) rotate(-88.7238) scale(0.414439 0.455349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE1EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.665 273.657) rotate(-88.724) scale(0.414444 0.455345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE1EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.249 118.899) rotate(90) scale(0.455353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE1EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.888 119.233) rotate(90) scale(0.455349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_57_182",
    x1: 302.414,
    y1: 269.664,
    x2: 280.89,
    y2: 265.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E5A3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A4E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_57_182",
    x1: 304.011,
    y1: 272.946,
    x2: 303.166,
    y2: 272.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_57_182",
    x1: 305.208,
    y1: 273.081,
    x2: 304.362,
    y2: 272.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_57_182",
    x1: 306.311,
    y1: 273.148,
    x2: 305.466,
    y2: 272.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_57_182",
    x1: 307.404,
    y1: 273.272,
    x2: 306.558,
    y2: 273.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_57_182",
    x1: 308.507,
    y1: 273.339,
    x2: 307.662,
    y2: 273.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_57_182",
    x1: 309.611,
    y1: 273.406,
    x2: 308.765,
    y2: 273.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_57_182",
    x1: 271.833,
    y1: 257.367,
    x2: 268.259,
    y2: 256.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A29F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_57_182",
    x1: 284.646,
    y1: 306.761,
    x2: 294.719,
    y2: 298.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64543B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62523B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_57_182",
    x1: 290.694,
    y1: 305.051,
    x2: 277.674,
    y2: 302.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66553B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_57_182",
    x1: 285.274,
    y1: 296.813,
    x2: 282.293,
    y2: 285.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63533B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#836B3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_57_182",
    x1: 284.542,
    y1: 294.018,
    x2: 284.063,
    y2: 292.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_57_182",
    x1: 283.303,
    y1: 289.194,
    x2: 282.519,
    y2: 286.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#B3A16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#80693D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#80693D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_57_182",
    x1: 283.385,
    y1: 298.786,
    x2: 282.333,
    y2: 294.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_57_182",
    x1: 287.932,
    y1: 297.561,
    x2: 286.881,
    y2: 293.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_57_182",
    x1: 254.638,
    y1: 83.736,
    x2: 269.019,
    y2: 91.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64543B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62523B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_57_182",
    x1: 262.927,
    y1: 83.818,
    x2: 248.377,
    y2: 91.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66553B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_57_182",
    x1: 258.853,
    y1: 93.8109,
    x2: 258.853,
    y2: 106.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63533B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#836B3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_57_182",
    x1: 258.88,
    y1: 96.895,
    x2: 258.88,
    y2: 98.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_57_182",
    x1: 258.957,
    y1: 102.209,
    x2: 258.957,
    y2: 105.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#B3A16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#80693D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#80693D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_57_182",
    x1: 255.769,
    y1: 92.303,
    x2: 255.769,
    y2: 96.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_57_182",
    x1: 261.982,
    y1: 92.303,
    x2: 261.982,
    y2: 96.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_57_182",
    x1: 290.003,
    y1: 117.025,
    x2: 266.419,
    y2: 131.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E5A3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A4E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_57_182",
    x1: 290.911,
    y1: 113.2,
    x2: 289.985,
    y2: 113.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_57_182",
    x1: 292.389,
    y1: 112.729,
    x2: 291.463,
    y2: 113.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_57_182",
    x1: 293.772,
    y1: 112.353,
    x2: 292.846,
    y2: 112.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_57_182",
    x1: 295.121,
    y1: 111.922,
    x2: 294.194,
    y2: 112.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_57_182",
    x1: 296.504,
    y1: 111.547,
    x2: 295.577,
    y2: 112.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_57_182",
    x1: 297.886,
    y1: 111.171,
    x2: 296.96,
    y2: 111.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_57_182",
    x1: 255.274,
    y1: 138.188,
    x2: 251.292,
    y2: 140.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A29F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_57_182",
    x1: 228.591,
    y1: 280.533,
    x2: 226.781,
    y2: 269.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_57_182",
    x1: 213.812,
    y1: 108.421,
    x2: 213.812,
    y2: 120.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.716 263.045) rotate(-79.955) scale(0.365982 0.455353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#63573A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA9D27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4985 263.52) rotate(-79.9549) scale(0.365976 0.45535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#63573A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA9D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_57_182",
    x1: 44.1021,
    y1: 246.494,
    x2: 46.2541,
    y2: 234.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_57_182",
    x1: 44.583,
    y1: 243.902,
    x2: 46.295,
    y2: 234.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_57_182",
    x1: 41.2374,
    y1: 238.597,
    x2: 58.1594,
    y2: 249.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.0195 121.145) rotate(90) scale(0.455349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#63573A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA9D27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_57_182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.8118 120.69) rotate(90) scale(0.455353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#63573A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA9D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_57_182",
    x1: 52.1369,
    y1: 138.663,
    x2: 52.1369,
    y2: 154.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_57_182",
    x1: 52.1591,
    y1: 141.943,
    x2: 52.1591,
    y2: 154.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_57_182",
    x1: 47.9382,
    y1: 147.716,
    x2: 67.3892,
    y2: 141.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 333,
    height: 300,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfib);
export default __webpack_public_path__ + "static/media/TFIB.c18505b8097c7abc26d61e8c7f97278a.svg";
export { ForwardRef as ReactComponent };